import { Injectable } from '@angular/core';
import { Endpoints } from '../../../models/endpoints';
import { HttpService } from './http.service';
import {TranslateService} from "@ngx-translate/core";
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

export enum AutoCompleteType {
	PAYS,
	GENRE,
	MOT_CLEF,
	CODENUTS,
	CPV,
	LANGEC,
	DEVISE,
	EDITION,
	CLASSIFICATIONVALUE,
	CLASSIFICATIONORGANISME,
	CLASSSUPPLEMENTAIRE,
	LIEUCODENUTS,
	RAPPEL,
	RUBRIQUE,
	SERVICES,
	CURRENCY,
	DURATIONUNIT,
	MEASUREMENTUNIT,
	TYPERENS,
	CIVILITE
}

@Injectable({
	providedIn: 'root',
  })
export class AutoCompleteService {

	private classsupplementaire = [
		{ code: 'AA01', libelle: 'Métal' },
		{ code: 'AA02', libelle: 'Aluminium' },
		{ code: 'AA03', libelle: 'Bronze' },
		{ code: 'AA04', libelle: 'Cuivre' },
		{ code: 'AA05', libelle: 'Fer' },
		{ code: 'AA06', libelle: 'Plomb' },
		{ code: 'AA07', libelle: 'Nickel' },
		{ code: 'AA08', libelle: 'Etain' },
		{ code: 'AA09', libelle: 'Zinc' },
		{ code: 'AA10', libelle: 'Alliage' },
		{ code: 'AA11', libelle: 'Acier' },
		{ code: 'AA12', libelle: 'Acier au carbone' },
		{ code: 'AA13', libelle: 'Vanadium.' },
		{ code: 'AA14', libelle: 'Chrome' },
		{ code: 'AA15', libelle: 'Manganèse' },
		{ code: 'AA16', libelle: 'Cobalt' },
		{ code: 'AA17', libelle: 'Yttrium' },
		{ code: 'AA18', libelle: 'Zirconium' },
		{ code: 'AA19', libelle: 'Molybdène' },
		{ code: 'AA20', libelle: 'Technétium' },
		{ code: 'AA21', libelle: 'Ruthenium' },
		{ code: 'AA22', libelle: 'Rhodium' },
		{ code: 'AA23', libelle: 'Cadmium' },
		{ code: 'AA24', libelle: 'Lutétium' },
		{ code: 'AA25', libelle: 'Hafnium' },
		{ code: 'AA26', libelle: 'Tantale' },
		{ code: 'AA27', libelle: 'Tungstène' },
		{ code: 'AA28', libelle: 'Iridium' },
		{ code: 'AA29', libelle: 'Gallium' },
		{ code: 'AA30', libelle: 'Indium' },
		{ code: 'AA31', libelle: 'Thallium' },
		{ code: 'AA32', libelle: 'Barium' },
		{ code: 'AA33', libelle: 'Caesium' },
		{ code: 'AA34', libelle: 'Strontium' },
		{ code: 'AA35', libelle: 'Rubidium' },
		{ code: 'AA36', libelle: 'Calcium' },
		{ code: 'AA37', libelle: 'Potassium' },
		{ code: 'AA38', libelle: 'Sodium' },
		{ code: 'AA39', libelle: 'Lithium' },
		{ code: 'AA40', libelle: 'Niobium' },
		{ code: 'AA41', libelle: 'Osmium' },
		{ code: 'AA42', libelle: 'Rhénium' },
		{ code: 'AA43', libelle: 'Palladium' },
		{ code: 'AA44', libelle: 'Laiton' },
		{ code: 'AA45', libelle: 'Or' },
		{ code: 'AA46', libelle: 'Argent' },
		{ code: 'AA47', libelle: 'Platine' },
		{ code: 'AA48', libelle: 'Magnésium' },
		{ code: 'AB02', libelle: 'Céramique ' },
		{ code: 'AB03', libelle: 'Porcelaine ou faïence' },
		{ code: 'AB04', libelle: 'Argile' },
		{ code: 'AB05', libelle: 'Béton' },
		{ code: 'AB06', libelle: 'Plastique' },
		{ code: 'AB07', libelle: 'Polyester' },
		{ code: 'AB08', libelle: 'Polyéthène (polyéthylène)' },
		{ code: 'AB09', libelle: 'Polystyrène' },
		{ code: 'AB11', libelle: 'PVC' },
		{ code: 'AB12', libelle: 'Caoutchouc' },
		{ code: 'AB13', libelle: 'Bois' },
		{ code: 'AB14', libelle: 'Bois de conifère' },
		{ code: 'AB15', libelle: 'Bois tropical ' },
		{ code: 'AB16', libelle: 'Bambou' },
		{ code: 'AB17', libelle: 'Liège' },
		{ code: 'AB18', libelle: 'Papier' },
		{ code: 'AB19', libelle: 'Cuir' },
		{ code: 'AB20', libelle: 'Fibre de verre' },
		{ code: 'AB21', libelle: 'Verre' },
		{ code: 'AB22', libelle: 'Parties intérieures en verre' },
		{ code: 'AB23', libelle: 'Pièces en verre ' },
		{ code: 'AB24', libelle: 'Textile' },
		{ code: 'AB25', libelle: 'Synthétique' },
		{ code: 'AB26', libelle: 'Bois de construction' },
		{ code: 'AB27', libelle: 'Pierre' },
		{ code: 'AB28', libelle: 'Marbre' },
		{ code: 'AB29', libelle: 'Pierres précieuses' },
		{ code: 'AB30', libelle: 'Laine' },
		{ code: 'AB31', libelle: 'Soie' },
		{ code: 'AB32', libelle: 'Toile' },
		{ code: 'AB33', libelle: 'Coton' },
		{ code: 'AB34', libelle: 'Terrazzo' },
		{ code: 'AB35', libelle: 'Granit' },
		{ code: 'AB36', libelle: 'Ardoise' },
		{ code: 'BA01', libelle: 'Vivant ' },
		{ code: 'BA02', libelle: 'Naturel' },
		{ code: 'BA03', libelle: 'Artificiel ' },
		{ code: 'BA04', libelle: 'Frais' },
		{ code: 'BA05', libelle: 'Froid' },
		{ code: 'BA06', libelle: 'Chaud' },
		{ code: 'BA07', libelle: 'Liquide' },
		{ code: 'BA08', libelle: 'Solide' },
		{ code: 'BA09', libelle: 'Gazeux' },
		{ code: 'BA10', libelle: 'Brut' },
		{ code: 'BA11', libelle: 'Sec' },
		{ code: 'BA12', libelle: 'Rigide' },
		{ code: 'BA13', libelle: 'Souple' },
		{ code: 'BA14', libelle: 'Poussière/poudre' },
		{ code: 'BA15', libelle: 'Résidus' },
		{ code: 'BA16', libelle: 'Flocons' },
		{ code: 'BA17', libelle: 'Barres' },
		{ code: 'BA18', libelle: 'Cendres' },
		{ code: 'BA19', libelle: 'Granulés' },
		{ code: 'BA20', libelle: 'Lingots' },
		{ code: 'BA22', libelle: 'Tiges' },
		{ code: 'BA23', libelle: 'A l\'état brut' },
		{ code: 'BA24', libelle: 'Gelé' },
		{ code: 'BA25', libelle: 'Surgelé' },
		{ code: 'BA26', libelle: 'Plié' },
		{ code: 'BA27', libelle: 'Forgé' },
		{ code: 'BA28', libelle: 'Lyophilisé' },
		{ code: 'BA29', libelle: 'Laminé plat' },
		{ code: 'BA30', libelle: 'Séché' },
		{ code: 'BA31', libelle: 'Râpé' },
		{ code: 'BA32', libelle: 'Concentré' },
		{ code: 'BA33', libelle: 'Réfrigéré' },
		{ code: 'BA34', libelle: 'Enrobé' },
		{ code: 'BA35', libelle: 'Galvanisé' },
		{ code: 'BA36', libelle: 'Granulé' },
		{ code: 'BA37', libelle: 'Laminé à chaud' },
		{ code: 'BA38', libelle: 'Vitrifié' },
		{ code: 'BA39', libelle: 'Laminé' },
		{ code: 'BA40', libelle: 'Liquéfié' },
		{ code: 'BA41', libelle: 'Vulcanisé' },
		{ code: 'BA42', libelle: 'Soudé' },
		{ code: 'BA43', libelle: 'Préparé' },
		{ code: 'BA44', libelle: 'Pulverisé' },
		{ code: 'BA45', libelle: 'Raffiné' },
		{ code: 'BA46', libelle: 'Refondu' },
		{ code: 'BA47', libelle: 'Non traité' },
		{ code: 'BA48', libelle: 'Traité' },
		{ code: 'BA49', libelle: 'Non liquéfié' },
		{ code: 'BA50', libelle: 'Non raffiné' },
		{ code: 'BA51', libelle: 'Semi-fini' },
		{ code: 'BA52', libelle: 'Transformé' },
		{ code: 'BA53', libelle: 'Semi-ouvré' },
		{ code: 'BA54', libelle: 'Solution' },
		{ code: 'BB01', libelle: 'Non-tubulaire' },
		{ code: 'BB02', libelle: 'Tubulaire' },
		{ code: 'BB03', libelle: 'Rond' },
		{ code: 'BB04', libelle: 'Rectangulaire' },
		{ code: 'BB05', libelle: 'Carré' },
		{ code: 'BB06', libelle: 'Triangulaire' },
		{ code: 'BB07', libelle: 'Trapézoïdal' },
		{ code: 'BC01', libelle: 'Avec cadres en métal       ' },
		{ code: 'BC02', libelle: 'Avec cadres en plastique   ' },
		{ code: 'BC03', libelle: 'Avec cadres en bois        ' },
		{ code: 'BC04', libelle: 'Plaqué or' },
		{ code: 'BC05', libelle: 'Plaqué platine' },
		{ code: 'BC06', libelle: 'Plaqué argent' },
		{ code: 'BC07', libelle: 'Avec cadres en acier' },
		{ code: 'BC08', libelle: 'Plaqué' },
		{ code: 'BC09', libelle: 'Non moulé  ' },
		{ code: 'BC10', libelle: 'Rembourré' },
		{ code: 'BC11', libelle: 'Imprimé' },
		{ code: 'BC12', libelle: 'Coloré' },
		{ code: 'BC13', libelle: 'Imprégné ' },
		{ code: 'BC14', libelle: 'Préfabriqué ' },
		{ code: 'BC15', libelle: 'Recouvert de plastique' },
		{ code: 'BC16', libelle: 'En sachets' },
		{ code: 'BC17', libelle: 'En blocs' },
		{ code: 'BC18', libelle: 'En plaques' },
		{ code: 'BC19', libelle: 'En saumure' },
		{ code: 'BC20', libelle: 'En vrac' },
		{ code: 'BC21', libelle: 'En cartons' },
		{ code: 'BC22', libelle: 'En cartouches' },
		{ code: 'BC23', libelle: 'En morceaux' },
		{ code: 'BC24', libelle: 'En découpe' },
		{ code: 'BC25', libelle: 'En lots' },
		{ code: 'BC26', libelle: 'Dans l\'huile' },
		{ code: 'BC27', libelle: 'En paquets' },
		{ code: 'BC28', libelle: 'En étuis' },
		{ code: 'BC29', libelle: 'En rames' },
		{ code: 'BC30', libelle: 'En tiges' },
		{ code: 'BC31', libelle: 'En rouleaux' },
		{ code: 'BC32', libelle: 'En pochettes' },
		{ code: 'BC33', libelle: 'En sacs' },
		{ code: 'BC34', libelle: 'En feuilles' },
		{ code: 'BC35', libelle: 'En tranches' },
		{ code: 'BC36', libelle: 'En solution' },
		{ code: 'BC37', libelle: 'En bandes' },
		{ code: 'BC38', libelle: 'A l\'eau ' },
		{ code: 'BC39', libelle: 'Aromatisé' },
		{ code: 'BC40', libelle: 'Verre moulé' },
		{ code: 'BC41', libelle: 'En conserve' },
		{ code: 'BC42', libelle: 'En bouteille' },
		{ code: 'BC43', libelle: 'Emballé sous vide' },
		{ code: 'BC44', libelle: 'Partiellement cuit ' },
		{ code: 'BC45', libelle: 'Recyclé' },
		{ code: 'BC46', libelle: 'Stérilisé' },
		{ code: 'BC48', libelle: 'Trempé' },
		{ code: 'CA01', libelle: 'Imperméable' },
		{ code: 'CA02', libelle: 'Coupe-vent' },
		{ code: 'CA03', libelle: 'Pare-balles' },
		{ code: 'CA04', libelle: 'Ininflammable' },
		{ code: 'CA05', libelle: 'Inoxydable' },
		{ code: 'CA06', libelle: 'Extensible' },
		{ code: 'CA07', libelle: 'Isolé' },
		{ code: 'CA08', libelle: 'Non-isolé' },
		{ code: 'CA09', libelle: 'Réfractaire' },
		{ code: 'CA10', libelle: 'Non-réfractaire' },
		{ code: 'CA11', libelle: 'Renforcé' },
		{ code: 'CA12', libelle: 'Armé' },
		{ code: 'CA13', libelle: 'Oléo-absorbant' },
		{ code: 'CA14', libelle: 'Auto-adhésif' },
		{ code: 'CA15', libelle: 'Ductile' },
		{ code: 'CA16', libelle: 'Magnétique' },
		{ code: 'CA17', libelle: 'Ecologique' },
		{ code: 'CA18', libelle: 'Sans OGM ' },
		{ code: 'CA19', libelle: 'Sans hormones ' },
		{ code: 'CA20', libelle: 'Sans pesticides' },
		{ code: 'CA21', libelle: 'Sans amiante' },
		{ code: 'CA22', libelle: 'Sans CFC' },
		{ code: 'CA23', libelle: 'Sans ozone ' },
		{ code: 'CA24', libelle: 'Sans PVC' },
		{ code: 'CA25', libelle: 'Hybride ' },
		{ code: 'CA26', libelle: 'Sans hydrocarbure ' },
		{ code: 'CA27', libelle: 'Sans NOx ' },
		{ code: 'CA28', libelle: 'Sans CO' },
		{ code: 'CA29', libelle: 'Sans CO2' },
		{ code: 'CA30', libelle: 'Sans soufre' },
		{ code: 'CA31', libelle: 'Euro 0 (carburant)' },
		{ code: 'CA32', libelle: 'Euro 1 (carburant)' },
		{ code: 'CA33', libelle: 'Euro 2 (carburant)' },
		{ code: 'CA34', libelle: 'Euro 3 (carburant)' },
		{ code: 'CA35', libelle: 'Euro 4 (carburant)' },
		{ code: 'CA36', libelle: 'Euro 5 (carburantl)' },
		{ code: 'CA37', libelle: 'Articulé' },
		{ code: 'CA38', libelle: 'A longue conservation' },
		{ code: 'CA39', libelle: 'Léger' },
		{ code: 'CA40', libelle: 'De haute mer' },
		{ code: 'CA41', libelle: 'Semi-submersible' },
		{ code: 'CA42', libelle: 'Submersible' },
		{ code: 'CA43', libelle: 'Numérique' },
		{ code: 'CA44', libelle: 'Portable' },
		{ code: 'CA45', libelle: 'A haute résolution' },
		{ code: 'CA46', libelle: 'A haute performance' },
		{ code: 'CA47', libelle: 'Multitâches' },
		{ code: 'CA48', libelle: 'A utilisateurs multiples' },
		{ code: 'CA49', libelle: 'Actualisable' },
		{ code: 'CA50', libelle: 'Jetable' },
		{ code: 'CA51', libelle: 'Rechargeable' },
		{ code: 'CA52', libelle: 'Ignifuge' },
		{ code: 'CA53', libelle: 'Coupe-feu' },
		{ code: 'CA54', libelle: 'Résistant à la chaleur' },
		{ code: 'CA55', libelle: 'Stérile' },
		{ code: 'CA56', libelle: 'Non-stérile ' },
		{ code: 'CA57', libelle: 'Ecolabel' },
		{ code: 'CA58', libelle: 'Sans colorants ' },
		{ code: 'CA59', libelle: 'Sans conservateurs' },
		{ code: 'CA60', libelle: 'Tridimensionnel ' },
		{ code: 'CA61', libelle: 'Amovible' },
		{ code: 'CA62', libelle: 'Biologique ' },
		{ code: 'CA63', libelle: 'Cultivé' },
		{ code: 'CA64', libelle: 'Sauvage' },
		{ code: 'CA65', libelle: 'D\'élevage' },
		{ code: 'CA66', libelle: 'A usage unique ' },
		{ code: 'CA67', libelle: 'Réutilisable' },
		{ code: 'CA68', libelle: 'Blindé' },
		{ code: 'CA69', libelle: 'Ergonomique' },
		{ code: 'CB01', libelle: 'A chauffage électrique' },
		{ code: 'CB02', libelle: 'Télécommandé' },
		{ code: 'CB03', libelle: 'Haute pression' },
		{ code: 'CB04', libelle: 'Haute tension' },
		{ code: 'CB05', libelle: 'Basse pression' },
		{ code: 'CB06', libelle: 'Basse tension' },
		{ code: 'CB07', libelle: 'Moyenne pression' },
		{ code: 'CB08', libelle: '4 roues motrices' },
		{ code: 'CB09', libelle: 'Alimenté au diesel' },
		{ code: 'CB10', libelle: 'A énergie électrique' },
		{ code: 'CB11', libelle: 'A énergie hydroélectrique' },
		{ code: 'CB12', libelle: 'A énergie nucléaire' },
		{ code: 'CB13', libelle: 'A énergie solaire' },
		{ code: 'CB14', libelle: 'A moteur à essence' },
		{ code: 'CB15', libelle: 'Mécanique' },
		{ code: 'CB16', libelle: 'Mécanique et électrique' },
		{ code: 'CB17', libelle: 'A commande autonome' },
		{ code: 'CB18', libelle: 'Automatique' },
		{ code: 'CB19', libelle: 'Informatisé' },
		{ code: 'CB20', libelle: 'Assisté par ordinateur' },
		{ code: 'CB21', libelle: 'Basé sur l\'informatique' },
		{ code: 'CB22', libelle: 'Commandé par ordinateur' },
		{ code: 'CB23', libelle: 'Multitraitement' },
		{ code: 'CB24', libelle: 'Synchrone' },
		{ code: 'CB25', libelle: 'Asynchrone' },
		{ code: 'CB26', libelle: 'Portatif' },
		{ code: 'CB27', libelle: 'Intégré' },
		{ code: 'CB28', libelle: 'Alimenté aux combustibles fossiles' },
		{ code: 'CB29', libelle: 'Alimenté au  charbon' },
		{ code: 'CB30', libelle: 'Alimenté au gaz' },
		{ code: 'CB31', libelle: 'Alimenté au  pétrole' },
		{ code: 'CB32', libelle: 'Alimenté au bois' },
		{ code: 'CB33', libelle: 'Monophasé ' },
		{ code: 'CB34', libelle: 'Biphasé ' },
		{ code: 'CB35', libelle: 'Triphasé ' },
		{ code: 'CB36', libelle: 'Instantané' },
		{ code: 'CB37', libelle: 'A phase unique' },
		{ code: 'CB38', libelle: 'Autonome' },
		{ code: 'CB39', libelle: 'Non interruptible' },
		{ code: 'CB40', libelle: 'Interruptible ' },
		{ code: 'CB41', libelle: 'A propulsion hybride' },
		{ code: 'CB42', libelle: 'Fonctionnant à pile' },
		{ code: 'CB43', libelle: 'Fonctionnant au bio-diesel' },
		{ code: 'CB44', libelle: 'Fonctionnant à l\'hydrogène' },
		{ code: 'CB45', libelle: 'Fonctionnant à l\'éthanol' },
		{ code: 'CB46', libelle: 'Fonctionnant au kérosène' },
		{ code: 'CB-4', libelle: 'Fonctionnant au gaz' },
		{ code: 'DA01', libelle: 'International' },
		{ code: 'DA02', libelle: 'National' },
		{ code: 'DA03', libelle: 'Public' },
		{ code: 'DA04', libelle: 'Privé' },
		{ code: 'DA05', libelle: 'D\'occasion' },
		{ code: 'DA06', libelle: 'Primaire' },
		{ code: 'DA07', libelle: 'Secondaire' },
		{ code: 'DA08', libelle: 'Tertiaire' },
		{ code: 'DA09', libelle: 'En temps réel' },
		{ code: 'DA10', libelle: 'Phase (étape)' },
		{ code: 'DA11', libelle: 'De secrétariat' },
		{ code: 'DA12', libelle: 'A l\'intérieur' },
		{ code: 'DA13', libelle: 'A l\'extérieur' },
		{ code: 'DA14', libelle: 'Mobile' },
		{ code: 'DA15', libelle: 'Domestique' },
		{ code: 'DA16', libelle: 'Non-domestique' },
		{ code: 'DA17', libelle: 'Projet clés en main' },
		{ code: 'DA18', libelle: 'Souterrain' },
		{ code: 'DA19', libelle: 'Subaquatique' },
		{ code: 'DA20', libelle: 'Sur site' },
		{ code: 'DA21', libelle: 'A la surface' },
		{ code: 'DA22', libelle: 'A usage multiple' },
		{ code: 'DA23', libelle: 'A usage spécifique' },
		{ code: 'DA24', libelle: 'Et articles connexes' },
		{ code: 'DA25', libelle: 'Standard' },
		{ code: 'DA26', libelle: 'Gestion ' },
		{ code: 'DA27', libelle: 'Administratif' },
		{ code: 'DA28', libelle: 'Service social ' },
		{ code: 'DA29', libelle: 'Travail social' },
		{ code: 'DA30', libelle: 'Conseil' },
		{ code: 'DA31', libelle: 'Soins de jour' },
		{ code: 'DA32', libelle: 'Planning familial' },
		{ code: 'DA33', libelle: 'Réhabilitation' },
		{ code: 'DA34', libelle: 'Orientation' },
		{ code: 'DA35', libelle: 'Du lieu de travail' },
		{ code: 'DA36', libelle: 'Ressources naturelles ' },
		{ code: 'DA37', libelle: 'Recyclage' },
		{ code: 'DA38', libelle: 'Décontamination' },
		{ code: 'DA39', libelle: 'Localisation de la pollution ' },
		{ code: 'DA40', libelle: 'Contrôle de qualité' },
		{ code: 'DA41', libelle: 'Traitement' },
		{ code: 'DA42', libelle: 'Installation comprise' },
		{ code: 'DA43', libelle: 'Polyvalent' },
		{ code: 'DA44', libelle: 'Pièces détachées' },
		{ code: 'EA01', libelle: 'Pour bébés' },
		{ code: 'EA02', libelle: 'Pour enfants' },
		{ code: 'EA03', libelle: 'Pour adolescents' },
		{ code: 'EA04', libelle: 'Pour  hommes' },
		{ code: 'EA05', libelle: 'Pour personnes âgées' },
		{ code: 'EA06', libelle: 'Pour femmes' },
		{ code: 'EA07', libelle: 'Pour femmes enceintes' },
		{ code: 'EA08', libelle: 'Pour chômeurs' },
		{ code: 'EA09', libelle: 'Pour sans-abri' },
		{ code: 'EA10', libelle: 'Pour toxicomanes' },
		{ code: 'EA11', libelle: 'Pour retraités' },
		{ code: 'EA12', libelle: 'Pour/Adapté pour handicapés' },
		{ code: 'EA13', libelle: 'Pour/Adapté pour invalides' },
		{ code: 'EA14', libelle: 'Pour/Adapté pour paralysés' },
		{ code: 'EA15', libelle: 'Pour/Adapté pour hémiplégiques' },
		{ code: 'EA16', libelle: 'Pour/Adapté pour tétraplégiques' },
		{ code: 'EA17', libelle: 'Pour/Adapté pour paraplégiques' },
		{ code: 'EA18', libelle: 'Pour/Adapté pour muets' },
		{ code: 'EA19', libelle: 'Pour/Adapté pour malentendants' },
		{ code: 'EA20', libelle: 'Pour/Adapté pour sourds-muets' },
		{ code: 'EA21', libelle: 'Pour/Adapté pour déficients visuels' },
		{ code: 'EA22', libelle: 'Pour/Adapté pour déficients mentaux' },
		{ code: 'EA23', libelle: 'Pour passagers' },
		{ code: 'EA24', libelle: 'Pour clientèle restreinte' },
		{ code: 'EA25', libelle: 'Pour prisonniers' },
		{ code: 'EA26', libelle: 'Pour patients' },
		{ code: 'EA27', libelle: 'Pour patients ne relevant pas des urgences' },
		{ code: 'EA28', libelle: 'Pour passagers ordinaires' },
		{ code: 'EA29', libelle: 'A usage humain' },
		{ code: 'EA30', libelle: 'A usage animal' },
		{ code: 'FA01', libelle: 'A usage éducatif' },
		{ code: 'FA02', libelle: 'Pour jardins d\'enfants' },
		{ code: 'FA03', libelle: 'A usage scolaire' },
		{ code: 'FA04', libelle: 'Pour la formation' },
		{ code: 'FB01', libelle: 'A usage militaire' },
		{ code: 'FB02', libelle: 'Pour armes et munitions' },
		{ code: 'FB03', libelle: 'Pour la police' },
		{ code: 'FB04', libelle: 'Pour la lutte contre l\'incendie' },
		{ code: 'FB05', libelle: 'Pour prison' },
		{ code: 'FB06', libelle: 'Pour sauvetage' },
		{ code: 'FB07', libelle: 'Pour les urgences' },
		{ code: 'FB08', libelle: 'Pour la protection contre le feu' },
		{ code: 'FB09', libelle: 'Pour systèmes de sécurité' },
		{ code: 'FB10', libelle: 'Pour la protection nucléaire' },
		{ code: 'FB11', libelle: 'En cas d\'irradiations' },
		{ code: 'FB12', libelle: 'Pour la prévention du terrorisme' },
		{ code: 'FB13', libelle: 'A spécifications militaires' },
		{ code: 'FC01', libelle: 'Pour l\'élimination des déchets' },
		{ code: 'FC02', libelle: 'Pour déchets' },
		{ code: 'FC03', libelle: 'Pour ordures ménagères' },
		{ code: 'FD01', libelle: 'Pour le printemps' },
		{ code: 'FD02', libelle: 'Pour l\'été' },
		{ code: 'FD03', libelle: 'Pour l\'automne' },
		{ code: 'FD04', libelle: 'Pour l\'hiver' },
		{ code: 'FD05', libelle: 'Pour toutes les saisons' },
		{ code: 'FE01', libelle: 'Pour conditionnement des marchandises' },
		{ code: 'FE02', libelle: 'Pour colis' },
		{ code: 'FE03', libelle: 'Pour usage dans bureaux de poste' },
		{ code: 'FF01', libelle: 'Pour nettoyage' },
		{ code: 'FF02', libelle: 'Pour centres d\'accueil de jour ' },
		{ code: 'FG01', libelle: 'Pour accès' },
		{ code: 'FG02', libelle: 'Pour exposition' },
		{ code: 'FG03', libelle: 'A usage graphique' },
		{ code: 'FG04', libelle: 'Pour chauffage' },
		{ code: 'FG05', libelle: 'A usage industriel' },
		{ code: 'FG06', libelle: 'Pour impression' },
		{ code: 'FG07', libelle: 'A usage naval ' },
		{ code: 'FG08', libelle: 'Pour bureau' },
		{ code: 'FG09', libelle: 'Pour intérieur ' },
		{ code: 'FG10', libelle: 'Pour extérieur ' },
		{ code: 'FG11', libelle: 'A usage scientifique' },
		{ code: 'FG12', libelle: 'Pour stockage' },
		{ code: 'FG13', libelle: 'Pour survie' },
		{ code: 'FG14', libelle: 'A usage technique' },
		{ code: 'FG15', libelle: 'Pour tests' },
		{ code: 'FG16', libelle: 'A usage urbain' },
		{ code: 'FG17', libelle: 'A usage agricole' },
		{ code: 'FG18', libelle: 'A usage horticole' },
		{ code: 'FG19', libelle: 'Pour  camping' },
		{ code: 'FG20', libelle: 'Pour  cuisine' },
		{ code: 'FG21', libelle: 'A usage sous-marin' },
		{ code: 'FG22', libelle: 'Pour cosmétiques' },
		{ code: 'FG23', libelle: 'Pour  tourisme' },
		{ code: 'FG24', libelle: 'Pour specacles artistiques ' },
		{ code: 'FG25', libelle: 'Pour immeubles ou biens présentant un intérêt historique ou architectural particulier' },
		{ code: 'GA01', libelle: 'Poids spécifique exigé' },
		{ code: 'GA02', libelle: 'Poids spécifique total en charge' },
		{ code: 'GA03', libelle: 'Tonnes annuelles exigées' },
		{ code: 'GA04', libelle: 'Kilogrammes annuels exigés' },
		{ code: 'GA05', libelle: 'Hauteur spécifique exigée' },
		{ code: 'GA06', libelle: 'Largeur spécifique exigée' },
		{ code: 'GA07', libelle: 'Epaisseur spécifique exigée' },
		{ code: 'GA08', libelle: 'Longueur spécifique exigée' },
		{ code: 'GA09', libelle: 'Diamètre spécifique exigé' },
		{ code: 'GA10', libelle: 'Volume spécifique exigé' },
		{ code: 'GA11', libelle: 'Litres annuels exigés  ' },
		{ code: 'GA12', libelle: 'Taille spécifique exigée' },
		{ code: 'GA13', libelle: 'Taille unitaire spécifique exigée' },
		{ code: 'GA14', libelle: 'Capacité spécifique exigée' },
		{ code: 'GA15', libelle: 'Circonférence spécifique exigée' },
		{ code: 'GA16', libelle: 'Profondeur spécifique exigée' },
		{ code: 'GA17', libelle: 'KWh annuels exigés' },
		{ code: 'GA18', libelle: 'MWh annuels exigés' },
		{ code: 'GA19', libelle: 'Par an  (p.a.)' },
		{ code: 'GA20', libelle: 'Puissance spécifique' },
		{ code: 'GA21', libelle: 'Pression spécifique' },
		{ code: 'GA22', libelle: 'Tension spécifique exigée' },
		{ code: 'GA32', libelle: 'Degrés Celsius spécifiques exigés' },
		{ code: 'GA33', libelle: 'Degrés Fahrenheit spécifiques exigés' },
		{ code: 'GB01', libelle: 'Quotidien ' },
		{ code: 'GB02', libelle: 'Hebdomadaire' },
		{ code: 'GB03', libelle: 'Mensuel' },
		{ code: 'GB04', libelle: 'Annuel' },
		{ code: 'GC01', libelle: 'Ne dépassant pas' },
		{ code: 'GC02', libelle: 'Dépassant ' },
		{ code: 'GC03', libelle: 'Un maximum de :' },
		{ code: 'GC04', libelle: 'Un minimum de :' },
		{ code: 'GC05', libelle: 'Phase :' },
		{ code: 'GC06', libelle: 'Rendement :' },
		{ code: 'GC07', libelle: 'Référence:' },
		{ code: 'GC08', libelle: 'Délai de réaction' },
		{ code: 'GC09', libelle: 'Pièces:' },
		{ code: 'GC10', libelle: 'Etendue des travaux :' },
		{ code: 'GC11', libelle: 'Spécifications:' },
		{ code: 'GC12', libelle: 'Lot secondaire:' },
		{ code: 'GC13', libelle: 'Type:' },
		{ code: 'GC14', libelle: 'Type d\'architecture:' },
		{ code: 'GC15', libelle: 'Type de protocole:' },
		{ code: 'GC16', libelle: 'Type de norme:' },
		{ code: 'GC17', libelle: 'Habitations:' },
		{ code: 'GC18', libelle: 'Lots:' },
		{ code: 'GC19', libelle: 'Lot N°' },
		{ code: 'GC20', libelle: 'Lot principal:' },
		{ code: 'GC21', libelle: 'Surface:' },
		{ code: 'GC22', libelle: 'Mis en service ' },
		{ code: 'GC23', libelle: 'Allongement' },
		{ code: 'GC24', libelle: 'Total' },
		{ code: 'GC25', libelle: 'Nombre:' },
		{ code: 'GC26', libelle: 'Nombre de voies:' },
		{ code: 'GC27', libelle: 'Nombre d\'articles:' },
		{ code: 'GC28', libelle: 'Nombre de phases:' },
		{ code: 'GC29', libelle: 'Nombre de sièges:' },
		{ code: 'GC30', libelle: 'Nombre de lots :    ' },
		{ code: 'GC31', libelle: 'Nombre d\'unités:' },
		{ code: 'GC32', libelle: 'Nombre d\'utilisateurs:' },
		{ code: 'GC33', libelle: 'Nombre de feuilles:' },
		{ code: 'GC34', libelle: 'Nombre de copies:' },
		{ code: 'HA01', libelle: 'Cuit et réfrigéré' },
		{ code: 'HA02', libelle: 'Cuit et surgelé' },
		{ code: 'HA03', libelle: 'Kascher' },
		{ code: 'HA04', libelle: 'Sans porc' },
		{ code: 'HA05', libelle: 'Sans alcool' },
		{ code: 'HA06', libelle: 'Plat pour diabétique' },
		{ code: 'HA07', libelle: 'Plat sans gluten' },
		{ code: 'HA08', libelle: 'Plat riche en fibres' },
		{ code: 'HA09', libelle: 'Plat basses calories' },
		{ code: 'HA10', libelle: 'Plat pauvre en cholestérol/matières grasses' },
		{ code: 'HA11', libelle: 'Plat pauvre en protéines' },
		{ code: 'HA12', libelle: 'Plat pauvre en purine' },
		{ code: 'HA13', libelle: 'Plat pauvre en sodium' },
		{ code: 'HA14', libelle: 'Plat sans lactose' },
		{ code: 'HA15', libelle: 'Plat pour personnes allergiques aux arachides' },
		{ code: 'HA16', libelle: 'Plat végétarien' },
		{ code: 'HA17', libelle: 'Plat lacto-ovo-végétarien ' },
		{ code: 'HA18', libelle: 'Plat religieux' },
		{ code: 'HA19', libelle: 'Hallal' },
		{ code: 'HA20', libelle: 'Carcasses' },
		{ code: 'HA21', libelle: 'Partiellement frit    ' },
		{ code: 'HA22', libelle: 'Au sirop' },
		{ code: 'HA23', libelle: 'A la sauce tomate' },
		{ code: 'HA24', libelle: 'Au jus naturel' },
		{ code: 'HA25', libelle: 'Non salé' },
		{ code: 'HA26', libelle: 'Salé' },
		{ code: 'HA27', libelle: 'Cuit' },
		{ code: 'HA28', libelle: 'Cuit au four' },
		{ code: 'HA29', libelle: 'Frit' },
		{ code: 'HA30', libelle: 'A la vapeur' },
		{ code: 'HA31', libelle: 'Préparation liquide' },
		{ code: 'IA01', libelle: 'Conception et construction' },
		{ code: 'IA02', libelle: 'Conception et  pose' },
		{ code: 'IA03', libelle: 'Extension' },
		{ code: 'IA04', libelle: 'Extérieur' },
		{ code: 'IA05', libelle: 'Travaux de finition' },
		{ code: 'IA06', libelle: 'Equipé' },
		{ code: 'IA07', libelle: 'Accessoire pour' },
		{ code: 'IA08', libelle: 'Sols' },
		{ code: 'IA09', libelle: 'Intérieur' },
		{ code: 'IA10', libelle: 'Modernisation' },
		{ code: 'IA11', libelle: 'Modification' },
		{ code: 'IA13', libelle: 'Reconstruction' },
		{ code: 'IA14', libelle: 'Rénovation et extension' },
		{ code: 'IA15', libelle: 'Remplacement' },
		{ code: 'IA16', libelle: 'A plusieurs étages' },
		{ code: 'IA17', libelle: 'Onshore' },
		{ code: 'IA18', libelle: 'Resurfaçage' },
		{ code: 'IA19', libelle: 'Transformation' },
		{ code: 'IA20', libelle: 'Ressaut          ' },
		{ code: 'IA21', libelle: 'Offshore' },
		{ code: 'IA22', libelle: 'Révision' },
		{ code: 'IA23', libelle: 'Révision et réparation' },
		{ code: 'IA24', libelle: 'Remise en état' },
		{ code: 'IA25', libelle: 'Remise à neuf' },
		{ code: 'IA26', libelle: 'Enlèvement                  ' },
		{ code: 'IA27', libelle: 'Réhabilitation (travaux de construction)' },
		{ code: 'IA28', libelle: 'Renforcement' },
		{ code: 'IA29', libelle: 'Creux' },
		{ code: 'IA30', libelle: 'Eclairé' },
		{ code: 'IA31', libelle: 'Améliorations' },
		{ code: 'IA32', libelle: 'Terrain accidenté' },
		{ code: 'IA33', libelle: 'Ferrailles              ' },
		{ code: 'IA34', libelle: 'Elargissement' },
		{ code: 'IA35', libelle: 'Cloisonnement' },
		{ code: 'IA36', libelle: 'Pour bâtiments' },
		{ code: 'IA37', libelle: 'Pour isolation' },
		{ code: 'IA38', libelle: 'Pour installations mécaniques' },
		{ code: 'IA39', libelle: 'Pour autoroutes' },
		{ code: 'IA40', libelle: 'Rénovation' },
		{ code: 'IA41', libelle: 'Restauration' },
		{ code: 'IA42', libelle: 'Murs' },
		{ code: 'JA01', libelle: 'Pour matériel informatique' },
		{ code: 'JA02', libelle: 'Pour logiciels' },
		{ code: 'JA03', libelle: 'Pour utilisation en réseau' },
		{ code: 'JA04', libelle: 'Pour conception' },
		{ code: 'JA05', libelle: 'De bureau' },
		{ code: 'JA06', libelle: 'Pour le développement' },
		{ code: 'JA07', libelle: 'En ligne' },
		{ code: 'JA08', libelle: 'Mise à jour' },
		{ code: 'JA09', libelle: 'Multimédia' },
		{ code: 'JA10', libelle: 'Pour Internet' },
		{ code: 'JA11', libelle: 'Pour intranet' },
		{ code: 'JA12', libelle: 'Pour réseaux' },
		{ code: 'JA13', libelle: 'Pour réseau local' },
		{ code: 'JA14', libelle: 'Pour réseau étendu' },
		{ code: 'JA15', libelle: 'Avec licence' },
		{ code: 'JA16', libelle: 'Sans licence' },
		{ code: 'JA17', libelle: 'Pour données' },
		{ code: 'JA18', libelle: 'Pour audit' },
		{ code: 'JA19', libelle: 'Pour serveur' },
		{ code: 'JA20', libelle: 'Pour sauvegarde ' },
		{ code: 'JA21', libelle: 'Pour développement' },
		{ code: 'JA22', libelle: 'Pour programmation' },
		{ code: 'JA23', libelle: 'Pour mise à jour' },
		{ code: 'JA24', libelle: 'A large bande' },
		{ code: 'KA01', libelle: 'Pour chauffage urbain' },
		{ code: 'KA02', libelle: 'Pour drainage' },
		{ code: 'KA03', libelle: 'Pour matériel électrique' },
		{ code: 'KA04', libelle: 'Pour installations électriques' },
		{ code: 'KA05', libelle: 'Pour le traitement des eaux usées' },
		{ code: 'KA06', libelle: 'Pour l\'industrie gazière' },
		{ code: 'KA07', libelle: 'Pour l\'industrie pétrolière' },
		{ code: 'KA08', libelle: 'Pour le stockage du gaz naturel' },
		{ code: 'KA09', libelle: 'Pour le traitement de l\'eau' },
		{ code: 'KA10', libelle: 'Pour l\'industrie de l\'eau' },
		{ code: 'KA11', libelle: 'Pour les services des eaux' },
		{ code: 'KA12', libelle: 'Pour la production d\'électricité' },
		{ code: 'KA13', libelle: 'Approvisionnement industriel' },
		{ code: 'KA14', libelle: 'Eaux usées' },
		{ code: 'KA15', libelle: 'Vapeur' },
		{ code: 'KA16', libelle: 'Pour l\'industrie énergétique' },
		{ code: 'LA01', libelle: 'Pour anesthésie' },
		{ code: 'LA02', libelle: 'Pour dialyse rénale' },
		{ code: 'LA03', libelle: 'Pour autopsie' },
		{ code: 'LA04', libelle: 'Pour endoscopie des bronches' },
		{ code: 'LA05', libelle: 'Pour brûlures' },
		{ code: 'LA06', libelle: 'Pour traitement cytostatique' },
		{ code: 'LA07', libelle: 'Pour radiologie de diagnostic' },
		{ code: 'LA08', libelle: 'A usage diététique' },
		{ code: 'LA09', libelle: 'Pour désinfection' },
		{ code: 'LA10', libelle: 'Pour dispensaire' },
		{ code: 'LA11', libelle: 'A usage endovasculaire' },
		{ code: 'LA12', libelle: 'Pour gynécologie' },
		{ code: 'LA13', libelle: 'Pour hémodialyse' },
		{ code: 'LA14', libelle: 'Pour hémodynamique' },
		{ code: 'LA15', libelle: 'Pour cardiochirurgie ' },
		{ code: 'LA16', libelle: 'A usage hospitalier' },
		{ code: 'LA17', libelle: 'Pour immunologie' },
		{ code: 'LA18', libelle: 'Pour perfusion' },
		{ code: 'LA19', libelle: 'Pour injection' },
		{ code: 'LA20', libelle: 'Pour soins intensifs' },
		{ code: 'LA21', libelle: 'Pour laboratoire' },
		{ code: 'LA22', libelle: 'Pour le personnel médical' },
		{ code: 'LA23', libelle: 'A usage médical' },
		{ code: 'LA24', libelle: 'A usage neuro-angiographique' },
		{ code: 'LA25', libelle: 'A usage neuro-chirurgical' },
		{ code: 'LA26', libelle: 'Pour le personnel infirmier' },
		{ code: 'LA27', libelle: 'Pour salle d\'opération' },
		{ code: 'LA28', libelle: 'A usage en salle d\'opération' },
		{ code: 'LA29', libelle: 'A usage orthopédique' },
		{ code: 'LA30', libelle: 'Pour ostéosynthèse' },
		{ code: 'LA31', libelle: 'Pour pédiatrie' },
		{ code: 'LA32', libelle: 'A  usage paramédical' },
		{ code: 'LA33', libelle: 'Pour pathologie' },
		{ code: 'LA34', libelle: 'Pour dialyse péritonéale' },
		{ code: 'LA35', libelle: 'A usage psychiatrique' },
		{ code: 'LA36', libelle: 'Pour radiodiagnostic' },
		{ code: 'LA37', libelle: 'Pour analyse radio-immunologique' },
		{ code: 'LA38', libelle: 'Pour radio-immunologie' },
		{ code: 'LA39', libelle: 'Pour radiologie' },
		{ code: 'LA40', libelle: 'Pour réactifs de radiothérapie' },
		{ code: 'LA41', libelle: 'Pour sérologie' },
		{ code: 'LA42', libelle: 'A usage chirurgical' },
		{ code: 'LA43', libelle: 'Pour unité de dialyse rénale' },
		{ code: 'LA44', libelle: 'Pour médecine thérapeutique' },
		{ code: 'LA45', libelle: 'A usage thérapeutique' },
		{ code: 'LA46', libelle: 'Pour dialyse transpéritonéale' },
		{ code: 'LA47', libelle: 'Pour le traitement de l\'hypothermie' },
		{ code: 'LA48', libelle: 'Pour soins urologiques' },
		{ code: 'LA49', libelle: 'Pour unité de radiologie' },
		{ code: 'LA50', libelle: 'Pour cardiologie' },
		{ code: 'LA51', libelle: 'A usage cardiovasculaire' },
		{ code: 'LA52', libelle: 'Médical' },
		{ code: 'LA53', libelle: 'A usage post mortem' },
		{ code: 'LA54', libelle: 'A usage vasculaire' },
		{ code: 'LA55', libelle: 'A usage vétérinaire' },
		{ code: 'MA01', libelle: 'Pour aéronefs' },
		{ code: 'MA02', libelle: 'Pour équipages d\'aéronefs' },
		{ code: 'MA03', libelle: 'Pour autobus' },
		{ code: 'MA04', libelle: 'Pour automobiles' },
		{ code: 'MA05', libelle: 'Pour aéronefs civils' },
		{ code: 'MA06', libelle: 'Pour véhicules industriels' },
		{ code: 'MA07', libelle: 'Pour véhicules à moteur' },
		{ code: 'MA08', libelle: 'Pour le transport ferroviaire' },
		{ code: 'MA09', libelle: 'Pour le transport' },
		{ code: 'MA10', libelle: 'Pour utilisation dans les aéroports' },
		{ code: 'MA11', libelle: 'Pour véhicules' },
		{ code: 'MA12', libelle: 'Pour les transports urbains' },
		{ code: 'MA13', libelle: 'Pour les voies navigables' },
		{ code: 'MA14', libelle: 'Pour bateaux' },
		{ code: 'MB01', libelle: 'Conduite à gauche' },
		{ code: 'MB02', libelle: 'Conduite à droite' },
		{ code: 'MB03', libelle: 'Sous-marin' },
		{ code: 'MB04', libelle: 'A grande vitesse ' },
		{ code: 'MD01', libelle: 'Avec utilisation de véhicules réfrigérés' },
		{ code: 'MD02', libelle: 'Avec utilisation de véhicules à citerne' },
		{ code: 'MD03', libelle: 'Avec utilisation de véhicules adaptés au transport de marchandises en vrac' },
		{ code: 'MD04', libelle: 'Avec utilisation de véhicules à conteneur' },
		{ code: 'MD05', libelle: 'Avec utilisation de camions de déménagement ' },
		{ code: 'MD06', libelle: 'Avec utilisation de remorques autochargeuses' },
		{ code: 'MD07', libelle: 'Avec utilisation de voitures blindées' },
		{ code: 'ME01', libelle: 'De marchandise en vrac à l\'état sec' },
		{ code: 'ME02', libelle: 'De gaz naturel' },
		{ code: 'ME03', libelle: 'De cadavres' },
		{ code: 'ME04', libelle: 'D\'objets d\'art' },
		{ code: 'ME05', libelle: 'De substances toxiques' },
		{ code: 'MF01', libelle: 'Avec utilisation d\'un aéronef' },
		{ code: 'MF02', libelle: 'Avec utilisation d\'un tramway' },
		{ code: 'MF03', libelle: 'Avec utilisation de véhicules spécialisés' },
		{ code: 'MF04', libelle: 'Avec utilisation d\'une autombile' },
		{ code: 'MF05', libelle: 'Avec utilisation d\'un autobus' },
		{ code: 'MF06', libelle: 'Avec utilisation d\'un car' },
		{ code: 'MF07', libelle: 'Avec utilisation d\'un  aérostat ' },
		{ code: 'MF08', libelle: 'Avec utilisation d\'un zeppelin' },
		{ code: 'MF09', libelle: 'Avec utilisation d\'un aéroglisseurt' },
		{ code: 'MF10', libelle: 'Avec utilisation d\'un zodiac' },
		{ code: 'PA01', libelle: 'Location' },
		{ code: 'PA02', libelle: 'Crédit-bail' },
		{ code: 'PA03', libelle: 'Location-achat' },
		{ code: 'PB01', libelle: 'Avec équipage' },
		{ code: 'PB02', libelle: 'Sans équipage' },
		{ code: 'PB03', libelle: 'Avec chauffeur' },
		{ code: 'PB04', libelle: 'Sans chauffeur' },
		{ code: 'PB05', libelle: 'Avec opérateur' },
		{ code: 'PB06', libelle: 'Sans opérateur' },
		{ code: 'QA01', libelle: 'Pour publicité radiotélévisée' },
		{ code: 'QA02', libelle: 'Pour publicité radiophonique' },
		{ code: 'QA03', libelle: 'Pour publicité télévisée' },
		{ code: 'QA04', libelle: 'Pour publicité sur l\'Internet' },
		{ code: 'QA05', libelle: 'Pour publicité cinématographique' },
		{ code: 'QA06', libelle: 'Pour publicité dans la presse' },
		{ code: 'QA07', libelle: 'Pour publicité dans les magazines' },
		{ code: 'QA08', libelle: 'Pour publicité par affichage' },
		{ code: 'QA09', libelle: 'Pour publicité par coupons' },
		{ code: 'QA10', libelle: 'Pour foires et salons' },
		{ code: 'QA11', libelle: 'Pour évènements' },
		{ code: 'QA12', libelle: 'Pour conférences' },
		{ code: 'QA13', libelle: 'Pour expositions' },
		{ code: 'QB01', libelle: 'Pour le droit des contrats' },
		{ code: 'QB02', libelle: 'Pour le droit commercial' },
		{ code: 'QB03', libelle: 'Pour le droit des sociétés' },
		{ code: 'QB04', libelle: 'Pour le droit de la concurrence' },
		{ code: 'QB05', libelle: 'Pour le droit administratif' },
		{ code: 'QB06', libelle: 'Pour le droit privé' },
		{ code: 'QB07', libelle: 'Pour le droit public ' },
		{ code: 'QB08', libelle: 'Pour le droit international ' },
		{ code: 'QB09', libelle: 'Pour le droit national' },
		{ code: 'QB10', libelle: 'Pour le droit régional ' },
		{ code: 'QB11', libelle: 'Pour le droit du travail' },
		{ code: 'QB12', libelle: 'Pour le droit de l\'immigration ' },
		{ code: 'QB13', libelle: 'Pour le droit fiscal' },
		{ code: 'QB14', libelle: 'Pour le droit social ' },
		{ code: 'QB15', libelle: 'Pour le droit pénal' },
		{ code: 'QB16', libelle: 'Pour le droit en matière de discrimination ou de harcèlement' },
		{ code: 'QB17', libelle: 'Pour le droit en matière de justice des mineurs' },
		{ code: 'QB18', libelle: 'Pour la procédure d\'appel' },
		{ code: 'QB19', libelle: 'Pour le droit en matière de défense ' },
		{ code: 'QB20', libelle: 'Pour le droit des affaires' },
		{ code: 'QB21', libelle: 'Pour le droit des ententes' },
		{ code: 'QB23', libelle: 'Pour le droit de la faillite' },
		{ code: 'QB24', libelle: 'Pour le droit en matière de partenariats' },
		{ code: 'QB25', libelle: 'Pour le droit des brevets' },
		{ code: 'QB26', libelle: 'Pour le droit des marques' },
		{ code: 'QB27', libelle: 'Pour le droit de la propriété littéraire et artistique ' },
		{ code: 'QB28', libelle: 'Pour le droit en matière de liquidations' },
		{ code: 'QB29', libelle: 'Pour le droit immobilier' },
		{ code: 'QB30', libelle: 'Pour le droit en matière de fusions' },
		{ code: 'QB31', libelle: 'Pour le droit en matières d\'acquisitions' },
		{ code: 'QB32', libelle: 'Pour le droit en matière de recouvrement des dettes' },
		{ code: 'QB33', libelle: 'Pour le droit de la santé' },
		{ code: 'QB34', libelle: 'Pour le droit en matière de préjudices corporels' },
		{ code: 'QB35', libelle: 'Pour le droit de la propriété' },
		{ code: 'QB36', libelle: 'Pour le droit en matières d\'avantages sociaux des salariés' },
		{ code: 'QB37', libelle: 'Pour le droit des conflits de travail' },
		{ code: 'QB38', libelle: 'Pour le droit de la famille' },
		{ code: 'QB39', libelle: 'Pour le droit de l\'adoption ' },
		{ code: 'QB40', libelle: 'Pour le droit en matière de naturalisations' },
		{ code: 'QB41', libelle: 'Pour le droit en matière de tutelle' },
		{ code: 'QB42', libelle: 'Pour le droit en matière de garde d\'enfants' },
		{ code: 'QB43', libelle: 'En matière foncière   ' },
		{ code: 'QB44', libelle: 'En matière d\'eau ' },
		{ code: 'QB45', libelle: 'En matière de pêche' },
		{ code: 'QB46', libelle: 'En matière de plantes' },
		{ code: 'QB47', libelle: 'En matière d\'animaux' },
		{ code: 'QB48', libelle: 'En matière d\'alimentation' },
		{ code: 'QB49', libelle: 'En matière de sylviculture' },
		{ code: 'QB50', libelle: 'En matière de faune et de flore ' },
		{ code: 'QB51', libelle: 'En matière de parcs nationaux' },
		{ code: 'QB52', libelle: 'En matière d\'environnement' },
		{ code: 'QB53', libelle: 'En matière de biodiversité' },
		{ code: 'QB54', libelle: 'Concernant le secteur automobile' },
		{ code: 'QB55', libelle: 'Concernant le secteur aéronautique' },
		{ code: 'QB56', libelle: 'Concernant le secteur aérospatial' },
		{ code: 'QB57', libelle: 'Concernant des questions politiques' },
		{ code: 'RA01', libelle: 'En pharmacie ' },
		{ code: 'RA02', libelle: 'En bactériologie' },
		{ code: 'RA03', libelle: 'En biomédecine' },
		{ code: 'RA04', libelle: 'En cardiologie' },
		{ code: 'RA05', libelle: 'En anatomie' },
		{ code: 'RA06', libelle: 'En pathologie' },
		{ code: 'RA07', libelle: 'En embryologie' },
		{ code: 'RA08', libelle: 'En épidémiologie' },
		{ code: 'RA09', libelle: 'En génétique' },
		{ code: 'RA10', libelle: 'En immunologie' },
		{ code: 'RA11', libelle: 'En ophthalmologie' },
		{ code: 'RA12', libelle: 'En physiologie' },
		{ code: 'RA13', libelle: 'En toxicologie' },
		{ code: 'RA14', libelle: 'En neurologie' },
		{ code: 'RA15', libelle: 'En urologie' },
		{ code: 'RA16', libelle: 'En dermatologie' },
		{ code: 'RB01', libelle: 'Pour la micro-économie' },
		{ code: 'RB02', libelle: 'Pour la macro-économie' },
		{ code: 'RB03', libelle: 'Pour l\'économie industrielle' },
		{ code: 'RB04', libelle: 'Pour l\'économie de la concurrence' },
		{ code: 'RB05', libelle: 'Pour l\'économie de la régulation ' },
		{ code: 'RB06', libelle: 'Pour l\'économie en matière de commerce' },
		{ code: 'RB07', libelle: 'Pour l\'économie internationale' },
		{ code: 'RB08', libelle: 'Pour l\'économie nationale' },
		{ code: 'RB09', libelle: 'Pour l\'économie régionale' },
		{ code: 'RB10', libelle: 'Pour l\'économie géographique' },
		{ code: 'RB11', libelle: 'Pour l\'économie bancaire' },
		{ code: 'RB12', libelle: 'Pour l\'économie de l\'assurance' },
		{ code: 'RB13', libelle: 'Pour l\'économétrie' },
		{ code: 'RB14', libelle: 'Pour l\'économie monétaire' },
		{ code: 'RB15', libelle: 'Pour l\'économie cambiaire' },
		{ code: 'RB16', libelle: 'Pour l\'économie de l\'innovation' },
		{ code: 'RB17', libelle: 'Pour l\a prévision économique' },
		{ code: 'RB18', libelle: 'Pour l\'économie publique' },
		{ code: 'RB19', libelle: 'Pour l\'économie privée' },
		{ code: 'RB20', libelle: 'Pour l\'économie de marché' },
		{ code: 'RB21', libelle: 'Pour l\'économie planifiée ' },
		{ code: 'RC01', libelle: 'En technologie aérospatiale' },
		{ code: 'RC02', libelle: 'En technologie spatiale' },
		{ code: 'RC03', libelle: 'En technologie informatique' },
		{ code: 'RC04', libelle: 'En technologie de la communication ' },
		{ code: 'RC05', libelle: 'En technologie de l\'information ' },
		{ code: 'RC06', libelle: 'En technologie de l\'automation' },
		{ code: 'RC07', libelle: 'En technologie des combustibles' },
		{ code: 'RC08', libelle: 'En technologie nucléaire' },
		{ code: 'RD01', libelle: 'En mathématiques' },
		{ code: 'RD02', libelle: 'En sciences naturelles' },
		{ code: 'RD03', libelle: 'En biologie' },
		{ code: 'RD04', libelle: 'En chimie' },
		{ code: 'RD05', libelle: 'En physique' },
		{ code: 'RD06', libelle: 'En sciences de la terre' },
		{ code: 'RD07', libelle: 'En sciences sociales' },
		{ code: 'RD08', libelle: 'En sciences comportementales' },
		{ code: 'RD09', libelle: 'En sciences appliquées' },
		{ code: 'RD10', libelle: 'En sciences de la santé' },
		{ code: 'RD11', libelle: 'Dans des domaines interdisciplinaires' },
		{ code: 'SA01', libelle: 'Pour les activité bancaires' },
		{ code: 'SA02', libelle: 'Pour le change' },
		{ code: 'SA03', libelle: 'Pour les emprunts' },
		{ code: 'SA04', libelle: 'Pour les crédits' },
		{ code: 'SB01', libelle: 'Pour l\'assurance' },
		{ code: 'SB02', libelle: 'Pour la réassurance' },
		{ code: 'SC01', libelle: 'Pour les pensions' },
		{ code: 'TA01', libelle: 'Pour livres' },
		{ code: 'TA02', libelle: 'Pour carnets d\'adresses' },
		{ code: 'TA03', libelle: 'Pour cahiers de devoirs' },
		{ code: 'TA04', libelle: 'Pour agendas' },
		{ code: 'TA05', libelle: 'Pour mémentos personnels' },
		{ code: 'TA06', libelle: 'Pour carnets' },
		{ code: 'TA07', libelle: 'Pour brochures' },
		{ code: 'TA08', libelle: 'Pour blocs-notes' },
		{ code: 'TA09', libelle: 'Pour blocs de papier à lettres' },
		{ code: 'TA10', libelle: 'Pour sous-mains' },
		{ code: 'TA11', libelle: 'Pour publicités professionnelles' },
		{ code: 'TA12', libelle: 'Pour catalogues commerciaux' },
		{ code: 'TA13', libelle: 'Pour registres' },
		{ code: 'TA14', libelle: 'Pour livres de comptabilité' },
		{ code: 'TA15', libelle: 'Pour carnets de commande' },
		{ code: 'TA16', libelle: 'Pour carnets de quittances' },
		{ code: 'TA17', libelle: 'Pour articles de papeterie' },
		{ code: 'TA18', libelle: 'Pour enveloppes' },
		{ code: 'TA19', libelle: 'Pour papier à lettres' },
		{ code: 'TA20', libelle: 'Pour liasses carbonées' },
		{ code: 'TA21', libelle: 'Pour albums pour échantillons ou collections' },
		{ code: 'TA22', libelle: 'Pour classeurs ou  chemises ' },
		{ code: 'TA23', libelle: 'Pour cartes de visite' },
		{ code: 'TA24', libelle: 'Pour documents infalsifiables' },
		{ code: 'TA25', libelle: 'Pour permis' },
		{ code: 'TA26', libelle: 'Pour certificats d\'actions' },
		{ code: 'TA27', libelle: 'Pour chèques' },
		{ code: 'TA28', libelle: 'Pour nouveaux timbres ' },
		{ code: 'TA29', libelle: 'Pour papier timbré' },
		{ code: 'TA30', libelle: 'Pour chèques-repas' },
		{ code: 'TA31', libelle: 'Pour formulaires' },
		{ code: 'TA32', libelle: 'Pour formulaires commerciaux autocopiants' },
		{ code: 'TA33', libelle: 'Pour formulaires en continu' },
		{ code: 'TA34', libelle: 'Pour tickets' },
		{ code: 'TA35', libelle: 'Pour billets d\'entrée' },
		{ code: 'TA36', libelle: 'Pour billets de transport ' },
		{ code: 'TA37', libelle: 'Pour tickets à bande magnétique' },
		{ code: 'TA38', libelle: 'Pour calendriers' },
		{ code: 'TA39', libelle: 'Pour horaires' },
		{ code: 'TA40', libelle: 'Pour journaux' },
		{ code: 'TA41', libelle: 'Pour affiches' },
		{ code: 'TA42', libelle: 'Pour flexographie industrielle' },
		{ code: 'TA43', libelle: 'Pour rotogravure industrielle' },
		{ code: 'TA44', libelle: 'Pour sérigraphie industrielle' },
		{ code: 'TA45', libelle: 'Pour impression offset industrielle' },
		{ code: 'TA46', libelle: 'Pour impression à thermotransfert industrielle' },
		{ code: 'TA47', libelle: 'De livres en braille ' },
		{ code: 'TA48', libelle: 'De carton' },
		{ code: 'UA01', libelle: 'Produits alimentaires' },
		{ code: 'UA02', libelle: 'Boissons' },
		{ code: 'UB01', libelle: 'Mobilier' },
		{ code: 'UB02', libelle: 'Vêtements' },
		{ code: 'UB03', libelle: 'Matériaux de construction' },
		{ code: 'UB04', libelle: 'Imprimés' },
		{ code: 'UB05', libelle: 'Articles de bureau' },
		{ code: 'UB06', libelle: 'Produits d\'horticulture' },
		{ code: 'UB07', libelle: 'Produits médicaux' },
		{ code: 'UB08', libelle: 'Stocks excédentaires ' }];

	private classificationValue = [
		{ code: '1', libelle: 'Ministère ou toute autre autorité nationale ou fédérale, y compris leurs subdivisions régionales ou locales' },
		{ code: '2', libelle: 'Agence/office national(e) ou fédéral(e)' },
		{ code: '3', libelle: 'Autorité régionale ou locale (remplace "Collectivité territoriale")' },
		{ code: '4', libelle: 'Agence/office régional(e) ou local(e)' },
		{ code: '5', libelle: 'Organisme de droit public' },
		{ code: '6', libelle: 'Institution/agence européenne ou organisation européenne' },
		{ code: '7', libelle: 'autre' }];

	private classificationOrganisme = [
		{ code: '', libelle:'- Sélectionner -'},
		{ code: '1', libelle: 'Etat' },
		{ code: '2', libelle: 'Région' },
		{ code: '3', libelle: 'Département' },
		{ code: '4', libelle: 'Commune' },
		{ code: '5', libelle: 'Etablissement public national' },
		{ code: '6', libelle: 'Etablissement public territorial' },
		{ code: '7', libelle: 'Autre' },
		{ code: '8', libelle: 'Institution Européenne' }];

	private devise = [
		{ code: 'GBP', libelle: 'Pound Sterling' },
		{ code: 'EUR', libelle: 'Euro' },
		{ code: 'DKK', libelle: 'Danish Krone' },
		{ code: 'SEK', libelle: 'Swedish Krona' },
		{ code: 'CHF', libelle: 'Swiss Franc' },
		{ code: 'JPY', libelle: 'Japanese yen' },
		{ code: 'USD', libelle: 'US Dollar' },
		{ code: 'ISK', libelle: 'Iceland Krona' },
		{ code: 'NOK', libelle: 'Norwegian Krone' },
		{ code: 'CZK', libelle: 'Czech Koruna' },
		{ code: 'HUF', libelle: 'Forint' },
		{ code: 'PLN', libelle: 'Zloty' },
		{ code: 'SVC', libelle: 'Colon salvadorien' },
		{ code: 'SIT', libelle: 'Tolar slovène' },
	];

	private langEC = [
		{ code: 'es', libelle: 'espagnol' },
		{ code: 'fr', libelle: 'français' },
		{ code: 'da', libelle: 'danois' },
		{ code: 'de', libelle: 'allemand' },
		{ code: 'el', libelle: 'grec' },
		{ code: 'en', libelle: 'anglais' },
		{ code: 'it', libelle: 'italien' },
		{ code: 'nl', libelle: 'néerlandais' },
		{ code: 'pt', libelle: 'portugais' },
		{ code: 'fi', libelle: 'finnois' },
		{ code: 'sv', libelle: 'suédois' },
		{ code: 'cs', libelle: 'tchèque' },
		{ code: 'et', libelle: 'estonien' },
		{ code: 'hu', libelle: 'hongrois' },
		{ code: 'lv', libelle: 'letton' },
		{ code: 'lt', libelle: 'lituanien' },
		{ code: 'mt', libelle: 'maltais' },
		{ code: 'pl', libelle: 'polonais' },
		{ code: 'sk', libelle: 'slovaque' },
		{ code: 'sl', libelle: 'slovène' },
		{ code: 'bg', libelle: 'bulgare' },
		{ code: 'ga', libelle: 'irlandais' },
		{ code: 'ro', libelle: 'roumain' }];

	private readonly cpvSubject = new BehaviorSubject<any[]>([]);
  	public readonly cpv$ = this.cpvSubject.asObservable();
	private readonly nutsSubject = new BehaviorSubject<any[]>([]);
  	public readonly nuts$ = this.nutsSubject.asObservable();
	private readonly languageSubject = new BehaviorSubject<any[]>([]);
  	public readonly language$ = this.languageSubject.asObservable();
	private readonly countrySubject = new BehaviorSubject<any[]>([]);
  	public readonly countries$ = this.countrySubject.asObservable();
	private readonly currencySubject = new BehaviorSubject<any[]>([]);
  	public readonly currency$ = this.currencySubject.asObservable();
	private readonly durationUnitSubject = new BehaviorSubject<any[]>([]);
  	public readonly durationUnit$ = this.durationUnitSubject.asObservable();
	private readonly measurementUnitSubject = new BehaviorSubject<any[]>([]);
  	public readonly measurementUnit$ = this.measurementUnitSubject.asObservable();
	private readonly motClefSubject = new BehaviorSubject<any[]>([]);
  	public readonly motClef$ = this.motClefSubject.asObservable();

	public readonly eformBandeauErreurMappingSubject = new BehaviorSubject<any[]>([]);

	private codenuts = [
		{ code: 'Code 2021', libelle: '' },
		{ code: 'BE', libelle: 'Belgique/België' },
		{ code: 'BE1', libelle: 'Région de Bruxelles-Capitale/Brussels Hoofdstedelijk Gewest' },
		{ code: 'BE10', libelle: 'Région de Bruxelles-Capitale/ Brussels Hoofdstedelijk Gewest' },
		{ code: 'BE100', libelle: 'Arr. de Bruxelles-Capitale/Arr. Brussel-Hoofdstad' },
		{ code: 'BE2', libelle: 'Vlaams Gewest' },
		{ code: 'BE21', libelle: 'Prov. Antwerpen' },
		{ code: 'BE211', libelle: 'Arr. Antwerpen' },
		{ code: 'BE212', libelle: 'Arr. Mechelen' },
		{ code: 'BE213', libelle: 'Arr. Turnhout' },
		{ code: 'BE22', libelle: 'Prov. Limburg (BE)' },
		{ code: 'BE223', libelle: 'Arr. Tongeren' },
		{ code: 'BE224', libelle: 'Arr. Hasselt' },
		{ code: 'BE225', libelle: 'Arr. Maaseik' },
		{ code: 'BE23', libelle: 'Prov. Oost-Vlaanderen' },
		{ code: 'BE231', libelle: 'Arr. Aalst' },
		{ code: 'BE232', libelle: 'Arr. Dendermonde' },
		{ code: 'BE233', libelle: 'Arr. Eeklo' },
		{ code: 'BE234', libelle: 'Arr. Gent' },
		{ code: 'BE235', libelle: 'Arr. Oudenaarde' },
		{ code: 'BE236', libelle: 'Arr. Sint-Niklaas' },
		{ code: 'BE24', libelle: 'Prov. Vlaams-Brabant' },
		{ code: 'BE241', libelle: 'Arr. Halle-Vilvoorde' },
		{ code: 'BE242', libelle: 'Arr. Leuven' },
		{ code: 'BE25', libelle: 'Prov. West-Vlaanderen' },
		{ code: 'BE251', libelle: 'Arr. Brugge' },
		{ code: 'BE252', libelle: 'Arr. Diksmuide' },
		{ code: 'BE253', libelle: 'Arr. Ieper' },
		{ code: 'BE254', libelle: 'Arr. Kortrijk' },
		{ code: 'BE255', libelle: 'Arr. Oostende' },
		{ code: 'BE256', libelle: 'Arr. Roeselare' },
		{ code: 'BE257', libelle: 'Arr. Tielt' },
		{ code: 'BE258', libelle: 'Arr. Veurne' },
		{ code: 'BE3', libelle: 'Région wallonne' },
		{ code: 'BE31', libelle: 'Prov. Brabant Wallon' },
		{ code: 'BE310', libelle: 'Arr. Nivelles' },
		{ code: 'BE32', libelle: 'Prov. Hainaut' },
		{ code: 'BE323', libelle: 'Arr. Mons' },
		{ code: 'BE328', libelle: 'Arr. Tournai-Mouscron' },
		{ code: 'BE329', libelle: 'Arr. La Louvière' },
		{ code: 'BE32A', libelle: 'Arr. Ath' },
		{ code: 'BE32B', libelle: 'Arr. Charleroi' },
		{ code: 'BE32C', libelle: 'Arr. Soignies' },
		{ code: 'BE32D', libelle: 'Arr. Thuin' },
		{ code: 'BE33', libelle: 'Prov. Liège' },
		{ code: 'BE331', libelle: 'Arr. Huy' },
		{ code: 'BE332', libelle: 'Arr. Liège' },
		{ code: 'BE334', libelle: 'Arr. Waremme' },
		{ code: 'BE335', libelle: 'Arr. Verviers — communes francophones' },
		{ code: 'BE336', libelle: 'Bezirk Verviers — Deutschsprachige Gemeinschaft' },
		{ code: 'BE34', libelle: 'Prov. Luxembourg (BE)' },
		{ code: 'BE341', libelle: 'Arr. Arlon' },
		{ code: 'BE342', libelle: 'Arr. Bastogne' },
		{ code: 'BE343', libelle: 'Arr. Marche-en-Famenne' },
		{ code: 'BE344', libelle: 'Arr. Neufchâteau' },
		{ code: 'BE345', libelle: 'Arr. Virton' },
		{ code: 'BE35', libelle: 'Prov. Namur' },
		{ code: 'BE351', libelle: 'Arr. Dinant' },
		{ code: 'BE352', libelle: 'Arr. Namur' },
		{ code: 'BE353', libelle: 'Arr. Philippeville' },
		{ code: 'BEZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'BEZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'BEZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'BG', libelle: 'България ' },
		{ code: 'BG3', libelle: 'Северна и Югоизточна България' },
		{ code: 'BG31', libelle: 'Северозападен' },
		{ code: 'BG311', libelle: 'Видин' },
		{ code: 'BG312', libelle: 'Монтана' },
		{ code: 'BG313', libelle: 'Враца' },
		{ code: 'BG314', libelle: 'Плевен' },
		{ code: 'BG315', libelle: 'Ловеч' },
		{ code: 'BG32', libelle: 'Северен централен' },
		{ code: 'BG321', libelle: 'Велико Търново' },
		{ code: 'BG322', libelle: 'Габрово' },
		{ code: 'BG323', libelle: 'Русе' },
		{ code: 'BG324', libelle: 'Разград' },
		{ code: 'BG325', libelle: 'Силистра' },
		{ code: 'BG33', libelle: 'Североизточен' },
		{ code: 'BG331', libelle: 'Варна' },
		{ code: 'BG332', libelle: 'Добрич' },
		{ code: 'BG333', libelle: 'Шумен' },
		{ code: 'BG334', libelle: 'Търговище' },
		{ code: 'BG34', libelle: 'Югоизточен' },
		{ code: 'BG341', libelle: 'Бургас' },
		{ code: 'BG342', libelle: 'Сливен' },
		{ code: 'BG343', libelle: 'Ямбол' },
		{ code: 'BG344', libelle: 'Стара Загора' },
		{ code: 'BG4', libelle: 'Югозападна и Южна централна България' },
		{ code: 'BG41', libelle: 'Югозападен' },
		{ code: 'BG411', libelle: 'София (столица)' },
		{ code: 'BG412', libelle: 'София' },
		{ code: 'BG413', libelle: 'Благоевград' },
		{ code: 'BG414', libelle: 'Перник' },
		{ code: 'BG415', libelle: 'Кюстендил' },
		{ code: 'BG42', libelle: 'Южен централен' },
		{ code: 'BG421', libelle: 'Пловдив' },
		{ code: 'BG422', libelle: 'Хасково' },
		{ code: 'BG423', libelle: 'Пазарджик' },
		{ code: 'BG424', libelle: 'Смолян' },
		{ code: 'BG425', libelle: 'Кърджали' },
		{ code: 'BGZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'BGZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'BGZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'CZ', libelle: 'Česko' },
		{ code: 'CZ0', libelle: 'Česko' },
		{ code: 'CZ01', libelle: 'Praha' },
		{ code: 'CZ010', libelle: 'Hlavní město Praha' },
		{ code: 'CZ02', libelle: 'Střední Čechy' },
		{ code: 'CZ020', libelle: 'Středočeský kraj' },
		{ code: 'CZ03', libelle: 'Jihozápad' },
		{ code: 'CZ031', libelle: 'Jihočeský kraj' },
		{ code: 'CZ032', libelle: 'Plzeňský kraj' },
		{ code: 'CZ04', libelle: 'Severozápad' },
		{ code: 'CZ041', libelle: 'Karlovarský kraj' },
		{ code: 'CZ042', libelle: 'Ústecký kraj' },
		{ code: 'CZ05', libelle: 'Severovýchod' },
		{ code: 'CZ051', libelle: 'Liberecký kraj' },
		{ code: 'CZ052', libelle: 'Královéhradecký kraj' },
		{ code: 'CZ053', libelle: 'Pardubický kraj' },
		{ code: 'CZ06', libelle: 'Jihovýchod' },
		{ code: 'CZ063', libelle: 'Kraj Vysočina' },
		{ code: 'CZ064', libelle: 'Jihomoravský kraj' },
		{ code: 'CZ07', libelle: 'Střední Morava' },
		{ code: 'CZ071', libelle: 'Olomoucký kraj' },
		{ code: 'CZ072', libelle: 'Zlínský kraj' },
		{ code: 'CZ08', libelle: 'Moravskoslezsko' },
		{ code: 'CZ080', libelle: 'Moravskoslezský kraj' },
		{ code: 'CZZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'CZZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'CZZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'DK', libelle: 'Danmark' },
		{ code: 'DK0', libelle: 'Danmark' },
		{ code: 'DK01', libelle: 'Hovedstaden' },
		{ code: 'DK011', libelle: 'Byen København' },
		{ code: 'DK012', libelle: 'Københavns omegn' },
		{ code: 'DK013', libelle: 'Nordsjælland' },
		{ code: 'DK014', libelle: 'Bornholm' },
		{ code: 'DK02', libelle: 'Sjælland' },
		{ code: 'DK021', libelle: 'Østsjælland' },
		{ code: 'DK022', libelle: 'Vest- og Sydsjælland' },
		{ code: 'DK03', libelle: 'Syddanmark' },
		{ code: 'DK031', libelle: 'Fyn' },
		{ code: 'DK032', libelle: 'Sydjylland' },
		{ code: 'DK04', libelle: 'Midtjylland' },
		{ code: 'DK041', libelle: 'Vestjylland' },
		{ code: 'DK042', libelle: 'Østjylland' },
		{ code: 'DK05', libelle: 'Nordjylland' },
		{ code: 'DK050', libelle: 'Nordjylland' },
		{ code: 'DKZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'DKZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'DKZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'DE', libelle: 'Deutschland' },
		{ code: 'DE1', libelle: 'Baden-Württemberg' },
		{ code: 'DE11', libelle: 'Stuttgart' },
		{ code: 'DE111', libelle: 'Stuttgart, Stadtkreis' },
		{ code: 'DE112', libelle: 'Böblingen' },
		{ code: 'DE113', libelle: 'Esslingen' },
		{ code: 'DE114', libelle: 'Göppingen' },
		{ code: 'DE115', libelle: 'Ludwigsburg' },
		{ code: 'DE116', libelle: 'Rems-Murr-Kreis' },
		{ code: 'DE117', libelle: 'Heilbronn, Stadtkreis' },
		{ code: 'DE118', libelle: 'Heilbronn, Landkreis' },
		{ code: 'DE119', libelle: 'Hohenlohekreis' },
		{ code: 'DE11A', libelle: 'Schwäbisch Hall' },
		{ code: 'DE11B', libelle: 'Main-Tauber-Kreis' },
		{ code: 'DE11C', libelle: 'Heidenheim' },
		{ code: 'DE11D', libelle: 'Ostalbkreis' },
		{ code: 'DE12', libelle: 'Karlsruhe' },
		{ code: 'DE121', libelle: 'Baden-Baden, Stadtkreis' },
		{ code: 'DE122', libelle: 'Karlsruhe, Stadtkreis' },
		{ code: 'DE123', libelle: 'Karlsruhe, Landkreis' },
		{ code: 'DE124', libelle: 'Rastatt' },
		{ code: 'DE125', libelle: 'Heidelberg, Stadtkreis' },
		{ code: 'DE126', libelle: 'Mannheim, Stadtkreis' },
		{ code: 'DE127', libelle: 'Neckar-Odenwald-Kreis' },
		{ code: 'DE128', libelle: 'Rhein-Neckar-Kreis' },
		{ code: 'DE129', libelle: 'Pforzheim, Stadtkreis' },
		{ code: 'DE12A', libelle: 'Calw' },
		{ code: 'DE12B', libelle: 'Enzkreis' },
		{ code: 'DE12C', libelle: 'Freudenstadt' },
		{ code: 'DE13', libelle: 'Freiburg' },
		{ code: 'DE131', libelle: 'Freiburg im Breisgau, Stadtkreis' },
		{ code: 'DE132', libelle: 'Breisgau-Hochschwarzwald' },
		{ code: 'DE133', libelle: 'Emmendingen' },
		{ code: 'DE134', libelle: 'Ortenaukreis' },
		{ code: 'DE135', libelle: 'Rottweil' },
		{ code: 'DE136', libelle: 'Schwarzwald-Baar-Kreis' },
		{ code: 'DE137', libelle: 'Tuttlingen' },
		{ code: 'DE138', libelle: 'Konstanz' },
		{ code: 'DE139', libelle: 'Lörrach' },
		{ code: 'DE13A', libelle: 'Waldshut' },
		{ code: 'DE14', libelle: 'Tübingen' },
		{ code: 'DE141', libelle: 'Reutlingen' },
		{ code: 'DE142', libelle: 'Tübingen, Landkreis' },
		{ code: 'DE143', libelle: 'Zollernalbkreis' },
		{ code: 'DE144', libelle: 'Ulm, Stadtkreis' },
		{ code: 'DE145', libelle: 'Alb-Donau-Kreis' },
		{ code: 'DE146', libelle: 'Biberach' },
		{ code: 'DE147', libelle: 'Bodenseekreis' },
		{ code: 'DE148', libelle: 'Ravensburg' },
		{ code: 'DE149', libelle: 'Sigmaringen' },
		{ code: 'DE2', libelle: 'Bayern' },
		{ code: 'DE21', libelle: 'Oberbayern' },
		{ code: 'DE211', libelle: 'Ingolstadt, Kreisfreie Stadt' },
		{ code: 'DE212', libelle: 'München, Kreisfreie Stadt' },
		{ code: 'DE213', libelle: 'Rosenheim, Kreisfreie Stadt' },
		{ code: 'DE214', libelle: 'Altötting' },
		{ code: 'DE215', libelle: 'Berchtesgadener Land' },
		{ code: 'DE216', libelle: 'Bad Tölz-Wolfratshausen' },
		{ code: 'DE217', libelle: 'Dachau' },
		{ code: 'DE218', libelle: 'Ebersberg' },
		{ code: 'DE219', libelle: 'Eichstätt' },
		{ code: 'DE21A', libelle: 'Erding' },
		{ code: 'DE21B', libelle: 'Freising' },
		{ code: 'DE21C', libelle: 'Fürstenfeldbruck' },
		{ code: 'DE21D', libelle: 'Garmisch-Partenkirchen' },
		{ code: 'DE21E', libelle: 'Landsberg am Lech' },
		{ code: 'DE21F', libelle: 'Miesbach' },
		{ code: 'DE21G', libelle: 'Mühldorf a. Inn' },
		{ code: 'DE21H', libelle: 'München, Landkreis' },
		{ code: 'DE21I', libelle: 'Neuburg-Schrobenhausen' },
		{ code: 'DE21J', libelle: 'Pfaffenhofen a. d. Ilm' },
		{ code: 'DE21K', libelle: 'Rosenheim, Landkreis' },
		{ code: 'DE21L', libelle: 'Starnberg' },
		{ code: 'DE21M', libelle: 'Traunstein' },
		{ code: 'DE21N', libelle: 'Weilheim-Schongau' },
		{ code: 'DE22', libelle: 'Niederbayern' },
		{ code: 'DE221', libelle: 'Landshut, Kreisfreie Stadt' },
		{ code: 'DE222', libelle: 'Passau, Kreisfreie Stadt' },
		{ code: 'DE223', libelle: 'Straubing, Kreisfreie Stadt' },
		{ code: 'DE224', libelle: 'Deggendorf' },
		{ code: 'DE225', libelle: 'Freyung-Grafenau' },
		{ code: 'DE226', libelle: 'Kelheim' },
		{ code: 'DE227', libelle: 'Landshut, Landkreis' },
		{ code: 'DE228', libelle: 'Passau, Landkreis' },
		{ code: 'DE229', libelle: 'Regen' },
		{ code: 'DE22A', libelle: 'Rottal-Inn' },
		{ code: 'DE22B', libelle: 'Straubing-Bogen' },
		{ code: 'DE22C', libelle: 'Dingolfing-Landau' },
		{ code: 'DE23', libelle: 'Oberpfalz' },
		{ code: 'DE231', libelle: 'Amberg, Kreisfreie Stadt' },
		{ code: 'DE232', libelle: 'Regensburg, Kreisfreie Stadt' },
		{ code: 'DE233', libelle: 'Weiden i. d. Opf, Kreisfreie Stadt' },
		{ code: 'DE234', libelle: 'Amberg-Sulzbach' },
		{ code: 'DE235', libelle: 'Cham' },
		{ code: 'DE236', libelle: 'Neumarkt i. d. OPf.' },
		{ code: 'DE237', libelle: 'Neustadt a. d. Waldnaab' },
		{ code: 'DE238', libelle: 'Regensburg, Landkreis' },
		{ code: 'DE239', libelle: 'Schwandorf' },
		{ code: 'DE23A', libelle: 'Tirschenreuth' },
		{ code: 'DE24', libelle: 'Oberfranken' },
		{ code: 'DE241', libelle: 'Bamberg, Kreisfreie Stadt' },
		{ code: 'DE242', libelle: 'Bayreuth, Kreisfreie Stadt' },
		{ code: 'DE243', libelle: 'Coburg, Kreisfreie Stadt' },
		{ code: 'DE244', libelle: 'Hof, Kreisfreie Stadt' },
		{ code: 'DE245', libelle: 'Bamberg, Landkreis' },
		{ code: 'DE246', libelle: 'Bayreuth, Landkreis' },
		{ code: 'DE247', libelle: 'Coburg, Landkreis' },
		{ code: 'DE248', libelle: 'Forchheim' },
		{ code: 'DE249', libelle: 'Hof, Landkreis' },
		{ code: 'DE24A', libelle: 'Kronach' },
		{ code: 'DE24B', libelle: 'Kulmbach' },
		{ code: 'DE24C', libelle: 'Lichtenfels' },
		{ code: 'DE24D', libelle: 'Wunsiedel i. Fichtelgebirge' },
		{ code: 'DE25', libelle: 'Mittelfranken' },
		{ code: 'DE251', libelle: 'Ansbach, Kreisfreie Stadt' },
		{ code: 'DE252', libelle: 'Erlangen, Kreisfreie Stadt' },
		{ code: 'DE253', libelle: 'Fürth, Kreisfreie Stadt' },
		{ code: 'DE254', libelle: 'Nürnberg, Kreisfreie Stadt' },
		{ code: 'DE255', libelle: 'Schwabach, Kreisfreie Stadt' },
		{ code: 'DE256', libelle: 'Ansbach, Landkreis' },
		{ code: 'DE257', libelle: 'Erlangen-Höchstadt' },
		{ code: 'DE258', libelle: 'Fürth, Landkreis' },
		{ code: 'DE259', libelle: 'Nürnberger Land' },
		{ code: 'DE25A', libelle: 'Neustadt a. d. Aisch-Bad Windsheim' },
		{ code: 'DE25B', libelle: 'Roth' },
		{ code: 'DE25C', libelle: 'Weißenburg-Gunzenhausen' },
		{ code: 'DE26', libelle: 'Unterfranken' },
		{ code: 'DE261', libelle: 'Aschaffenburg, Kreisfreie Stadt' },
		{ code: 'DE262', libelle: 'Schweinfurt, Kreisfreie Stadt' },
		{ code: 'DE263', libelle: 'Würzburg, Kreisfreie Stadt' },
		{ code: 'DE264', libelle: 'Aschaffenburg, Landkreis' },
		{ code: 'DE265', libelle: 'Bad Kissingen' },
		{ code: 'DE266', libelle: 'Rhön-Grabfeld' },
		{ code: 'DE267', libelle: 'Haßberge' },
		{ code: 'DE268', libelle: 'Kitzingen' },
		{ code: 'DE269', libelle: 'Miltenberg' },
		{ code: 'DE26A', libelle: 'Main-Spessart' },
		{ code: 'DE26B', libelle: 'Schweinfurt, Landkreis' },
		{ code: 'DE26C', libelle: 'Würzburg, Landkreis' },
		{ code: 'DE27', libelle: 'Schwaben' },
		{ code: 'DE271', libelle: 'Augsburg, Kreisfreie Stadt' },
		{ code: 'DE272', libelle: 'Kaufbeuren, Kreisfreie Stadt' },
		{ code: 'DE273', libelle: 'Kempten (Allgäu), Kreisfreie Stadt' },
		{ code: 'DE274', libelle: 'Memmingen, Kreisfreie Stadt' },
		{ code: 'DE275', libelle: 'Aichach-Friedberg' },
		{ code: 'DE276', libelle: 'Augsburg, Landkreis' },
		{ code: 'DE277', libelle: 'Dillingen a.d. Donau' },
		{ code: 'DE278', libelle: 'Günzburg' },
		{ code: 'DE279', libelle: 'Neu-Ulm' },
		{ code: 'DE27A', libelle: 'Lindau (Bodensee)' },
		{ code: 'DE27B', libelle: 'Ostallgäu' },
		{ code: 'DE27C', libelle: 'Unterallgäu' },
		{ code: 'DE27D', libelle: 'Donau-Ries' },
		{ code: 'DE27E', libelle: 'Oberallgäu' },
		{ code: 'DE3', libelle: 'Berlin' },
		{ code: 'DE30', libelle: 'Berlin' },
		{ code: 'DE300', libelle: 'Berlin' },
		{ code: 'DE4', libelle: 'Brandenburg' },
		{ code: 'DE40', libelle: 'Brandenburg' },
		{ code: 'DE401', libelle: 'Brandenburg an der Havel, Kreisfreie Stadt' },
		{ code: 'DE402', libelle: 'Cottbus, Kreisfreie Stadt' },
		{ code: 'DE403', libelle: 'Frankfurt (Oder), Kreisfreie Stadt' },
		{ code: 'DE404', libelle: 'Potsdam, Kreisfreie Stadt' },
		{ code: 'DE405', libelle: 'Barnim' },
		{ code: 'DE406', libelle: 'Dahme-Spreewald' },
		{ code: 'DE407', libelle: 'Elbe-Elster' },
		{ code: 'DE408', libelle: 'Havelland' },
		{ code: 'DE409', libelle: 'Märkisch-Oderland' },
		{ code: 'DE40A', libelle: 'Oberhavel' },
		{ code: 'DE40B', libelle: 'Oberspreewald-Lausitz' },
		{ code: 'DE40C', libelle: 'Oder-Spree' },
		{ code: 'DE40D', libelle: 'Ostprignitz-Ruppin' },
		{ code: 'DE40E', libelle: 'Potsdam-Mittelmark' },
		{ code: 'DE40F', libelle: 'Prignitz' },
		{ code: 'DE40G', libelle: 'Spree-Neiße' },
		{ code: 'DE40H', libelle: 'Teltow-Fläming' },
		{ code: 'DE40I', libelle: 'Uckermark' },
		{ code: 'DE5', libelle: 'Bremen' },
		{ code: 'DE50', libelle: 'Bremen' },
		{ code: 'DE501', libelle: 'Bremen, Kreisfreie Stadt' },
		{ code: 'DE502', libelle: 'Bremerhaven, Kreisfreie Stadt' },
		{ code: 'DE6', libelle: 'Hamburg' },
		{ code: 'DE60', libelle: 'Hamburg' },
		{ code: 'DE600', libelle: 'Hamburg' },
		{ code: 'DE7', libelle: 'Hessen' },
		{ code: 'DE71', libelle: 'Darmstadt' },
		{ code: 'DE711', libelle: 'Darmstadt, Kreisfreie Stadt' },
		{ code: 'DE712', libelle: 'Frankfurt am Main, Kreisfreie Stadt' },
		{ code: 'DE713', libelle: 'Offenbach am Main, Kreisfreie Stadt' },
		{ code: 'DE714', libelle: 'Wiesbaden, Kreisfreie Stadt' },
		{ code: 'DE715', libelle: 'Bergstraße' },
		{ code: 'DE716', libelle: 'Darmstadt-Dieburg' },
		{ code: 'DE717', libelle: 'Groß-Gerau' },
		{ code: 'DE718', libelle: 'Hochtaunuskreis' },
		{ code: 'DE719', libelle: 'Main-Kinzig-Kreis' },
		{ code: 'DE71A', libelle: 'Main-Taunus-Kreis' },
		{ code: 'DE71B', libelle: 'Odenwaldkreis' },
		{ code: 'DE71C', libelle: 'Offenbach, Landkreis' },
		{ code: 'DE71D', libelle: 'Rheingau-Taunus-Kreis' },
		{ code: 'DE71E', libelle: 'Wetteraukreis' },
		{ code: 'DE72', libelle: 'Gießen' },
		{ code: 'DE721', libelle: 'Gießen, Landkreis' },
		{ code: 'DE722', libelle: 'Lahn-Dill-Kreis' },
		{ code: 'DE723', libelle: 'Limburg-Weilburg' },
		{ code: 'DE724', libelle: 'Marburg-Biedenkopf' },
		{ code: 'DE725', libelle: 'Vogelsbergkreis' },
		{ code: 'DE73', libelle: 'Kassel' },
		{ code: 'DE731', libelle: 'Kassel, Kreisfreie Stadt' },
		{ code: 'DE732', libelle: 'Fulda' },
		{ code: 'DE733', libelle: 'Hersfeld-Rotenburg' },
		{ code: 'DE734', libelle: 'Kassel, Landkreis' },
		{ code: 'DE735', libelle: 'Schwalm-Eder-Kreis' },
		{ code: 'DE736', libelle: 'Waldeck-Frankenberg' },
		{ code: 'DE737', libelle: 'Werra-Meißner-Kreis' },
		{ code: 'DE8', libelle: 'Mecklenburg-Vorpommern' },
		{ code: 'DE80', libelle: 'Mecklenburg-Vorpommern' },
		{ code: 'DE803', libelle: 'Rostock, Kreisfreie Stadt' },
		{ code: 'DE804', libelle: 'Schwerin, Kreisfreie Stadt' },
		{ code: 'DE80J', libelle: 'Mecklenburgische Seenplatte' },
		{ code: 'DE80K', libelle: 'Landkreis Rostock' },
		{ code: 'DE80L', libelle: 'Vorpommern-Rügen' },
		{ code: 'DE80M', libelle: 'Nordwestmecklenburg' },
		{ code: 'DE80N', libelle: 'Vorpommern-Greifswald' },
		{ code: 'DE80O', libelle: 'Ludwigslust-Parchim' },
		{ code: 'DE9', libelle: 'Niedersachsen' },
		{ code: 'DE91', libelle: 'Braunschweig' },
		{ code: 'DE911', libelle: 'Braunschweig, Kreisfreie Stadt' },
		{ code: 'DE912', libelle: 'Salzgitter, Kreisfreie Stadt' },
		{ code: 'DE913', libelle: 'Wolfsburg, Kreisfreie Stadt' },
		{ code: 'DE914', libelle: 'Gifhorn' },
		{ code: 'DE916', libelle: 'Goslar' },
		{ code: 'DE917', libelle: 'Helmstedt' },
		{ code: 'DE918', libelle: 'Northeim' },
		{ code: 'DE91A', libelle: 'Peine' },
		{ code: 'DE91B', libelle: 'Wolfenbüttel' },
		{ code: 'DE91C', libelle: 'Göttingen' },
		{ code: 'DE92', libelle: 'Hannover' },
		{ code: 'DE922', libelle: 'Diepholz' },
		{ code: 'DE923', libelle: 'Hameln-Pyrmont' },
		{ code: 'DE925', libelle: 'Hildesheim' },
		{ code: 'DE926', libelle: 'Holzminden' },
		{ code: 'DE927', libelle: 'Nienburg (Weser)' },
		{ code: 'DE928', libelle: 'Schaumburg' },
		{ code: 'DE929', libelle: 'Region Hannover' },
		{ code: 'DE93', libelle: 'Lüneburg' },
		{ code: 'DE931', libelle: 'Celle' },
		{ code: 'DE932', libelle: 'Cuxhaven' },
		{ code: 'DE933', libelle: 'Harburg' },
		{ code: 'DE934', libelle: 'Lüchow-Dannenberg' },
		{ code: 'DE935', libelle: 'Lüneburg, Landkreis' },
		{ code: 'DE936', libelle: 'Osterholz' },
		{ code: 'DE937', libelle: 'Rotenburg (Wümme)' },
		{ code: 'DE938', libelle: 'Heidekreis' },
		{ code: 'DE939', libelle: 'Stade' },
		{ code: 'DE93A', libelle: 'Uelzen' },
		{ code: 'DE93B', libelle: 'Verden' },
		{ code: 'DE94', libelle: 'Weser-Ems' },
		{ code: 'DE941', libelle: 'Delmenhorst, Kreisfreie Stadt' },
		{ code: 'DE942', libelle: 'Emden, Kreisfreie Stadt' },
		{ code: 'DE943', libelle: 'Oldenburg (Oldenburg), Kreisfreie Stadt' },
		{ code: 'DE944', libelle: 'Osnabrück, Kreisfreie Stadt' },
		{ code: 'DE945', libelle: 'Wilhelmshaven, Kreisfreie Stadt' },
		{ code: 'DE946', libelle: 'Ammerland' },
		{ code: 'DE947', libelle: 'Aurich' },
		{ code: 'DE948', libelle: 'Cloppenburg' },
		{ code: 'DE949', libelle: 'Emsland' },
		{ code: 'DE94A', libelle: 'Friesland (DE)' },
		{ code: 'DE94B', libelle: 'Grafschaft Bentheim' },
		{ code: 'DE94C', libelle: 'Leer' },
		{ code: 'DE94D', libelle: 'Oldenburg, Landkreis' },
		{ code: 'DE94E', libelle: 'Osnabrück, Landkreis' },
		{ code: 'DE94F', libelle: 'Vechta' },
		{ code: 'DE94G', libelle: 'Wesermarsch' },
		{ code: 'DE94H', libelle: 'Wittmund' },
		{ code: 'DEA', libelle: 'Nordrhein-Westfalen' },
		{ code: 'DEA1', libelle: 'Düsseldorf' },
		{ code: 'DEA11', libelle: 'Düsseldorf, Kreisfreie Stadt' },
		{ code: 'DEA12', libelle: 'Duisburg, Kreisfreie Stadt' },
		{ code: 'DEA13', libelle: 'Essen, Kreisfreie Stadt' },
		{ code: 'DEA14', libelle: 'Krefeld, Kreisfreie Stadt' },
		{ code: 'DEA15', libelle: 'Mönchengladbach, Kreisfreie Stadt' },
		{ code: 'DEA16', libelle: 'Mülheim an der Ruhr, Kreisfreie Stadt' },
		{ code: 'DEA17', libelle: 'Oberhausen, Kreisfreie Stadt' },
		{ code: 'DEA18', libelle: 'Remscheid, Kreisfreie Stadt' },
		{ code: 'DEA19', libelle: 'Solingen, Kreisfreie Stadt' },
		{ code: 'DEA1A', libelle: 'Wuppertal, Kreisfreie Stadt' },
		{ code: 'DEA1B', libelle: 'Kleve' },
		{ code: 'DEA1C', libelle: 'Mettmann' },
		{ code: 'DEA1D', libelle: 'Rhein-Kreis Neuss' },
		{ code: 'DEA1E', libelle: 'Viersen' },
		{ code: 'DEA1F', libelle: 'Wesel' },
		{ code: 'DEA2', libelle: 'Köln' },
		{ code: 'DEA22', libelle: 'Bonn, Kreisfreie Stadt' },
		{ code: 'DEA23', libelle: 'Köln, Kreisfreie Stadt' },
		{ code: 'DEA24', libelle: 'Leverkusen, Kreisfreie Stadt' },
		{ code: 'DEA26', libelle: 'Düren' },
		{ code: 'DEA27', libelle: 'Rhein-Erft-Kreis' },
		{ code: 'DEA28', libelle: 'Euskirchen' },
		{ code: 'DEA29', libelle: 'Heinsberg' },
		{ code: 'DEA2A', libelle: 'Oberbergischer Kreis' },
		{ code: 'DEA2B', libelle: 'Rheinisch-Bergischer Kreis' },
		{ code: 'DEA2C', libelle: 'Rhein-Sieg-Kreis' },
		{ code: 'DEA2D', libelle: 'Städteregion Aachen' },
		{ code: 'DEA3', libelle: 'Münster' },
		{ code: 'DEA31', libelle: 'Bottrop, Kreisfreie Stadt' },
		{ code: 'DEA32', libelle: 'Gelsenkirchen, Kreisfreie Stadt' },
		{ code: 'DEA33', libelle: 'Münster, Kreisfreie Stadt' },
		{ code: 'DEA34', libelle: 'Borken' },
		{ code: 'DEA35', libelle: 'Coesfeld' },
		{ code: 'DEA36', libelle: 'Recklinghausen' },
		{ code: 'DEA37', libelle: 'Steinfurt' },
		{ code: 'DEA38', libelle: 'Warendorf' },
		{ code: 'DEA4', libelle: 'Detmold' },
		{ code: 'DEA41', libelle: 'Bielefeld, Kreisfreie Stadt' },
		{ code: 'DEA42', libelle: 'Gütersloh' },
		{ code: 'DEA43', libelle: 'Herford' },
		{ code: 'DEA44', libelle: 'Höxter' },
		{ code: 'DEA45', libelle: 'Lippe' },
		{ code: 'DEA46', libelle: 'Minden-Lübbecke' },
		{ code: 'DEA47', libelle: 'Paderborn' },
		{ code: 'DEA5', libelle: 'Arnsberg' },
		{ code: 'DEA51', libelle: 'Bochum, Kreisfreie Stadt' },
		{ code: 'DEA52', libelle: 'Dortmund, Kreisfreie Stadt' },
		{ code: 'DEA53', libelle: 'Hagen, Kreisfreie Stadt' },
		{ code: 'DEA54', libelle: 'Hamm, Kreisfreie Stadt' },
		{ code: 'DEA55', libelle: 'Herne, Kreisfreie Stadt' },
		{ code: 'DEA56', libelle: 'Ennepe-Ruhr-Kreis' },
		{ code: 'DEA57', libelle: 'Hochsauerlandkreis' },
		{ code: 'DEA58', libelle: 'Märkischer Kreis' },
		{ code: 'DEA59', libelle: 'Olpe' },
		{ code: 'DEA5A', libelle: 'Siegen-Wittgenstein' },
		{ code: 'DEA5B', libelle: 'Soest' },
		{ code: 'DEA5C', libelle: 'Unna' },
		{ code: 'DEB', libelle: 'Rheinland-Pfalz' },
		{ code: 'DEB1', libelle: 'Koblenz' },
		{ code: 'DEB11', libelle: 'Koblenz, Kreisfreie Stadt' },
		{ code: 'DEB12', libelle: 'Ahrweiler' },
		{ code: 'DEB13', libelle: 'Altenkirchen (Westerwald)' },
		{ code: 'DEB14', libelle: 'Bad Kreuznach' },
		{ code: 'DEB15', libelle: 'Birkenfeld' },
		{ code: 'DEB17', libelle: 'Mayen-Koblenz' },
		{ code: 'DEB18', libelle: 'Neuwied' },
		{ code: 'DEB1A', libelle: 'Rhein-Lahn-Kreis' },
		{ code: 'DEB1B', libelle: 'Westerwaldkreis' },
		{ code: 'DEB1C', libelle: 'Cochem-Zell' },
		{ code: 'DEB1D', libelle: 'Rhein-Hunsrück-Kreis' },
		{ code: 'DEB2', libelle: 'Trier' },
		{ code: 'DEB21', libelle: 'Trier, Kreisfreie Stadt' },
		{ code: 'DEB22', libelle: 'Bernkastel-Wittlich' },
		{ code: 'DEB23', libelle: 'Eifelkreis Bitburg-Prüm' },
		{ code: 'DEB24', libelle: 'Vulkaneifel' },
		{ code: 'DEB25', libelle: 'Trier-Saarburg' },
		{ code: 'DEB3', libelle: 'Rheinhessen-Pfalz' },
		{ code: 'DEB31', libelle: 'Frankenthal (Pfalz), Kreisfreie Stadt' },
		{ code: 'DEB32', libelle: 'Kaiserslautern, Kreisfreie Stadt' },
		{ code: 'DEB33', libelle: 'Landau in der Pfalz, Kreisfreie Stadt' },
		{ code: 'DEB34', libelle: 'Ludwigshafen am Rhein, Kreisfreie Stadt' },
		{ code: 'DEB35', libelle: 'Mainz, Kreisfreie Stadt' },
		{ code: 'DEB36', libelle: 'Neustadt an der Weinstraße, Kreisfreie Stadt' },
		{ code: 'DEB37', libelle: 'Pirmasens, Kreisfreie Stadt' },
		{ code: 'DEB38', libelle: 'Speyer, Kreisfreie Stadt' },
		{ code: 'DEB39', libelle: 'Worms, Kreisfreie Stadt' },
		{ code: 'DEB3A', libelle: 'Zweibrücken, Kreisfreie Stadt' },
		{ code: 'DEB3B', libelle: 'Alzey-Worms' },
		{ code: 'DEB3C', libelle: 'Bad Dürkheim' },
		{ code: 'DEB3D', libelle: 'Donnersbergkreis' },
		{ code: 'DEB3E', libelle: 'Germersheim' },
		{ code: 'DEB3F', libelle: 'Kaiserslautern, Landkreis' },
		{ code: 'DEB3G', libelle: 'Kusel' },
		{ code: 'DEB3H', libelle: 'Südliche Weinstraße' },
		{ code: 'DEB3I', libelle: 'Rhein-Pfalz-Kreis' },
		{ code: 'DEB3J', libelle: 'Mainz-Bingen' },
		{ code: 'DEB3K', libelle: 'Südwestpfalz' },
		{ code: 'DEC', libelle: 'Saarland' },
		{ code: 'DEC0', libelle: 'Saarland' },
		{ code: 'DEC01', libelle: 'Regionalverband Saarbrücken' },
		{ code: 'DEC02', libelle: 'Merzig-Wadern' },
		{ code: 'DEC03', libelle: 'Neunkirchen' },
		{ code: 'DEC04', libelle: 'Saarlouis' },
		{ code: 'DEC05', libelle: 'Saarpfalz-Kreis' },
		{ code: 'DEC06', libelle: 'St. Wendel' },
		{ code: 'DED', libelle: 'Sachsen' },
		{ code: 'DED2', libelle: 'Dresden' },
		{ code: 'DED21', libelle: 'Dresden, Kreisfreie Stadt' },
		{ code: 'DED2C', libelle: 'Bautzen' },
		{ code: 'DED2D', libelle: 'Görlitz' },
		{ code: 'DED2E', libelle: 'Meißen' },
		{ code: 'DED2F', libelle: 'Sächsische Schweiz-Osterzgebirge' },
		{ code: 'DED4', libelle: 'Chemnitz' },
		{ code: 'DED41', libelle: 'Chemnitz, Kreisfreie Stadt' },
		{ code: 'DED42', libelle: 'Erzgebirgskreis' },
		{ code: 'DED43', libelle: 'Mittelsachsen' },
		{ code: 'DED44', libelle: 'Vogtlandkreis' },
		{ code: 'DED45', libelle: 'Zwickau' },
		{ code: 'DED5', libelle: 'Leipzig' },
		{ code: 'DED51', libelle: 'Leipzig, Kreisfreie Stadt' },
		{ code: 'DED52', libelle: 'Leipzig' },
		{ code: 'DED53', libelle: 'Nordsachsen' },
		{ code: 'DEE', libelle: 'Sachsen-Anhalt' },
		{ code: 'DEE0', libelle: 'Sachsen-Anhalt' },
		{ code: 'DEE01', libelle: 'Dessau-Roßlau, Kreisfreie Stadt' },
		{ code: 'DEE02', libelle: 'Halle (Saale), Kreisfreie Stadt' },
		{ code: 'DEE03', libelle: 'Magdeburg, Kreisfreie Stadt' },
		{ code: 'DEE04', libelle: 'Altmarkkreis Salzwedel' },
		{ code: 'DEE05', libelle: 'Anhalt-Bitterfeld' },
		{ code: 'DEE06', libelle: 'Jerichower Land' },
		{ code: 'DEE07', libelle: 'Börde' },
		{ code: 'DEE08', libelle: 'Burgenlandkreis' },
		{ code: 'DEE09', libelle: 'Harz' },
		{ code: 'DEE0A', libelle: 'Mansfeld-Südharz' },
		{ code: 'DEE0B', libelle: 'Saalekreis' },
		{ code: 'DEE0C', libelle: 'Salzlandkreis' },
		{ code: 'DEE0D', libelle: 'Stendal' },
		{ code: 'DEE0E', libelle: 'Wittenberg' },
		{ code: 'DEF', libelle: 'Schleswig-Holstein' },
		{ code: 'DEF0', libelle: 'Schleswig-Holstein' },
		{ code: 'DEF01', libelle: 'Flensburg, Kreisfreie Stadt' },
		{ code: 'DEF02', libelle: 'Kiel, Kreisfreie Stadt' },
		{ code: 'DEF03', libelle: 'Lübeck, Kreisfreie Stadt' },
		{ code: 'DEF04', libelle: 'Neumünster, Kreisfreie Stadt' },
		{ code: 'DEF05', libelle: 'Dithmarschen' },
		{ code: 'DEF06', libelle: 'Herzogtum Lauenburg' },
		{ code: 'DEF07', libelle: 'Nordfriesland' },
		{ code: 'DEF08', libelle: 'Ostholstein' },
		{ code: 'DEF09', libelle: 'Pinneberg' },
		{ code: 'DEF0A', libelle: 'Plön' },
		{ code: 'DEF0B', libelle: 'Rendsburg-Eckernförde' },
		{ code: 'DEF0C', libelle: 'Schleswig-Flensburg' },
		{ code: 'DEF0D', libelle: 'Segeberg' },
		{ code: 'DEF0E', libelle: 'Steinburg' },
		{ code: 'DEF0F', libelle: 'Stormarn' },
		{ code: 'DEG', libelle: 'Thüringen' },
		{ code: 'DEG0', libelle: 'Thüringen' },
		{ code: 'DEG01', libelle: 'Erfurt, Kreisfreie Stadt' },
		{ code: 'DEG02', libelle: 'Gera, Kreisfreie Stadt' },
		{ code: 'DEG03', libelle: 'Jena, Kreisfreie Stadt' },
		{ code: 'DEG04', libelle: 'Suhl, Kreisfreie Stadt' },
		{ code: 'DEG05', libelle: 'Weimar, Kreisfreie Stadt' },
		{ code: 'DEG06', libelle: 'Eichsfeld' },
		{ code: 'DEG07', libelle: 'Nordhausen' },
		{ code: 'DEG09', libelle: 'Unstrut-Hainich-Kreis' },
		{ code: 'DEG0A', libelle: 'Kyffhäuserkreis' },
		{ code: 'DEG0B', libelle: 'Schmalkalden-Meiningen' },
		{ code: 'DEG0C', libelle: 'Gotha' },
		{ code: 'DEG0D', libelle: 'Sömmerda' },
		{ code: 'DEG0E', libelle: 'Hildburghausen' },
		{ code: 'DEG0F', libelle: 'Ilm-Kreis' },
		{ code: 'DEG0G', libelle: 'Weimarer Land' },
		{ code: 'DEG0H', libelle: 'Sonneberg' },
		{ code: 'DEG0I', libelle: 'Saalfeld-Rudolstadt' },
		{ code: 'DEG0J', libelle: 'Saale-Holzland-Kreis' },
		{ code: 'DEG0K', libelle: 'Saale-Orla-Kreis' },
		{ code: 'DEG0L', libelle: 'Greiz' },
		{ code: 'DEG0M', libelle: 'Altenburger Land' },
		{ code: 'DEG0N', libelle: 'Eisenach, Kreisfreie Stadt' },
		{ code: 'DEG0P', libelle: 'Wartburgkreis' },
		{ code: 'DEZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'DEZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'DEZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'EE', libelle: 'Eesti' },
		{ code: 'EE0', libelle: 'Eesti' },
		{ code: 'EE00', libelle: 'Eesti' },
		{ code: 'EE001', libelle: 'Põhja-Eesti' },
		{ code: 'EE004', libelle: 'Lääne-Eesti' },
		{ code: 'EE008', libelle: 'Lõuna-Eesti' },
		{ code: 'EE009', libelle: 'Kesk-Eesti' },
		{ code: 'EE00A', libelle: 'Kirde-Eesti' },
		{ code: 'EEZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'EEZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'EEZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'IE', libelle: 'Éire/Ireland' },
		{ code: 'IE0', libelle: 'Ireland' },
		{ code: 'IE04', libelle: 'Northern and Western' },
		{ code: 'IE041', libelle: 'Border' },
		{ code: 'IE042', libelle: 'West' },
		{ code: 'IE05', libelle: 'Southern' },
		{ code: 'IE051', libelle: 'Mid-West ' },
		{ code: 'IE052', libelle: 'South-East ' },
		{ code: 'IE053', libelle: 'South-West ' },
		{ code: 'IE06', libelle: 'Eastern and Midland' },
		{ code: 'IE061', libelle: 'Dublin' },
		{ code: 'IE062', libelle: 'Mid-East' },
		{ code: 'IE063', libelle: 'Midland' },
		{ code: 'IEZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'IEZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'IEZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'EL', libelle: 'Ελλάδα ' },
		{ code: 'EL3', libelle: 'Αττική ' },
		{ code: 'EL30', libelle: 'Aττική' },
		{ code: 'EL301', libelle: 'Βόρειος Τομέας Αθηνών' },
		{ code: 'EL302', libelle: 'Δυτικός Τομέας Αθηνών' },
		{ code: 'EL303', libelle: 'Κεντρικός Τομέας Αθηνών' },
		{ code: 'EL304', libelle: 'Νότιος Τομέας Αθηνών' },
		{ code: 'EL305', libelle: 'Ανατολική Αττική' },
		{ code: 'EL306', libelle: 'Δυτική Αττική' },
		{ code: 'EL307', libelle: 'Πειραιάς, Νήσοι' },
		{ code: 'EL4', libelle: 'Νησιά Αιγαίου, Κρήτη' },
		{ code: 'EL41', libelle: 'Βόρειο Αιγαίο' },
		{ code: 'EL411', libelle: 'Λέσβος, Λήμνος' },
		{ code: 'EL412', libelle: 'Ικαρία, Σάμος' },
		{ code: 'EL413', libelle: 'Χίος' },
		{ code: 'EL42', libelle: 'Νότιο Αιγαίο' },
		{ code: 'EL421', libelle: 'Κάλυμνος, Κάρπαθος – Ηρωική Νήσος Κάσος, Κως, Ρόδος' },
		{ code: 'EL422', libelle: 'Άνδρος, Θήρα, Κέα, Μήλος, Μύκονος, Νάξος, Πάρος, Σύρος, Τήνος' },
		{ code: 'EL43', libelle: 'Κρήτη' },
		{ code: 'EL431', libelle: 'Ηράκλειο' },
		{ code: 'EL432', libelle: 'Λασίθι' },
		{ code: 'EL433', libelle: 'Ρέθυμνο' },
		{ code: 'EL434', libelle: 'Χανιά' },
		{ code: 'EL5', libelle: 'Βόρεια Ελλάδα' },
		{ code: 'EL51', libelle: 'Aνατολική Μακεδονία, Θράκη' },
		{ code: 'EL511', libelle: 'Έβρος' },
		{ code: 'EL512', libelle: 'Ξάνθη' },
		{ code: 'EL513', libelle: 'Ροδόπη' },
		{ code: 'EL514', libelle: 'Δράμα' },
		{ code: 'EL515', libelle: 'Θάσος, Καβάλα' },
		{ code: 'EL52', libelle: 'Κεντρική Μακεδονία' },
		{ code: 'EL521', libelle: 'Ημαθία' },
		{ code: 'EL522', libelle: 'Θεσσαλονίκη' },
		{ code: 'EL523', libelle: 'Κιλκίς' },
		{ code: 'EL524', libelle: 'Πέλλα' },
		{ code: 'EL525', libelle: 'Πιερία' },
		{ code: 'EL526', libelle: 'Σέρρες' },
		{ code: 'EL527', libelle: 'Χαλκιδική' },
		{ code: 'EL53', libelle: 'Δυτική Μακεδονία' },
		{ code: 'EL531', libelle: 'Γρεβενά, Κοζάνη' },
		{ code: 'EL532', libelle: 'Καστοριά' },
		{ code: 'EL533', libelle: 'Φλώρινα' },
		{ code: 'EL54', libelle: 'Ήπειρος' },
		{ code: 'EL541', libelle: 'Άρτα, Πρέβεζα' },
		{ code: 'EL542', libelle: 'Θεσπρωτία' },
		{ code: 'EL543', libelle: 'Ιωάννινα' },
		{ code: 'EL6', libelle: 'Κεντρική Ελλάδα' },
		{ code: 'EL61', libelle: 'Θεσσαλία' },
		{ code: 'EL611', libelle: 'Καρδίτσα, Τρίκαλα' },
		{ code: 'EL612', libelle: 'Λάρισα' },
		{ code: 'EL613', libelle: 'Μαγνησία, Σποράδες' },
		{ code: 'EL62', libelle: 'Ιόνια Νησιά' },
		{ code: 'EL621', libelle: 'Ζάκυνθος' },
		{ code: 'EL622', libelle: 'Κέρκυρα' },
		{ code: 'EL623', libelle: 'Ιθάκη, Κεφαλληνία' },
		{ code: 'EL624', libelle: 'Λευκάδα' },
		{ code: 'EL63', libelle: 'Δυτική Ελλάδα' },
		{ code: 'EL631', libelle: 'Αιτωλοακαρνανία' },
		{ code: 'EL632', libelle: 'Αχαΐα' },
		{ code: 'EL633', libelle: 'Ηλεία' },
		{ code: 'EL64', libelle: 'Στερεά Ελλάδα' },
		{ code: 'EL641', libelle: 'Βοιωτία' },
		{ code: 'EL642', libelle: 'Εύβοια' },
		{ code: 'EL643', libelle: 'Ευρυτανία' },
		{ code: 'EL644', libelle: 'Φθιώτιδα' },
		{ code: 'EL645', libelle: 'Φωκίδα' },
		{ code: 'EL65', libelle: 'Πελοπόννησος' },
		{ code: 'EL651', libelle: 'Αργολίδα, Αρκαδία' },
		{ code: 'EL652', libelle: 'Κορινθία' },
		{ code: 'EL653', libelle: 'Λακωνία, Μεσσηνία' },
		{ code: 'ELZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'ELZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'ELZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'ES', libelle: 'España' },
		{ code: 'ES1', libelle: 'Noroeste' },
		{ code: 'ES11', libelle: 'Galicia' },
		{ code: 'ES111', libelle: 'A Coruña' },
		{ code: 'ES112', libelle: 'Lugo' },
		{ code: 'ES113', libelle: 'Ourense' },
		{ code: 'ES114', libelle: 'Pontevedra' },
		{ code: 'ES12', libelle: 'Principado de Asturias' },
		{ code: 'ES120', libelle: 'Asturias' },
		{ code: 'ES13', libelle: 'Cantabria' },
		{ code: 'ES130', libelle: 'Cantabria' },
		{ code: 'ES2', libelle: 'Noreste' },
		{ code: 'ES21', libelle: 'País Vasco' },
		{ code: 'ES211', libelle: 'Araba/Álava' },
		{ code: 'ES212', libelle: 'Gipuzkoa' },
		{ code: 'ES213', libelle: 'Bizkaia' },
		{ code: 'ES22', libelle: 'Comunidad Foral de Navarra' },
		{ code: 'ES220', libelle: 'Navarra' },
		{ code: 'ES23', libelle: 'La Rioja' },
		{ code: 'ES230', libelle: 'La Rioja' },
		{ code: 'ES24', libelle: 'Aragón' },
		{ code: 'ES241', libelle: 'Huesca' },
		{ code: 'ES242', libelle: 'Teruel' },
		{ code: 'ES243', libelle: 'Zaragoza' },
		{ code: 'ES3', libelle: 'Comunidad de Madrid' },
		{ code: 'ES30', libelle: 'Comunidad de Madrid' },
		{ code: 'ES300', libelle: 'Madrid' },
		{ code: 'ES4', libelle: 'Centro (ES)' },
		{ code: 'ES41', libelle: 'Castilla y León' },
		{ code: 'ES411', libelle: 'Ávila' },
		{ code: 'ES412', libelle: 'Burgos' },
		{ code: 'ES413', libelle: 'León' },
		{ code: 'ES414', libelle: 'Palencia' },
		{ code: 'ES415', libelle: 'Salamanca' },
		{ code: 'ES416', libelle: 'Segovia' },
		{ code: 'ES417', libelle: 'Soria' },
		{ code: 'ES418', libelle: 'Valladolid' },
		{ code: 'ES419', libelle: 'Zamora' },
		{ code: 'ES42', libelle: 'Castilla-La Mancha' },
		{ code: 'ES421', libelle: 'Albacete' },
		{ code: 'ES422', libelle: 'Ciudad Real' },
		{ code: 'ES423', libelle: 'Cuenca' },
		{ code: 'ES424', libelle: 'Guadalajara' },
		{ code: 'ES425', libelle: 'Toledo' },
		{ code: 'ES43', libelle: 'Extremadura' },
		{ code: 'ES431', libelle: 'Badajoz' },
		{ code: 'ES432', libelle: 'Cáceres' },
		{ code: 'ES5', libelle: 'Este' },
		{ code: 'ES51', libelle: 'Cataluña' },
		{ code: 'ES511', libelle: 'Barcelona' },
		{ code: 'ES512', libelle: 'Girona' },
		{ code: 'ES513', libelle: 'Lleida' },
		{ code: 'ES514', libelle: 'Tarragona' },
		{ code: 'ES52', libelle: 'Comunitat Valenciana ' },
		{ code: 'ES521', libelle: 'Alicante/Alacant' },
		{ code: 'ES522', libelle: 'Castellón/Castelló' },
		{ code: 'ES523', libelle: 'Valencia/València' },
		{ code: 'ES53', libelle: 'Illes Balears' },
		{ code: 'ES531', libelle: 'Eivissa y Formentera' },
		{ code: 'ES532', libelle: 'Mallorca' },
		{ code: 'ES533', libelle: 'Menorca' },
		{ code: 'ES6', libelle: 'Sur' },
		{ code: 'ES61', libelle: 'Andalucía' },
		{ code: 'ES611', libelle: 'Almería' },
		{ code: 'ES612', libelle: 'Cádiz' },
		{ code: 'ES613', libelle: 'Córdoba' },
		{ code: 'ES614', libelle: 'Granada' },
		{ code: 'ES615', libelle: 'Huelva' },
		{ code: 'ES616', libelle: 'Jaén' },
		{ code: 'ES617', libelle: 'Málaga' },
		{ code: 'ES618', libelle: 'Sevilla' },
		{ code: 'ES62', libelle: 'Región de Murcia' },
		{ code: 'ES620', libelle: 'Murcia' },
		{ code: 'ES63', libelle: 'Ciudad de Ceuta' },
		{ code: 'ES630', libelle: 'Ceuta' },
		{ code: 'ES64', libelle: 'Ciudad de Melilla' },
		{ code: 'ES640', libelle: 'Melilla' },
		{ code: 'ES7', libelle: 'Canarias' },
		{ code: 'ES70', libelle: 'Canarias' },
		{ code: 'ES703', libelle: 'El Hierro' },
		{ code: 'ES704', libelle: 'Fuerteventura' },
		{ code: 'ES705', libelle: 'Gran Canaria' },
		{ code: 'ES706', libelle: 'La Gomera' },
		{ code: 'ES707', libelle: 'La Palma' },
		{ code: 'ES708', libelle: 'Lanzarote' },
		{ code: 'ES709', libelle: 'Tenerife' },
		{ code: 'ESZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'ESZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'ESZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'FR', libelle: 'France' },
		{ code: 'FR1', libelle: 'Ile-de-France' },
		{ code: 'FR10', libelle: 'Ile-de-France' },
		{ code: 'FR101', libelle: 'Paris' },
		{ code: 'FR102', libelle: 'Seine-et-Marne ' },
		{ code: 'FR103', libelle: 'Yvelines ' },
		{ code: 'FR104', libelle: 'Essonne' },
		{ code: 'FR105', libelle: 'Hauts-de-Seine ' },
		{ code: 'FR106', libelle: 'Seine-Saint-Denis ' },
		{ code: 'FR107', libelle: 'Val-de-Marne' },
		{ code: 'FR108', libelle: 'Val-d’Oise' },
		{ code: 'FRB', libelle: 'Centre — Val de Loire' },
		{ code: 'FRB0', libelle: 'Centre — Val de Loire' },
		{ code: 'FRB01', libelle: 'Cher' },
		{ code: 'FRB02', libelle: 'Eure-et-Loir' },
		{ code: 'FRB03', libelle: 'Indre' },
		{ code: 'FRB04', libelle: 'Indre-et-Loire' },
		{ code: 'FRB05', libelle: 'Loir-et-Cher' },
		{ code: 'FRB06', libelle: 'Loiret' },
		{ code: 'FRC', libelle: 'Bourgogne-Franche-Comté' },
		{ code: 'FRC1', libelle: 'Bourgogne' },
		{ code: 'FRC11', libelle: 'Côte-d’Or' },
		{ code: 'FRC12', libelle: 'Nièvre' },
		{ code: 'FRC13', libelle: 'Saône-et-Loire' },
		{ code: 'FRC14', libelle: 'Yonne' },
		{ code: 'FRC2', libelle: 'Franche-Comté' },
		{ code: 'FRC21', libelle: 'Doubs' },
		{ code: 'FRC22', libelle: 'Jura' },
		{ code: 'FRC23', libelle: 'Haute-Saône' },
		{ code: 'FRC24', libelle: 'Territoire de Belfort' },
		{ code: 'FRD', libelle: 'Normandie' },
		{ code: 'FRD1', libelle: 'Basse-Normandie ' },
		{ code: 'FRD11', libelle: 'Calvados ' },
		{ code: 'FRD12', libelle: 'Manche ' },
		{ code: 'FRD13', libelle: 'Orne' },
		{ code: 'FRD2', libelle: 'Haute-Normandie ' },
		{ code: 'FRD21', libelle: 'Eure' },
		{ code: 'FRD22', libelle: 'Seine-Maritime' },
		{ code: 'FRE', libelle: 'Hauts-de-France' },
		{ code: 'FRE1', libelle: 'Nord-Pas de Calais' },
		{ code: 'FRE11', libelle: 'Nord' },
		{ code: 'FRE12', libelle: 'Pas-de-Calais' },
		{ code: 'FRE2', libelle: 'Picardie' },
		{ code: 'FRE21', libelle: 'Aisne' },
		{ code: 'FRE22', libelle: 'Oise' },
		{ code: 'FRE23', libelle: 'Somme' },
		{ code: 'FRF', libelle: 'Grand Est' },
		{ code: 'FRF1', libelle: 'Alsace' },
		{ code: 'FRF11', libelle: 'Bas-Rhin' },
		{ code: 'FRF12', libelle: 'Haut-Rhin' },
		{ code: 'FRF2', libelle: 'Champagne-Ardenne' },
		{ code: 'FRF21', libelle: 'Ardennes' },
		{ code: 'FRF22', libelle: 'Aube' },
		{ code: 'FRF23', libelle: 'Marne' },
		{ code: 'FRF24', libelle: 'Haute-Marne' },
		{ code: 'FRF3', libelle: 'Lorraine' },
		{ code: 'FRF31', libelle: 'Meurthe-et-Moselle ' },
		{ code: 'FRF32', libelle: 'Meuse ' },
		{ code: 'FRF33', libelle: 'Moselle' },
		{ code: 'FRF34', libelle: 'Vosges' },
		{ code: 'FRG', libelle: 'Pays de la Loire' },
		{ code: 'FRG0', libelle: 'Pays de la Loire' },
		{ code: 'FRG01', libelle: 'Loire-Atlantique' },
		{ code: 'FRG02', libelle: 'Maine-et-Loire' },
		{ code: 'FRG03', libelle: 'Mayenne' },
		{ code: 'FRG04', libelle: 'Sarthe' },
		{ code: 'FRG05', libelle: 'Vendée' },
		{ code: 'FRH', libelle: 'Bretagne' },
		{ code: 'FRH0', libelle: 'Bretagne' },
		{ code: 'FRH01', libelle: 'Côtes-d’Armor' },
		{ code: 'FRH02', libelle: 'Finistère' },
		{ code: 'FRH03', libelle: 'Ille-et-Vilaine' },
		{ code: 'FRH04', libelle: 'Morbihan' },
		{ code: 'FRI', libelle: 'Nouvelle-Aquitaine' },
		{ code: 'FRI1', libelle: 'Aquitaine' },
		{ code: 'FRI11', libelle: 'Dordogne' },
		{ code: 'FRI12', libelle: 'Gironde' },
		{ code: 'FRI13', libelle: 'Landes' },
		{ code: 'FRI14', libelle: 'Lot-et-Garonne' },
		{ code: 'FRI15', libelle: 'Pyrénées-Atlantiques' },
		{ code: 'FRI2', libelle: 'Limousin' },
		{ code: 'FRI21', libelle: 'Corrèze' },
		{ code: 'FRI22', libelle: 'Creuse' },
		{ code: 'FRI23', libelle: 'Haute-Vienne' },
		{ code: 'FRI3', libelle: 'Poitou-Charentes' },
		{ code: 'FRI31', libelle: 'Charente' },
		{ code: 'FRI32', libelle: 'Charente-Maritime' },
		{ code: 'FRI33', libelle: 'Deux-Sèvres' },
		{ code: 'FRI34', libelle: 'Vienne' },
		{ code: 'FRJ', libelle: 'Occitanie' },
		{ code: 'FRJ1', libelle: 'Languedoc-Roussillon' },
		{ code: 'FRJ11', libelle: 'Aude' },
		{ code: 'FRJ12', libelle: 'Gard' },
		{ code: 'FRJ13', libelle: 'Hérault' },
		{ code: 'FRJ14', libelle: 'Lozère' },
		{ code: 'FRJ15', libelle: 'Pyrénées-Orientales' },
		{ code: 'FRJ2', libelle: 'Midi-Pyrénées' },
		{ code: 'FRJ21', libelle: 'Ariège' },
		{ code: 'FRJ22', libelle: 'Aveyron' },
		{ code: 'FRJ23', libelle: 'Haute-Garonne' },
		{ code: 'FRJ24', libelle: 'Gers' },
		{ code: 'FRJ25', libelle: 'Lot' },
		{ code: 'FRJ26', libelle: 'Hautes-Pyrénées ' },
		{ code: 'FRJ27', libelle: 'Tarn' },
		{ code: 'FRJ28', libelle: 'Tarn-et-Garonne' },
		{ code: 'FRK', libelle: 'Auvergne-Rhône-Alpes' },
		{ code: 'FRK1', libelle: 'Auvergne' },
		{ code: 'FRK11', libelle: 'Allier' },
		{ code: 'FRK12', libelle: 'Cantal' },
		{ code: 'FRK13', libelle: 'Haute-Loire' },
		{ code: 'FRK14', libelle: 'Puy-de-Dôme' },
		{ code: 'FRK2', libelle: 'Rhône-Alpes' },
		{ code: 'FRK21', libelle: 'Ain' },
		{ code: 'FRK22', libelle: 'Ardèche' },
		{ code: 'FRK23', libelle: 'Drôme' },
		{ code: 'FRK24', libelle: 'Isère' },
		{ code: 'FRK25', libelle: 'Loire' },
		{ code: 'FRK26', libelle: 'Rhône' },
		{ code: 'FRK27', libelle: 'Savoie' },
		{ code: 'FRK28', libelle: 'Haute-Savoie' },
		{ code: 'FRL', libelle: 'Provence-Alpes-Côte d’Azur' },
		{ code: 'FRL0', libelle: 'Provence-Alpes-Côte d’Azur' },
		{ code: 'FRL01', libelle: 'Alpes-de-Haute-Provence' },
		{ code: 'FRL02', libelle: 'Hautes-Alpes ' },
		{ code: 'FRL03', libelle: 'Alpes-Maritimes' },
		{ code: 'FRL04', libelle: 'Bouches-du-Rhône' },
		{ code: 'FRL05', libelle: 'Var' },
		{ code: 'FRL06', libelle: 'Vaucluse' },
		{ code: 'FRM', libelle: 'Corse' },
		{ code: 'FRM0', libelle: 'Corse' },
		{ code: 'FRM01', libelle: 'Corse-du-Sud' },
		{ code: 'FRM02', libelle: 'Haute-Corse' },
		{ code: 'FRY', libelle: 'RUP FR — Régions Ultrapériphériques Françaises' },
		{ code: 'FRY1', libelle: 'Guadeloupe' },
		{ code: 'FRY10', libelle: 'Guadeloupe' },
		{ code: 'FRY2', libelle: 'Martinique ' },
		{ code: 'FRY20', libelle: 'Martinique ' },
		{ code: 'FRY3', libelle: 'Guyane' },
		{ code: 'FRY30', libelle: 'Guyane' },
		{ code: 'FRY4', libelle: 'La Réunion ' },
		{ code: 'FRY40', libelle: 'La Réunion' },
		{ code: 'FRY5', libelle: 'Mayotte' },
		{ code: 'FRY50', libelle: 'Mayotte ' },
		{ code: 'FRZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'FRZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'FRZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'HR', libelle: 'Hrvatska' },
		{ code: 'HR0', libelle: 'Hrvatska' },
		{ code: 'HR02', libelle: 'Panonska Hrvatska' },
		{ code: 'HR021', libelle: 'Bjelovarsko-bilogorska županija' },
		{ code: 'HR022', libelle: 'Virovitičko-podravska županija' },
		{ code: 'HR023', libelle: 'Požeško-slavonska županija' },
		{ code: 'HR024', libelle: 'Brodsko-posavska županija' },
		{ code: 'HR025', libelle: 'Osječko-baranjska županija' },
		{ code: 'HR026', libelle: 'Vukovarsko-srijemska županija' },
		{ code: 'HR027', libelle: 'Karlovačka županija' },
		{ code: 'HR028', libelle: 'Sisačko-moslavačka županija' },
		{ code: 'HR03', libelle: 'Jadranska Hrvatska' },
		{ code: 'HR031', libelle: 'Primorsko-goranska županija' },
		{ code: 'HR032', libelle: 'Ličko-senjska županija' },
		{ code: 'HR033', libelle: 'Zadarska županija' },
		{ code: 'HR034', libelle: 'Šibensko-kninska županija' },
		{ code: 'HR035', libelle: 'Splitsko-dalmatinska županija' },
		{ code: 'HR036', libelle: 'Istarska županija' },
		{ code: 'HR037', libelle: 'Dubrovačko-neretvanska županija' },
		{ code: 'HR05', libelle: 'Grad Zagreb' },
		{ code: 'HR050', libelle: 'Grad Zagreb' },
		{ code: 'HR06', libelle: 'Sjeverna Hrvatska' },
		{ code: 'HR061', libelle: 'Međimurska županija' },
		{ code: 'HR062', libelle: 'Varaždinska županija' },
		{ code: 'HR063', libelle: 'Koprivničko-križevačka županija' },
		{ code: 'HR064', libelle: 'Krapinsko-zagorska županija' },
		{ code: 'HR065', libelle: 'Zagrebačka županija' },
		{ code: 'HRZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'HRZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'HRZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'IT', libelle: 'Italia' },
		{ code: 'ITC', libelle: 'Nord-Ovest' },
		{ code: 'ITC1', libelle: 'Piemonte' },
		{ code: 'ITC11', libelle: 'Torino' },
		{ code: 'ITC12', libelle: 'Vercelli' },
		{ code: 'ITC13', libelle: 'Biella' },
		{ code: 'ITC14', libelle: 'Verbano-Cusio-Ossola' },
		{ code: 'ITC15', libelle: 'Novara' },
		{ code: 'ITC16', libelle: 'Cuneo' },
		{ code: 'ITC17', libelle: 'Asti' },
		{ code: 'ITC18', libelle: 'Alessandria' },
		{ code: 'ITC2', libelle: 'Valle d’Aosta/Vallée d’Aoste' },
		{ code: 'ITC20', libelle: 'Valle d’Aosta/Vallée d’Aoste' },
		{ code: 'ITC3', libelle: 'Liguria' },
		{ code: 'ITC31', libelle: 'Imperia' },
		{ code: 'ITC32', libelle: 'Savona' },
		{ code: 'ITC33', libelle: 'Genova' },
		{ code: 'ITC34', libelle: 'La Spezia' },
		{ code: 'ITC4', libelle: 'Lombardia' },
		{ code: 'ITC41', libelle: 'Varese' },
		{ code: 'ITC42', libelle: 'Como' },
		{ code: 'ITC43', libelle: 'Lecco' },
		{ code: 'ITC44', libelle: 'Sondrio' },
		{ code: 'ITC46', libelle: 'Bergamo' },
		{ code: 'ITC47', libelle: 'Brescia' },
		{ code: 'ITC48', libelle: 'Pavia' },
		{ code: 'ITC49', libelle: 'Lodi' },
		{ code: 'ITC4A', libelle: 'Cremona' },
		{ code: 'ITC4B', libelle: 'Mantova' },
		{ code: 'ITC4C', libelle: 'Milano' },
		{ code: 'ITC4D', libelle: 'Monza e della Brianza' },
		{ code: 'ITF', libelle: 'Sud' },
		{ code: 'ITF1', libelle: 'Abruzzo' },
		{ code: 'ITF11', libelle: 'L’Aquila' },
		{ code: 'ITF12', libelle: 'Teramo' },
		{ code: 'ITF13', libelle: 'Pescara' },
		{ code: 'ITF14', libelle: 'Chieti' },
		{ code: 'ITF2', libelle: 'Molise' },
		{ code: 'ITF21', libelle: 'Isernia' },
		{ code: 'ITF22', libelle: 'Campobasso' },
		{ code: 'ITF3', libelle: 'Campania' },
		{ code: 'ITF31', libelle: 'Caserta' },
		{ code: 'ITF32', libelle: 'Benevento' },
		{ code: 'ITF33', libelle: 'Napoli' },
		{ code: 'ITF34', libelle: 'Avellino' },
		{ code: 'ITF35', libelle: 'Salerno' },
		{ code: 'ITF4', libelle: 'Puglia' },
		{ code: 'ITF43', libelle: 'Taranto' },
		{ code: 'ITF44', libelle: 'Brindisi' },
		{ code: 'ITF45', libelle: 'Lecce' },
		{ code: 'ITF46', libelle: 'Foggia' },
		{ code: 'ITF47', libelle: 'Bari' },
		{ code: 'ITF48', libelle: 'Barletta-Andria-Trani' },
		{ code: 'ITF5', libelle: 'Basilicata' },
		{ code: 'ITF51', libelle: 'Potenza' },
		{ code: 'ITF52', libelle: 'Matera' },
		{ code: 'ITF6', libelle: 'Calabria' },
		{ code: 'ITF61', libelle: 'Cosenza' },
		{ code: 'ITF62', libelle: 'Crotone' },
		{ code: 'ITF63', libelle: 'Catanzaro' },
		{ code: 'ITF64', libelle: 'Vibo Valentia' },
		{ code: 'ITF65', libelle: 'Reggio di Calabria' },
		{ code: 'ITG', libelle: 'Isole' },
		{ code: 'ITG1', libelle: 'Sicilia' },
		{ code: 'ITG11', libelle: 'Trapani' },
		{ code: 'ITG12', libelle: 'Palermo' },
		{ code: 'ITG13', libelle: 'Messina' },
		{ code: 'ITG14', libelle: 'Agrigento' },
		{ code: 'ITG15', libelle: 'Caltanissetta' },
		{ code: 'ITG16', libelle: 'Enna' },
		{ code: 'ITG17', libelle: 'Catania' },
		{ code: 'ITG18', libelle: 'Ragusa' },
		{ code: 'ITG19', libelle: 'Siracusa' },
		{ code: 'ITG2', libelle: 'Sardegna' },
		{ code: 'ITG2D', libelle: 'Sassari' },
		{ code: 'ITG2E', libelle: 'Nuoro' },
		{ code: 'ITG2F', libelle: 'Cagliari' },
		{ code: 'ITG2G', libelle: 'Oristano' },
		{ code: 'ITG2H', libelle: 'Sud Sardegna' },
		{ code: 'ITH', libelle: 'Nord-Est' },
		{ code: 'ITH1', libelle: 'Provincia Autonoma di Bolzano/Bozen' },
		{ code: 'ITH10', libelle: 'Bolzano-Bozen' },
		{ code: 'ITH2', libelle: 'Provincia Autonoma di Trento' },
		{ code: 'ITH20', libelle: 'Trento' },
		{ code: 'ITH3', libelle: 'Veneto' },
		{ code: 'ITH31', libelle: 'Verona' },
		{ code: 'ITH32', libelle: 'Vicenza' },
		{ code: 'ITH33', libelle: 'Belluno' },
		{ code: 'ITH34', libelle: 'Treviso' },
		{ code: 'ITH35', libelle: 'Venezia' },
		{ code: 'ITH36', libelle: 'Padova' },
		{ code: 'ITH37', libelle: 'Rovigo' },
		{ code: 'ITH4', libelle: 'Friuli-Venezia Giulia' },
		{ code: 'ITH41', libelle: 'Pordenone' },
		{ code: 'ITH42', libelle: 'Udine' },
		{ code: 'ITH43', libelle: 'Gorizia' },
		{ code: 'ITH44', libelle: 'Trieste' },
		{ code: 'ITH5', libelle: 'Emilia-Romagna' },
		{ code: 'ITH51', libelle: 'Piacenza' },
		{ code: 'ITH52', libelle: 'Parma' },
		{ code: 'ITH53', libelle: 'Reggio nell’Emilia' },
		{ code: 'ITH54', libelle: 'Modena' },
		{ code: 'ITH55', libelle: 'Bologna' },
		{ code: 'ITH56', libelle: 'Ferrara' },
		{ code: 'ITH57', libelle: 'Ravenna' },
		{ code: 'ITH58', libelle: 'Forlì-Cesena' },
		{ code: 'ITH59', libelle: 'Rimini' },
		{ code: 'ITI', libelle: 'Centro (IT)' },
		{ code: 'ITI1', libelle: 'Toscana' },
		{ code: 'ITI11', libelle: 'Massa-Carrara' },
		{ code: 'ITI12', libelle: 'Lucca' },
		{ code: 'ITI13', libelle: 'Pistoia' },
		{ code: 'ITI14', libelle: 'Firenze' },
		{ code: 'ITI15', libelle: 'Prato' },
		{ code: 'ITI16', libelle: 'Livorno' },
		{ code: 'ITI17', libelle: 'Pisa' },
		{ code: 'ITI18', libelle: 'Arezzo' },
		{ code: 'ITI19', libelle: 'Siena' },
		{ code: 'ITI1A', libelle: 'Grosseto' },
		{ code: 'ITI2', libelle: 'Umbria' },
		{ code: 'ITI21', libelle: 'Perugia' },
		{ code: 'ITI22', libelle: 'Terni' },
		{ code: 'ITI3', libelle: 'Marche' },
		{ code: 'ITI31', libelle: 'Pesaro e Urbino' },
		{ code: 'ITI32', libelle: 'Ancona' },
		{ code: 'ITI33', libelle: 'Macerata' },
		{ code: 'ITI34', libelle: 'Ascoli Piceno' },
		{ code: 'ITI35', libelle: 'Fermo' },
		{ code: 'ITI4', libelle: 'Lazio' },
		{ code: 'ITI41', libelle: 'Viterbo' },
		{ code: 'ITI42', libelle: 'Rieti' },
		{ code: 'ITI43', libelle: 'Roma' },
		{ code: 'ITI44', libelle: 'Latina' },
		{ code: 'ITI45', libelle: 'Frosinone' },
		{ code: 'ITZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'ITZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'ITZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'CY', libelle: 'Κύπρος ' },
		{ code: 'CY0', libelle: 'Κύπρος' },
		{ code: 'CY00', libelle: 'Κύπρος' },
		{ code: 'CY000', libelle: 'Κύπρος' },
		{ code: 'CYZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'CYZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'CYZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'LV', libelle: 'Latvija' },
		{ code: 'LV0', libelle: 'Latvija' },
		{ code: 'LV00', libelle: 'Latvija' },
		{ code: 'LV003', libelle: 'Kurzeme' },
		{ code: 'LV005', libelle: 'Latgale' },
		{ code: 'LV006', libelle: 'Rīga' },
		{ code: 'LV007', libelle: 'Pierīga' },
		{ code: 'LV008', libelle: 'Vidzeme' },
		{ code: 'LV009', libelle: 'Zemgale' },
		{ code: 'LVZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'LVZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'LVZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'LT', libelle: 'Lietuva' },
		{ code: 'LT0', libelle: 'Lietuva' },
		{ code: 'LT01', libelle: 'Sostinės regionas' },
		{ code: 'LT011', libelle: 'Vilniaus apskritis' },
		{ code: 'LT02', libelle: 'Vidurio ir vakarų Lietuvos regionas ' },
		{ code: 'LT021', libelle: 'Alytaus apskritis' },
		{ code: 'LT022', libelle: 'Kauno apskritis' },
		{ code: 'LT023', libelle: 'Klaipėdos apskritis' },
		{ code: 'LT024', libelle: 'Marijampolės apskritis' },
		{ code: 'LT025', libelle: 'Panevėžio apskritis' },
		{ code: 'LT026', libelle: 'Šiaulių apskritis' },
		{ code: 'LT027', libelle: 'Tauragės apskritis' },
		{ code: 'LT028', libelle: 'Telšių apskritis' },
		{ code: 'LT029', libelle: 'Utenos apskritis' },
		{ code: 'LTZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'LTZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'LTZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'LU', libelle: 'Luxembourg' },
		{ code: 'LU0', libelle: 'Luxembourg' },
		{ code: 'LU00', libelle: 'Luxembourg' },
		{ code: 'LU000', libelle: 'Luxembourg' },
		{ code: 'LUZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'LUZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'LUZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'HU', libelle: 'Magyarország' },
		{ code: 'HU1', libelle: 'Közép-Magyarország' },
		{ code: 'HU11', libelle: 'Budapest' },
		{ code: 'HU110', libelle: 'Budapest' },
		{ code: 'HU12', libelle: 'Pest' },
		{ code: 'HU120', libelle: 'Pest' },
		{ code: 'HU2', libelle: 'Dunántúl' },
		{ code: 'HU21', libelle: 'Közép-Dunántúl' },
		{ code: 'HU211', libelle: 'Fejér' },
		{ code: 'HU212', libelle: 'Komárom-Esztergom' },
		{ code: 'HU213', libelle: 'Veszprém' },
		{ code: 'HU22', libelle: 'Nyugat-Dunántúl' },
		{ code: 'HU221', libelle: 'Győr-Moson-Sopron' },
		{ code: 'HU222', libelle: 'Vas' },
		{ code: 'HU223', libelle: 'Zala' },
		{ code: 'HU23', libelle: 'Dél-Dunántúl' },
		{ code: 'HU231', libelle: 'Baranya' },
		{ code: 'HU232', libelle: 'Somogy' },
		{ code: 'HU233', libelle: 'Tolna' },
		{ code: 'HU3', libelle: 'Alföld és Észak' },
		{ code: 'HU31', libelle: 'Észak-Magyarország' },
		{ code: 'HU311', libelle: 'Borsod-Abaúj-Zemplén' },
		{ code: 'HU312', libelle: 'Heves' },
		{ code: 'HU313', libelle: 'Nógrád' },
		{ code: 'HU32', libelle: 'Észak-Alföld' },
		{ code: 'HU321', libelle: 'Hajdú-Bihar' },
		{ code: 'HU322', libelle: 'Jász-Nagykun-Szolnok' },
		{ code: 'HU323', libelle: 'Szabolcs-Szatmár-Bereg' },
		{ code: 'HU33', libelle: 'Dél-Alföld' },
		{ code: 'HU331', libelle: 'Bács-Kiskun' },
		{ code: 'HU332', libelle: 'Békés' },
		{ code: 'HU333', libelle: 'Csongrád' },
		{ code: 'HUZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'HUZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'HUZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'MT', libelle: 'Malta' },
		{ code: 'MT0', libelle: 'Malta' },
		{ code: 'MT00', libelle: 'Malta' },
		{ code: 'MT001', libelle: 'Malta' },
		{ code: 'MT002', libelle: 'Gozo and Comino/Għawdex u Kemmuna' },
		{ code: 'MTZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'MTZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'MTZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'NL', libelle: 'Nederland' },
		{ code: 'NL1', libelle: 'Noord-Nederland' },
		{ code: 'NL11', libelle: 'Groningen' },
		{ code: 'NL111', libelle: 'Oost-Groningen' },
		{ code: 'NL112', libelle: 'Delfzijl en omgeving' },
		{ code: 'NL113', libelle: 'Overig Groningen' },
		{ code: 'NL12', libelle: 'Friesland (NL)' },
		{ code: 'NL124', libelle: 'Noord-Friesland' },
		{ code: 'NL125', libelle: 'Zuidwest-Friesland' },
		{ code: 'NL126', libelle: 'Zuidoost-Friesland' },
		{ code: 'NL13', libelle: 'Drenthe' },
		{ code: 'NL131', libelle: 'Noord-Drenthe' },
		{ code: 'NL132', libelle: 'Zuidoost-Drenthe' },
		{ code: 'NL133', libelle: 'Zuidwest-Drenthe' },
		{ code: 'NL2', libelle: 'Oost-Nederland' },
		{ code: 'NL21', libelle: 'Overijssel' },
		{ code: 'NL211', libelle: 'Noord-Overijssel' },
		{ code: 'NL212', libelle: 'Zuidwest-Overijssel' },
		{ code: 'NL213', libelle: 'Twente' },
		{ code: 'NL22', libelle: 'Gelderland' },
		{ code: 'NL221', libelle: 'Veluwe' },
		{ code: 'NL224', libelle: 'Zuidwest-Gelderland' },
		{ code: 'NL225', libelle: 'Achterhoek' },
		{ code: 'NL226', libelle: 'Arnhem/Nijmegen' },
		{ code: 'NL23', libelle: 'Flevoland' },
		{ code: 'NL230', libelle: 'Flevoland' },
		{ code: 'NL3', libelle: 'West-Nederland' },
		{ code: 'NL31', libelle: 'Utrecht' },
		{ code: 'NL310', libelle: 'Utrecht' },
		{ code: 'NL32', libelle: 'Noord-Holland' },
		{ code: 'NL321', libelle: 'Kop van Noord-Holland' },
		{ code: 'NL323', libelle: 'IJmond' },
		{ code: 'NL324', libelle: 'Agglomeratie Haarlem' },
		{ code: 'NL325', libelle: 'Zaanstreek' },
		{ code: 'NL327', libelle: 'Het Gooi en Vechtstreek' },
		{ code: 'NL328', libelle: 'Alkmaar en omgeving' },
		{ code: 'NL329', libelle: 'Groot-Amsterdam' },
		{ code: 'NL33', libelle: 'Zuid-Holland' },
		{ code: 'NL332', libelle: 'Agglomeratie ’s-Gravenhage' },
		{ code: 'NL333', libelle: 'Delft en Westland' },
		{ code: 'NL337', libelle: 'Agglomeratie Leiden en Bollenstreek' },
		{ code: 'NL33A', libelle: 'Zuidoost-Zuid-Holland' },
		{ code: 'NL33B', libelle: 'Oost-Zuid-Holland' },
		{ code: 'NL33C', libelle: 'Groot-Rijnmond' },
		{ code: 'NL34', libelle: 'Zeeland' },
		{ code: 'NL341', libelle: 'Zeeuwsch-Vlaanderen' },
		{ code: 'NL342', libelle: 'Overig Zeeland' },
		{ code: 'NL4', libelle: 'Zuid-Nederland' },
		{ code: 'NL41', libelle: 'Noord-Brabant' },
		{ code: 'NL411', libelle: 'West-Noord-Brabant' },
		{ code: 'NL412', libelle: 'Midden-Noord-Brabant' },
		{ code: 'NL413', libelle: 'Noordoost-Noord-Brabant' },
		{ code: 'NL414', libelle: 'Zuidoost-Noord-Brabant' },
		{ code: 'NL42', libelle: 'Limburg (NL)' },
		{ code: 'NL421', libelle: 'Noord-Limburg' },
		{ code: 'NL422', libelle: 'Midden-Limburg' },
		{ code: 'NL423', libelle: 'Zuid-Limburg' },
		{ code: 'NLZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'NLZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'NLZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'AT', libelle: 'Österreich' },
		{ code: 'AT1', libelle: 'Ostösterreich' },
		{ code: 'AT11', libelle: 'Burgenland' },
		{ code: 'AT111', libelle: 'Mittelburgenland' },
		{ code: 'AT112', libelle: 'Nordburgenland' },
		{ code: 'AT113', libelle: 'Südburgenland' },
		{ code: 'AT12', libelle: 'Niederösterreich' },
		{ code: 'AT121', libelle: 'Mostviertel-Eisenwurzen' },
		{ code: 'AT122', libelle: 'Niederösterreich-Süd' },
		{ code: 'AT123', libelle: 'Sankt Pölten' },
		{ code: 'AT124', libelle: 'Waldviertel' },
		{ code: 'AT125', libelle: 'Weinviertel' },
		{ code: 'AT126', libelle: 'Wiener Umland/Nordteil' },
		{ code: 'AT127', libelle: 'Wiener Umland/Südteil' },
		{ code: 'AT13', libelle: 'Wien' },
		{ code: 'AT130', libelle: 'Wien' },
		{ code: 'AT2', libelle: 'Südösterreich' },
		{ code: 'AT21', libelle: 'Kärnten' },
		{ code: 'AT211', libelle: 'Klagenfurt-Villach' },
		{ code: 'AT212', libelle: 'Oberkärnten' },
		{ code: 'AT213', libelle: 'Unterkärnten' },
		{ code: 'AT22', libelle: 'Steiermark' },
		{ code: 'AT221', libelle: 'Graz' },
		{ code: 'AT222', libelle: 'Liezen' },
		{ code: 'AT223', libelle: 'Östliche Obersteiermark' },
		{ code: 'AT224', libelle: 'Oststeiermark' },
		{ code: 'AT225', libelle: 'West- und Südsteiermark' },
		{ code: 'AT226', libelle: 'Westliche Obersteiermark' },
		{ code: 'AT3', libelle: 'Westösterreich' },
		{ code: 'AT31', libelle: 'Oberösterreich' },
		{ code: 'AT311', libelle: 'Innviertel' },
		{ code: 'AT312', libelle: 'Linz-Wels' },
		{ code: 'AT313', libelle: 'Mühlviertel' },
		{ code: 'AT314', libelle: 'Steyr-Kirchdorf' },
		{ code: 'AT315', libelle: 'Traunviertel' },
		{ code: 'AT32', libelle: 'Salzburg' },
		{ code: 'AT321', libelle: 'Lungau' },
		{ code: 'AT322', libelle: 'Pinzgau-Pongau' },
		{ code: 'AT323', libelle: 'Salzburg und Umgebung' },
		{ code: 'AT33', libelle: 'Tirol' },
		{ code: 'AT331', libelle: 'Außerfern' },
		{ code: 'AT332', libelle: 'Innsbruck' },
		{ code: 'AT333', libelle: 'Osttirol' },
		{ code: 'AT334', libelle: 'Tiroler Oberland' },
		{ code: 'AT335', libelle: 'Tiroler Unterland' },
		{ code: 'AT34', libelle: 'Vorarlberg' },
		{ code: 'AT341', libelle: 'Bludenz-Bregenzer Wald' },
		{ code: 'AT342', libelle: 'Rheintal-Bodenseegebiet' },
		{ code: 'ATZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'ATZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'ATZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'PL', libelle: 'Polska' },
		{ code: 'PL2', libelle: 'Makroregion południowy' },
		{ code: 'PL21', libelle: 'Małopolskie' },
		{ code: 'PL213', libelle: 'Miasto Kraków' },
		{ code: 'PL214', libelle: 'Krakowski' },
		{ code: 'PL217', libelle: 'Tarnowski' },
		{ code: 'PL218', libelle: 'Nowosądecki' },
		{ code: 'PL219', libelle: 'Nowotarski' },
		{ code: 'PL21A', libelle: 'Oświęcimski' },
		{ code: 'PL22', libelle: 'Śląskie' },
		{ code: 'PL224', libelle: 'Częstochowski' },
		{ code: 'PL225', libelle: 'Bielski' },
		{ code: 'PL227', libelle: 'Rybnicki' },
		{ code: 'PL228', libelle: 'Bytomski' },
		{ code: 'PL229', libelle: 'Gliwicki' },
		{ code: 'PL22A', libelle: 'Katowicki' },
		{ code: 'PL22B', libelle: 'Sosnowiecki' },
		{ code: 'PL22C', libelle: 'Tyski' },
		{ code: 'PL4', libelle: 'Makroregion północno-zachodni' },
		{ code: 'PL41', libelle: 'Wielkopolskie' },
		{ code: 'PL411', libelle: 'Pilski' },
		{ code: 'PL414', libelle: 'Koniński' },
		{ code: 'PL415', libelle: 'Miasto Poznań' },
		{ code: 'PL416', libelle: 'Kaliski' },
		{ code: 'PL417', libelle: 'Leszczyński' },
		{ code: 'PL418', libelle: 'Poznański' },
		{ code: 'PL42', libelle: 'Zachodniopomorskie' },
		{ code: 'PL424', libelle: 'Miasto Szczecin' },
		{ code: 'PL426', libelle: 'Koszaliński' },
		{ code: 'PL427', libelle: 'Szczecinecko-pyrzycki' },
		{ code: 'PL428', libelle: 'Szczeciński' },
		{ code: 'PL43', libelle: 'Lubuskie' },
		{ code: 'PL431', libelle: 'Gorzowski' },
		{ code: 'PL432', libelle: 'Zielonogórski' },
		{ code: 'PL5', libelle: 'Makroregion południowo-zachodni' },
		{ code: 'PL51', libelle: 'Dolnośląskie' },
		{ code: 'PL514', libelle: 'Miasto Wrocław' },
		{ code: 'PL515', libelle: 'Jeleniogórski' },
		{ code: 'PL516', libelle: 'Legnicko-głogowski' },
		{ code: 'PL517', libelle: 'Wałbrzyski' },
		{ code: 'PL518', libelle: 'Wrocławski' },
		{ code: 'PL52', libelle: 'Opolskie' },
		{ code: 'PL523', libelle: 'Nyski' },
		{ code: 'PL524', libelle: 'Opolski' },
		{ code: 'PL6', libelle: 'Makroregion północny' },
		{ code: 'PL61', libelle: 'Kujawsko-pomorskie' },
		{ code: 'PL613', libelle: 'Bydgosko-toruński' },
		{ code: 'PL616', libelle: 'Grudziądzki' },
		{ code: 'PL617', libelle: 'Inowrocławski' },
		{ code: 'PL618', libelle: 'Świecki' },
		{ code: 'PL619', libelle: 'Włocławski' },
		{ code: 'PL62', libelle: 'Warmińsko-mazurskie' },
		{ code: 'PL621', libelle: 'Elbląski' },
		{ code: 'PL622', libelle: 'Olsztyński' },
		{ code: 'PL623', libelle: 'Ełcki' },
		{ code: 'PL63', libelle: 'Pomorskie' },
		{ code: 'PL633', libelle: 'Trójmiejski' },
		{ code: 'PL634', libelle: 'Gdański' },
		{ code: 'PL636', libelle: 'Słupski' },
		{ code: 'PL637', libelle: 'Chojnicki' },
		{ code: 'PL638', libelle: 'Starogardzki' },
		{ code: 'PL7', libelle: 'Makroregion centralny' },
		{ code: 'PL71', libelle: 'Łódzkie' },
		{ code: 'PL711', libelle: 'Miasto Łódź' },
		{ code: 'PL712', libelle: 'Łódzki' },
		{ code: 'PL713', libelle: 'Piotrkowski' },
		{ code: 'PL714', libelle: 'Sieradzki' },
		{ code: 'PL715', libelle: 'Skierniewicki' },
		{ code: 'PL72', libelle: 'Świętokrzyskie' },
		{ code: 'PL721', libelle: 'Kielecki' },
		{ code: 'PL722', libelle: 'Sandomiersko-jędrzejowski' },
		{ code: 'PL8', libelle: 'Makroregion wschodni' },
		{ code: 'PL81', libelle: 'Lubelskie' },
		{ code: 'PL811', libelle: 'Bialski' },
		{ code: 'PL812', libelle: 'Chełmsko-zamojski' },
		{ code: 'PL814', libelle: 'Lubelski' },
		{ code: 'PL815', libelle: 'Puławski' },
		{ code: 'PL82', libelle: 'Podkarpackie' },
		{ code: 'PL821', libelle: 'Krośnieński' },
		{ code: 'PL822', libelle: 'Przemyski' },
		{ code: 'PL823', libelle: 'Rzeszowski' },
		{ code: 'PL824', libelle: 'Tarnobrzeski' },
		{ code: 'PL84', libelle: 'Podlaskie' },
		{ code: 'PL841', libelle: 'Białostocki' },
		{ code: 'PL842', libelle: 'Łomżyński' },
		{ code: 'PL843', libelle: 'Suwalski' },
		{ code: 'PL9', libelle: 'Makroregion województwo mazowieckie' },
		{ code: 'PL91', libelle: 'Warszawski stołeczny' },
		{ code: 'PL911', libelle: 'Miasto Warszawa' },
		{ code: 'PL912', libelle: 'Warszawski wschodni' },
		{ code: 'PL913', libelle: 'Warszawski zachodni' },
		{ code: 'PL92', libelle: 'Mazowiecki regionalny' },
		{ code: 'PL921', libelle: 'Radomski' },
		{ code: 'PL922', libelle: 'Ciechanowski' },
		{ code: 'PL923', libelle: 'Płocki' },
		{ code: 'PL924', libelle: 'Ostrołęcki' },
		{ code: 'PL925', libelle: 'Siedlecki' },
		{ code: 'PL926', libelle: 'Żyrardowski' },
		{ code: 'PLZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'PLZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'PLZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'PT', libelle: 'Portugal' },
		{ code: 'PT1', libelle: 'Continente' },
		{ code: 'PT11', libelle: 'Norte' },
		{ code: 'PT111', libelle: 'Alto Minho' },
		{ code: 'PT112', libelle: 'Cávado' },
		{ code: 'PT119', libelle: 'Ave' },
		{ code: 'PT11A', libelle: 'Área Metropolitana do Porto' },
		{ code: 'PT11B', libelle: 'Alto Tâmega' },
		{ code: 'PT11C', libelle: 'Tâmega e Sousa' },
		{ code: 'PT11D', libelle: 'Douro' },
		{ code: 'PT11E', libelle: 'Terras de Trás-os-Montes' },
		{ code: 'PT15', libelle: 'Algarve' },
		{ code: 'PT150', libelle: 'Algarve' },
		{ code: 'PT16', libelle: 'Centro (PT)' },
		{ code: 'PT16B', libelle: 'Oeste' },
		{ code: 'PT16D', libelle: 'Região de Aveiro' },
		{ code: 'PT16E', libelle: 'Região de Coimbra' },
		{ code: 'PT16F', libelle: 'Região de Leiria' },
		{ code: 'PT16G', libelle: 'Viseu Dão Lafões' },
		{ code: 'PT16H', libelle: 'Beira Baixa' },
		{ code: 'PT16I', libelle: 'Médio Tejo' },
		{ code: 'PT16J', libelle: 'Beiras e Serra da Estrela' },
		{ code: 'PT17', libelle: 'Área Metropolitana de Lisboa' },
		{ code: 'PT170', libelle: 'Área Metropolitana de Lisboa' },
		{ code: 'PT18', libelle: 'Alentejo' },
		{ code: 'PT181', libelle: 'Alentejo Litoral' },
		{ code: 'PT184', libelle: 'Baixo Alentejo' },
		{ code: 'PT185', libelle: 'Lezíria do Tejo' },
		{ code: 'PT186', libelle: 'Alto Alentejo' },
		{ code: 'PT187', libelle: 'Alentejo Central' },
		{ code: 'PT2', libelle: 'Região Autónoma dos Açores' },
		{ code: 'PT20', libelle: 'Região Autónoma dos Açores' },
		{ code: 'PT200', libelle: 'Região Autónoma dos Açores' },
		{ code: 'PT3', libelle: 'Região Autónoma da Madeira' },
		{ code: 'PT30', libelle: 'Região Autónoma da Madeira' },
		{ code: 'PT300', libelle: 'Região Autónoma da Madeira' },
		{ code: 'PTZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'PTZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'PTZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'RO', libelle: 'România' },
		{ code: 'RO1', libelle: 'Macroregiunea Unu' },
		{ code: 'RO11', libelle: 'Nord-Vest' },
		{ code: 'RO111', libelle: 'Bihor' },
		{ code: 'RO112', libelle: 'Bistriţa-Năsăud' },
		{ code: 'RO113', libelle: 'Cluj' },
		{ code: 'RO114', libelle: 'Maramureş' },
		{ code: 'RO115', libelle: 'Satu Mare' },
		{ code: 'RO116', libelle: 'Sălaj' },
		{ code: 'RO12', libelle: 'Centru' },
		{ code: 'RO121', libelle: 'Alba' },
		{ code: 'RO122', libelle: 'Braşov' },
		{ code: 'RO123', libelle: 'Covasna' },
		{ code: 'RO124', libelle: 'Harghita' },
		{ code: 'RO125', libelle: 'Mureş' },
		{ code: 'RO126', libelle: 'Sibiu' },
		{ code: 'RO2', libelle: 'Macroregiunea Doi' },
		{ code: 'RO21', libelle: 'Nord-Est' },
		{ code: 'RO211', libelle: 'Bacău' },
		{ code: 'RO212', libelle: 'Botoşani' },
		{ code: 'RO213', libelle: 'Iaşi' },
		{ code: 'RO214', libelle: 'Neamţ' },
		{ code: 'RO215', libelle: 'Suceava' },
		{ code: 'RO216', libelle: 'Vaslui' },
		{ code: 'RO22', libelle: 'Sud-Est' },
		{ code: 'RO221', libelle: 'Brăila' },
		{ code: 'RO222', libelle: 'Buzău' },
		{ code: 'RO223', libelle: 'Constanţa' },
		{ code: 'RO224', libelle: 'Galaţi' },
		{ code: 'RO225', libelle: 'Tulcea' },
		{ code: 'RO226', libelle: 'Vrancea' },
		{ code: 'RO3', libelle: 'Macroregiunea Trei' },
		{ code: 'RO31', libelle: 'Sud-Muntenia' },
		{ code: 'RO311', libelle: 'Argeş' },
		{ code: 'RO312', libelle: 'Călăraşi' },
		{ code: 'RO313', libelle: 'Dâmboviţa' },
		{ code: 'RO314', libelle: 'Giurgiu' },
		{ code: 'RO315', libelle: 'Ialomiţa' },
		{ code: 'RO316', libelle: 'Prahova' },
		{ code: 'RO317', libelle: 'Teleorman' },
		{ code: 'RO32', libelle: 'Bucureşti-Ilfov' },
		{ code: 'RO321', libelle: 'Bucureşti' },
		{ code: 'RO322', libelle: 'Ilfov' },
		{ code: 'RO4', libelle: 'Macroregiunea Patru' },
		{ code: 'RO41', libelle: 'Sud-Vest Oltenia' },
		{ code: 'RO411', libelle: 'Dolj' },
		{ code: 'RO412', libelle: 'Gorj' },
		{ code: 'RO413', libelle: 'Mehedinţi' },
		{ code: 'RO414', libelle: 'Olt' },
		{ code: 'RO415', libelle: 'Vâlcea' },
		{ code: 'RO42', libelle: 'Vest' },
		{ code: 'RO421', libelle: 'Arad' },
		{ code: 'RO422', libelle: 'Caraş-Severin' },
		{ code: 'RO423', libelle: 'Hunedoara' },
		{ code: 'RO424', libelle: 'Timiş' },
		{ code: 'ROZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'ROZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'ROZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'SI', libelle: 'Slovenija' },
		{ code: 'SI0', libelle: 'Slovenija' },
		{ code: 'SI03', libelle: 'Vzhodna Slovenija' },
		{ code: 'SI031', libelle: 'Pomurska' },
		{ code: 'SI032', libelle: 'Podravska' },
		{ code: 'SI033', libelle: 'Koroška' },
		{ code: 'SI034', libelle: 'Savinjska' },
		{ code: 'SI035', libelle: 'Zasavska' },
		{ code: 'SI036', libelle: 'Posavska' },
		{ code: 'SI037', libelle: 'Jugovzhodna Slovenija' },
		{ code: 'SI038', libelle: 'Primorsko-notranjska' },
		{ code: 'SI04', libelle: 'Zahodna Slovenija' },
		{ code: 'SI041', libelle: 'Osrednjeslovenska' },
		{ code: 'SI042', libelle: 'Gorenjska' },
		{ code: 'SI043', libelle: 'Goriška' },
		{ code: 'SI044', libelle: 'Obalno-kraška' },
		{ code: 'SIZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'SIZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'SIZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'SK', libelle: 'Slovensko' },
		{ code: 'SK0', libelle: 'Slovensko' },
		{ code: 'SK01', libelle: 'Bratislavský kraj' },
		{ code: 'SK010', libelle: 'Bratislavský kraj' },
		{ code: 'SK02', libelle: 'Západné Slovensko' },
		{ code: 'SK021', libelle: 'Trnavský kraj' },
		{ code: 'SK022', libelle: 'Trenčiansky kraj' },
		{ code: 'SK023', libelle: 'Nitriansky kraj' },
		{ code: 'SK03', libelle: 'Stredné Slovensko' },
		{ code: 'SK031', libelle: 'Žilinský kraj' },
		{ code: 'SK032', libelle: 'Banskobystrický kraj' },
		{ code: 'SK04', libelle: 'Východné Slovensko' },
		{ code: 'SK041', libelle: 'Prešovský kraj' },
		{ code: 'SK042', libelle: 'Košický kraj' },
		{ code: 'SKZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'SKZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'SKZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'FI', libelle: 'Suomi/Finland' },
		{ code: 'FI1', libelle: 'Manner-Suomi' },
		{ code: 'FI19', libelle: 'Länsi-Suomi' },
		{ code: 'FI193', libelle: 'Keski-Suomi' },
		{ code: 'FI194', libelle: 'Etelä-Pohjanmaa' },
		{ code: 'FI195', libelle: 'Pohjanmaa' },
		{ code: 'FI196', libelle: 'Satakunta' },
		{ code: 'FI197', libelle: 'Pirkanmaa' },
		{ code: 'FI1B', libelle: 'Helsinki-Uusimaa' },
		{ code: 'FI1B1', libelle: 'Helsinki-Uusimaa' },
		{ code: 'FI1C', libelle: 'Etelä-Suomi' },
		{ code: 'FI1C1', libelle: 'Varsinais-Suomi' },
		{ code: 'FI1C2', libelle: 'Kanta-Häme' },
		{ code: 'FI1C3', libelle: 'Päijät-Häme' },
		{ code: 'FI1C4', libelle: 'Kymenlaakso' },
		{ code: 'FI1C5', libelle: 'Etelä-Karjala' },
		{ code: 'FI1D', libelle: 'Pohjois- ja Itä-Suomi' },
		{ code: 'FI1D1', libelle: 'Etelä-Savo' },
		{ code: 'FI1D2', libelle: 'Pohjois-Savo' },
		{ code: 'FI1D3', libelle: 'Pohjois-Karjala' },
		{ code: 'FI1D5', libelle: 'Keski-Pohjanmaa' },
		{ code: 'FI1D7', libelle: 'Lappi' },
		{ code: 'FI1D8', libelle: 'Kainuu' },
		{ code: 'FI1D9', libelle: 'Pohjois-Pohjanmaa' },
		{ code: 'FI2', libelle: 'Åland' },
		{ code: 'FI20', libelle: 'Åland' },
		{ code: 'FI200', libelle: 'Åland' },
		{ code: 'FIZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'FIZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'FIZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'SE', libelle: 'Sverige' },
		{ code: 'SE1', libelle: 'Östra Sverige' },
		{ code: 'SE11', libelle: 'Stockholm' },
		{ code: 'SE110', libelle: 'Stockholms län' },
		{ code: 'SE12', libelle: 'Östra Mellansverige' },
		{ code: 'SE121', libelle: 'Uppsala län' },
		{ code: 'SE122', libelle: 'Södermanlands län' },
		{ code: 'SE123', libelle: 'Östergötlands län' },
		{ code: 'SE124', libelle: 'Örebro län' },
		{ code: 'SE125', libelle: 'Västmanlands län' },
		{ code: 'SE2', libelle: 'Södra Sverige' },
		{ code: 'SE21', libelle: 'Småland med öarna' },
		{ code: 'SE211', libelle: 'Jönköpings län' },
		{ code: 'SE212', libelle: 'Kronobergs län' },
		{ code: 'SE213', libelle: 'Kalmar län' },
		{ code: 'SE214', libelle: 'Gotlands län' },
		{ code: 'SE22', libelle: 'Sydsverige' },
		{ code: 'SE221', libelle: 'Blekinge län' },
		{ code: 'SE224', libelle: 'Skåne län' },
		{ code: 'SE23', libelle: 'Västsverige' },
		{ code: 'SE231', libelle: 'Hallands län' },
		{ code: 'SE232', libelle: 'Västra Götalands län' },
		{ code: 'SE3', libelle: 'Norra Sverige' },
		{ code: 'SE31', libelle: 'Norra Mellansverige' },
		{ code: 'SE311', libelle: 'Värmlands län' },
		{ code: 'SE312', libelle: 'Dalarnas län' },
		{ code: 'SE313', libelle: 'Gävleborgs län' },
		{ code: 'SE32', libelle: 'Mellersta Norrland' },
		{ code: 'SE321', libelle: 'Västernorrlands län' },
		{ code: 'SE322', libelle: 'Jämtlands län' },
		{ code: 'SE33', libelle: 'Övre Norrland' },
		{ code: 'SE331', libelle: 'Västerbottens län' },
		{ code: 'SE332', libelle: 'Norrbottens län' },
		{ code: 'SEZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'SEZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'SEZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'UK', libelle: 'United Kingdom' },
		{ code: 'UKC', libelle: 'North East (England)' },
		{ code: 'UKC1', libelle: 'Tees Valley and Durham' },
		{ code: 'UKC11', libelle: 'Hartlepool and Stockton-on-Tees' },
		{ code: 'UKC12', libelle: 'South Teesside' },
		{ code: 'UKC13', libelle: 'Darlington' },
		{ code: 'UKC14', libelle: 'Durham CC' },
		{ code: 'UKC2', libelle: 'Northumberland and Tyne and Wear' },
		{ code: 'UKC21', libelle: 'Northumberland' },
		{ code: 'UKC22', libelle: 'Tyneside' },
		{ code: 'UKC23', libelle: 'Sunderland' },
		{ code: 'UKD', libelle: 'North West (England)' },
		{ code: 'UKD1', libelle: 'Cumbria' },
		{ code: 'UKD11', libelle: 'West Cumbria' },
		{ code: 'UKD12', libelle: 'East Cumbria' },
		{ code: 'UKD3', libelle: 'Greater Manchester' },
		{ code: 'UKD33', libelle: 'Manchester' },
		{ code: 'UKD34', libelle: 'Greater Manchester South West' },
		{ code: 'UKD35', libelle: 'Greater Manchester South East' },
		{ code: 'UKD36', libelle: 'Greater Manchester North West' },
		{ code: 'UKD37', libelle: 'Greater Manchester North East' },
		{ code: 'UKD4', libelle: 'Lancashire' },
		{ code: 'UKD41', libelle: 'Blackburn with Darwen' },
		{ code: 'UKD42', libelle: 'Blackpool' },
		{ code: 'UKD44', libelle: 'Lancaster and Wyre' },
		{ code: 'UKD45', libelle: 'Mid Lancashire' },
		{ code: 'UKD46', libelle: 'East Lancashire' },
		{ code: 'UKD47', libelle: 'Chorley and West Lancashire' },
		{ code: 'UKD6', libelle: 'Cheshire' },
		{ code: 'UKD61', libelle: 'Warrington' },
		{ code: 'UKD62', libelle: 'Cheshire East' },
		{ code: 'UKD63', libelle: 'Cheshire West and Chester' },
		{ code: 'UKD7', libelle: 'Merseyside' },
		{ code: 'UKD71', libelle: 'East Merseyside' },
		{ code: 'UKD72', libelle: 'Liverpool' },
		{ code: 'UKD73', libelle: 'Sefton' },
		{ code: 'UKD74', libelle: 'Wirral' },
		{ code: 'UKE', libelle: 'Yorkshire and the Humber' },
		{ code: 'UKE1', libelle: 'East Yorkshire and Northern Lincolnshire' },
		{ code: 'UKE11', libelle: 'Kingston upon Hull, City of' },
		{ code: 'UKE12', libelle: 'East Riding of Yorkshire' },
		{ code: 'UKE13', libelle: 'North and North East Lincolnshire' },
		{ code: 'UKE2', libelle: 'North Yorkshire' },
		{ code: 'UKE21', libelle: 'York' },
		{ code: 'UKE22', libelle: 'North Yorkshire CC' },
		{ code: 'UKE3', libelle: 'South Yorkshire' },
		{ code: 'UKE31', libelle: 'Barnsley, Doncaster and Rotherham' },
		{ code: 'UKE32', libelle: 'Sheffield' },
		{ code: 'UKE4', libelle: 'West Yorkshire' },
		{ code: 'UKE41', libelle: 'Bradford' },
		{ code: 'UKE42', libelle: 'Leeds' },
		{ code: 'UKE44', libelle: 'Calderdale and Kirklees' },
		{ code: 'UKE45', libelle: 'Wakefield' },
		{ code: 'UKF', libelle: 'East Midlands (England)' },
		{ code: 'UKF1', libelle: 'Derbyshire and Nottinghamshire' },
		{ code: 'UKF11', libelle: 'Derby' },
		{ code: 'UKF12', libelle: 'East Derbyshire' },
		{ code: 'UKF13', libelle: 'South and West Derbyshire' },
		{ code: 'UKF14', libelle: 'Nottingham' },
		{ code: 'UKF15', libelle: 'North Nottinghamshire' },
		{ code: 'UKF16', libelle: 'South Nottinghamshire' },
		{ code: 'UKF2', libelle: 'Leicestershire, Rutland and Northamptonshire' },
		{ code: 'UKF21', libelle: 'Leicester' },
		{ code: 'UKF22', libelle: 'Leicestershire CC and Rutland' },
		{ code: 'UKF24', libelle: 'West Northamptonshire' },
		{ code: 'UKF25', libelle: 'North Northamptonshire' },
		{ code: 'UKF3', libelle: 'Lincolnshire' },
		{ code: 'UKF30', libelle: 'Lincolnshire' },
		{ code: 'UKG', libelle: 'West Midlands (England)' },
		{ code: 'UKG1', libelle: 'Herefordshire, Worcestershire and Warwickshire' },
		{ code: 'UKG11', libelle: 'Herefordshire, County of' },
		{ code: 'UKG12', libelle: 'Worcestershire' },
		{ code: 'UKG13', libelle: 'Warwickshire' },
		{ code: 'UKG2', libelle: 'Shropshire and Staffordshire' },
		{ code: 'UKG21', libelle: 'Telford and Wrekin' },
		{ code: 'UKG22', libelle: 'Shropshire CC' },
		{ code: 'UKG23', libelle: 'Stoke-on-Trent' },
		{ code: 'UKG24', libelle: 'Staffordshire CC' },
		{ code: 'UKG3', libelle: 'West Midlands' },
		{ code: 'UKG31', libelle: 'Birmingham' },
		{ code: 'UKG32', libelle: 'Solihull' },
		{ code: 'UKG33', libelle: 'Coventry' },
		{ code: 'UKG36', libelle: 'Dudley' },
		{ code: 'UKG37', libelle: 'Sandwell' },
		{ code: 'UKG38', libelle: 'Walsall' },
		{ code: 'UKG39', libelle: 'Wolverhampton' },
		{ code: 'UKH', libelle: 'East of England' },
		{ code: 'UKH1', libelle: 'East Anglia' },
		{ code: 'UKH11', libelle: 'Peterborough' },
		{ code: 'UKH12', libelle: 'Cambridgeshire CC' },
		{ code: 'UKH14', libelle: 'Suffolk' },
		{ code: 'UKH15', libelle: 'Norwich and East Norfolk' },
		{ code: 'UKH16', libelle: 'North and West Norfolk' },
		{ code: 'UKH17', libelle: 'Breckland and South Norfolk' },
		{ code: 'UKH2', libelle: 'Bedfordshire and Hertfordshire' },
		{ code: 'UKH21', libelle: 'Luton' },
		{ code: 'UKH23', libelle: 'Hertfordshire' },
		{ code: 'UKH24', libelle: 'Bedford' },
		{ code: 'UKH25', libelle: 'Central Bedfordshire' },
		{ code: 'UKH3', libelle: 'Essex' },
		{ code: 'UKH31', libelle: 'Southend-on-Sea' },
		{ code: 'UKH32', libelle: 'Thurrock' },
		{ code: 'UKH34', libelle: 'Essex Haven Gateway' },
		{ code: 'UKH35', libelle: 'West Essex' },
		{ code: 'UKH36', libelle: 'Heart of Essex' },
		{ code: 'UKH37', libelle: 'Essex Thames Gateway' },
		{ code: 'UKI', libelle: 'London' },
		{ code: 'UKI3', libelle: 'Inner London — West' },
		{ code: 'UKI31', libelle: 'Camden and City of London' },
		{ code: 'UKI32', libelle: 'Westminster' },
		{ code: 'UKI33', libelle: 'Kensington & Chelsea and Hammersmith & Fulham' },
		{ code: 'UKI34', libelle: 'Wandsworth' },
		{ code: 'UKI4', libelle: 'Inner London — East' },
		{ code: 'UKI41', libelle: 'Hackney and Newham' },
		{ code: 'UKI42', libelle: 'Tower Hamlets' },
		{ code: 'UKI43', libelle: 'Haringey and Islington' },
		{ code: 'UKI44', libelle: 'Lewisham and Southwark' },
		{ code: 'UKI45', libelle: 'Lambeth' },
		{ code: 'UKI5', libelle: 'Outer London — East and North East' },
		{ code: 'UKI51', libelle: 'Bexley and Greenwich' },
		{ code: 'UKI52', libelle: 'Barking & Dagenham and Havering' },
		{ code: 'UKI53', libelle: 'Redbridge and Waltham Forest' },
		{ code: 'UKI54', libelle: 'Enfield' },
		{ code: 'UKI6', libelle: 'Outer London — South' },
		{ code: 'UKI61', libelle: 'Bromley' },
		{ code: 'UKI62', libelle: 'Croydon' },
		{ code: 'UKI63', libelle: 'Merton, Kingston upon Thames and Sutton' },
		{ code: 'UKI7', libelle: 'Outer London — West and North West' },
		{ code: 'UKI71', libelle: 'Barnet' },
		{ code: 'UKI72', libelle: 'Brent' },
		{ code: 'UKI73', libelle: 'Ealing' },
		{ code: 'UKI74', libelle: 'Harrow and Hillingdon' },
		{ code: 'UKI75', libelle: 'Hounslow and Richmond upon Thames' },
		{ code: 'UKJ', libelle: 'South East (England)' },
		{ code: 'UKJ1', libelle: 'Berkshire, Buckinghamshire and Oxfordshire' },
		{ code: 'UKJ11', libelle: 'Berkshire' },
		{ code: 'UKJ12', libelle: 'Milton Keynes' },
		{ code: 'UKJ13', libelle: 'Buckinghamshire CC' },
		{ code: 'UKJ14', libelle: 'Oxfordshire' },
		{ code: 'UKJ2', libelle: 'Surrey, East and West Sussex' },
		{ code: 'UKJ21', libelle: 'Brighton and Hove' },
		{ code: 'UKJ22', libelle: 'East Sussex CC' },
		{ code: 'UKJ25', libelle: 'West Surrey' },
		{ code: 'UKJ26', libelle: 'East Surrey' },
		{ code: 'UKJ27', libelle: 'West Sussex (South West)' },
		{ code: 'UKJ28', libelle: 'West Sussex (North East)' },
		{ code: 'UKJ3', libelle: 'Hampshire and Isle of Wight' },
		{ code: 'UKJ31', libelle: 'Portsmouth' },
		{ code: 'UKJ32', libelle: 'Southampton' },
		{ code: 'UKJ34', libelle: 'Isle of Wight' },
		{ code: 'UKJ35', libelle: 'South Hampshire' },
		{ code: 'UKJ36', libelle: 'Central Hampshire' },
		{ code: 'UKJ37', libelle: 'North Hampshire' },
		{ code: 'UKJ4', libelle: 'Kent' },
		{ code: 'UKJ41', libelle: 'Medway' },
		{ code: 'UKJ43', libelle: 'Kent Thames Gateway' },
		{ code: 'UKJ44', libelle: 'East Kent' },
		{ code: 'UKJ45', libelle: 'Mid Kent' },
		{ code: 'UKJ46', libelle: 'West Kent' },
		{ code: 'UKK', libelle: 'South West (England)' },
		{ code: 'UKK1', libelle: 'Gloucestershire, Wiltshire and Bristol/Bath area' },
		{ code: 'UKK11', libelle: 'Bristol, City of' },
		{ code: 'UKK12', libelle: 'Bath and North East Somerset, North Somerset and South Gloucestershire' },
		{ code: 'UKK13', libelle: 'Gloucestershire' },
		{ code: 'UKK14', libelle: 'Swindon' },
		{ code: 'UKK15', libelle: 'Wiltshire CC' },
		{ code: 'UKK2', libelle: 'Dorset and Somerset' },
		{ code: 'UKK23', libelle: 'Somerset' },
		{ code: 'UKK24', libelle: 'Bournemouth, Christchurch and Poole' },
		{ code: 'UKK25', libelle: 'Dorset' },
		{ code: 'UKK3', libelle: 'Cornwall and Isles of Scilly' },
		{ code: 'UKK30', libelle: 'Cornwall and Isles of Scilly' },
		{ code: 'UKK4', libelle: 'Devon' },
		{ code: 'UKK41', libelle: 'Plymouth' },
		{ code: 'UKK42', libelle: 'Torbay' },
		{ code: 'UKK43', libelle: 'Devon CC' },
		{ code: 'UKL', libelle: 'Wales' },
		{ code: 'UKL1', libelle: 'West Wales and The Valleys' },
		{ code: 'UKL11', libelle: 'Isle of Anglesey' },
		{ code: 'UKL12', libelle: 'Gwynedd' },
		{ code: 'UKL13', libelle: 'Conwy and Denbighshire' },
		{ code: 'UKL14', libelle: 'South West Wales' },
		{ code: 'UKL15', libelle: 'Central Valleys' },
		{ code: 'UKL16', libelle: 'Gwent Valleys' },
		{ code: 'UKL17', libelle: 'Bridgend and Neath Port Talbot' },
		{ code: 'UKL18', libelle: 'Swansea' },
		{ code: 'UKL2', libelle: 'East Wales' },
		{ code: 'UKL21', libelle: 'Monmouthshire and Newport' },
		{ code: 'UKL22', libelle: 'Cardiff and Vale of Glamorgan' },
		{ code: 'UKL23', libelle: 'Flintshire and Wrexham' },
		{ code: 'UKL24', libelle: 'Powys' },
		{ code: 'UKM', libelle: 'Scotland' },
		{ code: 'UKM5', libelle: 'North Eastern Scotland' },
		{ code: 'UKM50', libelle: 'Aberdeen City and Aberdeenshire' },
		{ code: 'UKM6', libelle: 'Highlands and Islands' },
		{ code: 'UKM61', libelle: 'Caithness & Sutherland and Ross & Cromarty' },
		{ code: 'UKM62', libelle: 'Inverness & Nairn and Moray, Badenoch & Strathspey' },
		{ code: 'UKM63', libelle: 'Lochaber, Skye & Lochalsh, Arran & Cumbrae and Argyll & Bute' },
		{ code: 'UKM64', libelle: 'Na h-Eileanan Siar (Western Isles)' },
		{ code: 'UKM65', libelle: 'Orkney Islands' },
		{ code: 'UKM66', libelle: 'Shetland Islands' },
		{ code: 'UKM7', libelle: 'Eastern Scotland' },
		{ code: 'UKM71', libelle: 'Angus and Dundee City' },
		{ code: 'UKM72', libelle: 'Clackmannanshire and Fife' },
		{ code: 'UKM73', libelle: 'East Lothian and Midlothian' },
		{ code: 'UKM75', libelle: 'Edinburgh, City of' },
		{ code: 'UKM76', libelle: 'Falkirk' },
		{ code: 'UKM77', libelle: 'Perth & Kinross and Stirling' },
		{ code: 'UKM78', libelle: 'West Lothian' },
		{ code: 'UKM8', libelle: 'West Central Scotland' },
		{ code: 'UKM81', libelle: 'East Dunbartonshire, West Dunbartonshire and Helensburgh & Lomond' },
		{ code: 'UKM82', libelle: 'Glasgow City' },
		{ code: 'UKM83', libelle: 'Inverclyde, East Renfrewshire and Renfrewshire' },
		{ code: 'UKM84', libelle: 'North Lanarkshire' },
		{ code: 'UKM9', libelle: 'Southern Scotland' },
		{ code: 'UKM91', libelle: 'Scottish Borders' },
		{ code: 'UKM92', libelle: 'Dumfries & Galloway' },
		{ code: 'UKM93', libelle: 'East Ayrshire and North Ayrshire mainland' },
		{ code: 'UKM94', libelle: 'South Ayrshire' },
		{ code: 'UKM95', libelle: 'South Lanarkshire' },
		{ code: 'UKN', libelle: 'Northern Ireland' },
		{ code: 'UKN0', libelle: 'Northern Ireland' },
		{ code: 'UKN06', libelle: 'Belfast' },
		{ code: 'UKN07', libelle: 'Armagh City, Banbridge and Craigavon' },
		{ code: 'UKN08', libelle: 'Newry, Mourne and Down' },
		{ code: 'UKN09', libelle: 'Ards and North Down ' },
		{ code: 'UKN0A', libelle: 'Derry City and Strabane' },
		{ code: 'UKN0B', libelle: 'Mid Ulster' },
		{ code: 'UKN0C', libelle: 'Causeway Coast and Glens' },
		{ code: 'UKN0D', libelle: 'Antrim and Newtownabbey' },
		{ code: 'UKN0E', libelle: 'Lisburn and Castlereagh' },
		{ code: 'UKN0F', libelle: 'Mid and East Antrim' },
		{ code: 'UKN0G', libelle: 'Fermanagh and Omagh' },
		{ code: 'UKZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'UKZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'UKZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: '', libelle: '0' },
		{ code: 'Statistical regions (EFTA countries, candidate countries, potential candidates, other partners (Eastern Partnership etc.):', libelle: '0' },
		{ code: '', libelle: '0' },
		{ code: 'IS', libelle: 'Ísland' },
		{ code: 'IS0', libelle: 'Ísland' },
		{ code: 'IS00', libelle: 'Ísland' },
		{ code: 'IS001', libelle: 'Höfuðborgarsvæði' },
		{ code: 'IS002', libelle: 'Landsbyggð' },
		{ code: 'ISZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'ISZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'ISZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'LI', libelle: 'Liechtenstein' },
		{ code: 'LI0', libelle: 'Liechtenstein' },
		{ code: 'LI00', libelle: 'Liechtenstein' },
		{ code: 'LI000', libelle: 'Liechtenstein' },
		{ code: 'LIZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'LIZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'LIZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'NO', libelle: 'Norge' },
		{ code: 'NO0', libelle: 'Norge' },
		{ code: 'NO02', libelle: 'Innlandet' },
		{ code: 'NO020', libelle: 'Innlandet' },
		{ code: 'NO06', libelle: 'Trøndelag' },
		{ code: 'NO060', libelle: 'Trøndelag' },
		{ code: 'NO07', libelle: 'Nord-Norge' },
		{ code: 'NO071', libelle: 'Nordland' },
		{ code: 'NO074', libelle: 'Troms og Finnmark' },
		{ code: 'NO08', libelle: 'Oslo og Viken' },
		{ code: 'NO081', libelle: 'Oslo' },
		{ code: 'NO082', libelle: 'Viken' },
		{ code: 'NO09', libelle: 'Agder og Sør-Østlandet' },
		{ code: 'NO091', libelle: 'Vestfold og Telemark' },
		{ code: 'NO092', libelle: 'Agder' },
		{ code: 'NO0A', libelle: 'Vestlandet' },
		{ code: 'NO0A1', libelle: 'Rogaland' },
		{ code: 'NO0A2', libelle: 'Vestland' },
		{ code: 'NO0A3', libelle: 'Møre og Romsdal' },
		{ code: 'NO0B', libelle: 'Svalbard og Jan Mayen' },
		{ code: 'NO0B1', libelle: 'Jan Mayen' },
		{ code: 'NO0B2', libelle: 'Svalbard' },
		{ code: 'NOZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'NOZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'NOZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'CH', libelle: 'Schweiz/Suisse/Svizzera' },
		{ code: 'CH0', libelle: 'Schweiz/Suisse/Svizzera' },
		{ code: 'CH01', libelle: 'Région lémanique' },
		{ code: 'CH011', libelle: 'Vaud' },
		{ code: 'CH012', libelle: 'Valais / Wallis' },
		{ code: 'CH013', libelle: 'Genève' },
		{ code: 'CH02', libelle: 'Espace Mittelland' },
		{ code: 'CH021', libelle: 'Bern / Berne' },
		{ code: 'CH022', libelle: 'Fribourg / Freiburg' },
		{ code: 'CH023', libelle: 'Solothurn' },
		{ code: 'CH024', libelle: 'Neuchâtel' },
		{ code: 'CH025', libelle: 'Jura' },
		{ code: 'CH03', libelle: 'Nordwestschweiz' },
		{ code: 'CH031', libelle: 'Basel-Stadt' },
		{ code: 'CH032', libelle: 'Basel-Landschaft' },
		{ code: 'CH033', libelle: 'Aargau' },
		{ code: 'CH04', libelle: 'Zürich' },
		{ code: 'CH040', libelle: 'Zürich' },
		{ code: 'CH05', libelle: 'Ostschweiz' },
		{ code: 'CH051', libelle: 'Glarus' },
		{ code: 'CH052', libelle: 'Schaffhausen' },
		{ code: 'CH053', libelle: 'Appenzell Ausserrhoden' },
		{ code: 'CH054', libelle: 'Appenzell Innerrhoden' },
		{ code: 'CH055', libelle: 'St. Gallen' },
		{ code: 'CH056', libelle: 'Graubünden / Grigioni / Grischun' },
		{ code: 'CH057', libelle: 'Thurgau' },
		{ code: 'CH06', libelle: 'Zentralschweiz' },
		{ code: 'CH061', libelle: 'Luzern' },
		{ code: 'CH062', libelle: 'Uri' },
		{ code: 'CH063', libelle: 'Schwyz' },
		{ code: 'CH064', libelle: 'Obwalden' },
		{ code: 'CH065', libelle: 'Nidwalden' },
		{ code: 'CH066', libelle: 'Zug' },
		{ code: 'CH07', libelle: 'Ticino' },
		{ code: 'CH070', libelle: 'Ticino' },
		{ code: 'CHZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'CHZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'CHZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'ME', libelle: 'Црна Гора ' },
		{ code: 'ME0', libelle: 'Црна Гора ' },
		{ code: 'ME00', libelle: 'Црна Гора' },
		{ code: 'ME000', libelle: 'Црна Гора' },
		{ code: 'MEZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'MEZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'MEZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'MK', libelle: 'Северна Македонија' },
		{ code: 'MK0', libelle: 'Северна Македонија' },
		{ code: 'MK00', libelle: 'Северна Македонија' },
		{ code: 'MK001', libelle: 'Вардарски' },
		{ code: 'MK002', libelle: 'Источен' },
		{ code: 'MK003', libelle: 'Југозападен' },
		{ code: 'MK004', libelle: 'Југоисточен' },
		{ code: 'MK005', libelle: 'Пелагониски' },
		{ code: 'MK006', libelle: 'Полошки' },
		{ code: 'MK007', libelle: 'Североисточен' },
		{ code: 'MK008', libelle: 'Скопски' },
		{ code: 'MKZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'MKZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'MKZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'AL', libelle: 'Shqipëria' },
		{ code: 'AL0', libelle: 'Shqipëria' },
		{ code: 'AL01', libelle: 'Veri' },
		{ code: 'AL011', libelle: 'Dibër' },
		{ code: 'AL012', libelle: 'Durrës' },
		{ code: 'AL013', libelle: 'Kukës' },
		{ code: 'AL014', libelle: 'Lezhë' },
		{ code: 'AL015', libelle: 'Shkodër' },
		{ code: 'AL02', libelle: 'Qender' },
		{ code: 'AL021', libelle: 'Elbasan' },
		{ code: 'AL022', libelle: 'Tiranë' },
		{ code: 'AL03', libelle: 'Jug' },
		{ code: 'AL031', libelle: 'Berat' },
		{ code: 'AL032', libelle: 'Fier' },
		{ code: 'AL033', libelle: 'Gjirokastër' },
		{ code: 'AL034', libelle: 'Korcë' },
		{ code: 'AL035', libelle: 'Vlorë' },
		{ code: 'ALZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'ALZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'ALZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'RS', libelle: 'Srbija/Сpбија' },
		{ code: 'RS1', libelle: 'Србија - север ' },
		{ code: 'RS11', libelle: 'Београдски регион' },
		{ code: 'RS110', libelle: 'Београдска област' },
		{ code: 'RS12', libelle: 'Регион Војводине' },
		{ code: 'RS121', libelle: 'Западнобачка област' },
		{ code: 'RS122', libelle: 'Јужнобанатска област' },
		{ code: 'RS123', libelle: 'Јужнобачка област' },
		{ code: 'RS124', libelle: 'Севернобанатска област' },
		{ code: 'RS125', libelle: 'Севернобачка област' },
		{ code: 'RS126', libelle: 'Средњобанатска област' },
		{ code: 'RS127', libelle: 'Сремска област' },
		{ code: 'RS2', libelle: 'Србија - југ ' },
		{ code: 'RS21', libelle: 'Регион Шумадије и Западне Србије' },
		{ code: 'RS211', libelle: 'Златиборска област' },
		{ code: 'RS212', libelle: 'Колубарска област' },
		{ code: 'RS213', libelle: 'Мачванска област' },
		{ code: 'RS214', libelle: 'Моравичка област' },
		{ code: 'RS215', libelle: 'Поморавска област' },
		{ code: 'RS216', libelle: 'Расинска област' },
		{ code: 'RS217', libelle: 'Рашка област' },
		{ code: 'RS218', libelle: 'Шумадијска област' },
		{ code: 'RS22', libelle: 'Регион Јужне и Источне Србије' },
		{ code: 'RS221', libelle: 'Борска област' },
		{ code: 'RS222', libelle: 'Браничевска област' },
		{ code: 'RS223', libelle: 'Зајечарска област' },
		{ code: 'RS224', libelle: 'Јабланичка област' },
		{ code: 'RS225', libelle: 'Нишавска област' },
		{ code: 'RS226', libelle: 'Пиротска област' },
		{ code: 'RS227', libelle: 'Подунавска област' },
		{ code: 'RS228', libelle: 'Пчињска област' },
		{ code: 'RS229', libelle: 'Топличка област' },
		{ code: 'RSZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'RSZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'RSZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: 'TR', libelle: 'Türkiye' },
		{ code: 'TR1', libelle: 'İstanbul' },
		{ code: 'TR10', libelle: 'İstanbul' },
		{ code: 'TR100', libelle: 'İstanbul' },
		{ code: 'TR2', libelle: 'Batı Marmara' },
		{ code: 'TR21', libelle: 'Tekirdağ, Edirne, Kırklareli' },
		{ code: 'TR211', libelle: 'Tekirdağ' },
		{ code: 'TR212', libelle: 'Edirne' },
		{ code: 'TR213', libelle: 'Kırklareli' },
		{ code: 'TR22', libelle: 'Balıkesir, Çanakkale' },
		{ code: 'TR221', libelle: 'Balıkesir' },
		{ code: 'TR222', libelle: 'Çanakkale' },
		{ code: 'TR3', libelle: 'Ege' },
		{ code: 'TR31', libelle: 'İzmir' },
		{ code: 'TR310', libelle: 'İzmir' },
		{ code: 'TR32', libelle: 'Aydın, Denizli, Muğla' },
		{ code: 'TR321', libelle: 'Aydın' },
		{ code: 'TR322', libelle: 'Denizli' },
		{ code: 'TR323', libelle: 'Muğla' },
		{ code: 'TR33', libelle: 'Manisa, Afyonkarahisar, Kütahya, Uşak' },
		{ code: 'TR331', libelle: 'Manisa' },
		{ code: 'TR332', libelle: 'Afyonkarahisar' },
		{ code: 'TR333', libelle: 'Kütahya' },
		{ code: 'TR334', libelle: 'Uşak' },
		{ code: 'TR4', libelle: 'Doğu Marmara' },
		{ code: 'TR41', libelle: 'Bursa, Eskişehir, Bilecik' },
		{ code: 'TR411', libelle: 'Bursa' },
		{ code: 'TR412', libelle: 'Eskişehir' },
		{ code: 'TR413', libelle: 'Bilecik' },
		{ code: 'TR42', libelle: 'Kocaeli, Sakarya, Düzce, Bolu, Yalova' },
		{ code: 'TR421', libelle: 'Kocaeli' },
		{ code: 'TR422', libelle: 'Sakarya' },
		{ code: 'TR423', libelle: 'Düzce' },
		{ code: 'TR424', libelle: 'Bolu' },
		{ code: 'TR425', libelle: 'Yalova' },
		{ code: 'TR5', libelle: 'Batı Anadolu' },
		{ code: 'TR51', libelle: 'Ankara' },
		{ code: 'TR510', libelle: 'Ankara' },
		{ code: 'TR52', libelle: 'Konya, Karaman' },
		{ code: 'TR521', libelle: 'Konya' },
		{ code: 'TR522', libelle: 'Karaman' },
		{ code: 'TR6', libelle: 'Akdeniz' },
		{ code: 'TR61', libelle: 'Antalya, Isparta, Burdur' },
		{ code: 'TR611', libelle: 'Antalya' },
		{ code: 'TR612', libelle: 'Isparta' },
		{ code: 'TR613', libelle: 'Burdur' },
		{ code: 'TR62', libelle: 'Adana, Mersin' },
		{ code: 'TR621', libelle: 'Adana' },
		{ code: 'TR622', libelle: 'Mersin' },
		{ code: 'TR63', libelle: 'Hatay, Kahramanmaraş, Osmaniye' },
		{ code: 'TR631', libelle: 'Hatay' },
		{ code: 'TR632', libelle: 'Kahramanmaraş' },
		{ code: 'TR633', libelle: 'Osmaniye' },
		{ code: 'TR7', libelle: 'Orta Anadolu' },
		{ code: 'TR71', libelle: 'Kırıkkale, Aksaray, Niğde, Nevşehir, Kırşehir' },
		{ code: 'TR711', libelle: 'Kırıkkale' },
		{ code: 'TR712', libelle: 'Aksaray' },
		{ code: 'TR713', libelle: 'Niğde' },
		{ code: 'TR714', libelle: 'Nevşehir' },
		{ code: 'TR715', libelle: 'Kırşehir' },
		{ code: 'TR72', libelle: 'Kayseri, Sivas, Yozgat' },
		{ code: 'TR721', libelle: 'Kayseri' },
		{ code: 'TR722', libelle: 'Sivas' },
		{ code: 'TR723', libelle: 'Yozgat' },
		{ code: 'TR8', libelle: 'Batı Karadeniz' },
		{ code: 'TR81', libelle: 'Zonguldak, Karabük, Bartın' },
		{ code: 'TR811', libelle: 'Zonguldak' },
		{ code: 'TR812', libelle: 'Karabük' },
		{ code: 'TR813', libelle: 'Bartın' },
		{ code: 'TR82', libelle: 'Kastamonu, Çankırı, Sinop' },
		{ code: 'TR821', libelle: 'Kastamonu' },
		{ code: 'TR822', libelle: 'Çankırı' },
		{ code: 'TR823', libelle: 'Sinop' },
		{ code: 'TR83', libelle: 'Samsun, Tokat, Çorum, Amasya' },
		{ code: 'TR831', libelle: 'Samsun' },
		{ code: 'TR832', libelle: 'Tokat' },
		{ code: 'TR833', libelle: 'Çorum' },
		{ code: 'TR834', libelle: 'Amasya' },
		{ code: 'TR9', libelle: 'Doğu Karadeniz' },
		{ code: 'TR90', libelle: 'Trabzon, Ordu, Giresun, Rize, Artvin, Gümüşhane' },
		{ code: 'TR901', libelle: 'Trabzon' },
		{ code: 'TR902', libelle: 'Ordu' },
		{ code: 'TR903', libelle: 'Giresun' },
		{ code: 'TR904', libelle: 'Rize' },
		{ code: 'TR905', libelle: 'Artvin' },
		{ code: 'TR906', libelle: 'Gümüşhane' },
		{ code: 'TRA', libelle: 'Kuzeydoğu Anadolu' },
		{ code: 'TRA1', libelle: 'Erzurum, Erzincan, Bayburt' },
		{ code: 'TRA11', libelle: 'Erzurum' },
		{ code: 'TRA12', libelle: 'Erzincan' },
		{ code: 'TRA13', libelle: 'Bayburt' },
		{ code: 'TRA2', libelle: 'Ağrı, Kars, Iğdır, Ardahan' },
		{ code: 'TRA21', libelle: 'Ağrı' },
		{ code: 'TRA22', libelle: 'Kars' },
		{ code: 'TRA23', libelle: 'Iğdır' },
		{ code: 'TRA24', libelle: 'Ardahan' },
		{ code: 'TRB', libelle: 'Ortadoğu Anadolu' },
		{ code: 'TRB1', libelle: 'Malatya, Elazığ, Bingöl, Tunceli' },
		{ code: 'TRB11', libelle: 'Malatya' },
		{ code: 'TRB12', libelle: 'Elazığ' },
		{ code: 'TRB13', libelle: 'Bingöl' },
		{ code: 'TRB14', libelle: 'Tunceli' },
		{ code: 'TRB2', libelle: 'Van, Muş, Bitlis, Hakkari' },
		{ code: 'TRB21', libelle: 'Van' },
		{ code: 'TRB22', libelle: 'Muş' },
		{ code: 'TRB23', libelle: 'Bitlis' },
		{ code: 'TRB24', libelle: 'Hakkari' },
		{ code: 'TRC', libelle: 'Güneydoğu Anadolu' },
		{ code: 'TRC1', libelle: 'Gaziantep, Adıyaman, Kilis' },
		{ code: 'TRC11', libelle: 'Gaziantep' },
		{ code: 'TRC12', libelle: 'Adıyaman' },
		{ code: 'TRC13', libelle: 'Kilis' },
		{ code: 'TRC2', libelle: 'Şanlıurfa, Diyarbakır' },
		{ code: 'TRC21', libelle: 'Şanlıurfa' },
		{ code: 'TRC22', libelle: 'Diyarbakır' },
		{ code: 'TRC3', libelle: 'Mardin, Batman, Şırnak, Siirt' },
		{ code: 'TRC31', libelle: 'Mardin' },
		{ code: 'TRC32', libelle: 'Batman' },
		{ code: 'TRC33', libelle: 'Şırnak' },
		{ code: 'TRC34', libelle: 'Siirt' },
		{ code: 'TRZ', libelle: 'Extra-Regio NUTS 1' },
		{ code: 'TRZZ', libelle: 'Extra-Regio NUTS 2' },
		{ code: 'TRZZZ', libelle: 'Extra-Regio NUTS 3' },
		{ code: '1A', libelle: '1A' },
		{ code: 'AD', libelle: 'AD' },
		{ code: 'AE', libelle: 'AE' },
		{ code: 'AF', libelle: 'AF' },
		{ code: 'AG', libelle: 'AG' },
		{ code: 'AI', libelle: 'AI' },
		{ code: 'AM', libelle: 'AM' },
		{ code: 'AO', libelle: 'AO' },
		{ code: 'AQ', libelle: 'AQ' },
		{ code: 'AR', libelle: 'AR' },
		{ code: 'AS', libelle: 'AS' },
		{ code: 'AU', libelle: 'AU' },
		{ code: 'AW', libelle: 'AW' },
		{ code: 'AZ', libelle: 'AZ' },
		{ code: 'BA', libelle: 'BA' },
		{ code: 'BB', libelle: 'BB' },
		{ code: 'BD', libelle: 'BD' },
		{ code: 'BF', libelle: 'BF' },
		{ code: 'BH', libelle: 'BH' },
		{ code: 'BI', libelle: 'BI' },
		{ code: 'BJ', libelle: 'BJ' },
		{ code: 'BL', libelle: 'BL' },
		{ code: 'BM', libelle: 'BM' },
		{ code: 'BN', libelle: 'BN' },
		{ code: 'BO', libelle: 'BO' },
		{ code: 'BQ', libelle: 'BQ' },
		{ code: 'BR', libelle: 'BR' },
		{ code: 'BS', libelle: 'BS' },
		{ code: 'BT', libelle: 'BT' },
		{ code: 'BV', libelle: 'BV' },
		{ code: 'BW', libelle: 'BW' },
		{ code: 'BY', libelle: 'BY' },
		{ code: 'BZ', libelle: 'BZ' },
		{ code: 'CA', libelle: 'CA' },
		{ code: 'CC', libelle: 'CC' },
		{ code: 'CD', libelle: 'CD' },
		{ code: 'CF', libelle: 'CF' },
		{ code: 'CG', libelle: 'CG' },
		{ code: 'CI', libelle: 'CI' },
		{ code: 'CK', libelle: 'CK' },
		{ code: 'CL', libelle: 'CL' },
		{ code: 'CM', libelle: 'CM' },
		{ code: 'CN', libelle: 'CN' },
		{ code: 'CO', libelle: 'CO' },
		{ code: 'CP', libelle: 'CP' },
		{ code: 'CR', libelle: 'CR' },
		{ code: 'CU', libelle: 'CU' },
		{ code: 'CV', libelle: 'CV' },
		{ code: 'CW', libelle: 'CW' },
		{ code: 'CX', libelle: 'CX' },
		{ code: 'DJ', libelle: 'DJ' },
		{ code: 'DM', libelle: 'DM' },
		{ code: 'DO', libelle: 'DO' },
		{ code: 'DZ', libelle: 'DZ' },
		{ code: 'EC', libelle: 'EC' },
		{ code: 'EG', libelle: 'EG' },
		{ code: 'EH', libelle: 'EH' },
		{ code: 'ER', libelle: 'ER' },
		{ code: 'ET', libelle: 'ET' },
		{ code: 'FJ', libelle: 'FJ' },
		{ code: 'FK', libelle: 'FK' },
		{ code: 'FM', libelle: 'FM' },
		{ code: 'FO', libelle: 'FO' },
		{ code: 'GA', libelle: 'GA' },
		{ code: 'GD', libelle: 'GD' },
		{ code: 'GE', libelle: 'GE' },
		{ code: 'GG', libelle: 'GG' },
		{ code: 'GH', libelle: 'GH' },
		{ code: 'GL', libelle: 'GL' },
		{ code: 'GM', libelle: 'GM' },
		{ code: 'GN', libelle: 'GN' },
		{ code: 'GQ', libelle: 'GQ' },
		{ code: 'GS', libelle: 'GS' },
		{ code: 'GT', libelle: 'GT' },
		{ code: 'GU', libelle: 'GU' },
		{ code: 'GW', libelle: 'GW' },
		{ code: 'GY', libelle: 'GY' },
		{ code: 'HK', libelle: 'HK' },
		{ code: 'HM', libelle: 'HM' },
		{ code: 'HN', libelle: 'HN' },
		{ code: 'HT', libelle: 'HT' },
		{ code: 'ID', libelle: 'ID' },
		{ code: 'IL', libelle: 'IL' },
		{ code: 'IM', libelle: 'IM' },
		{ code: 'IN', libelle: 'IN' },
		{ code: 'IO', libelle: 'IO' },
		{ code: 'IQ', libelle: 'IQ' },
		{ code: 'IR', libelle: 'IR' },
		{ code: 'JE', libelle: 'JE' },
		{ code: 'JM', libelle: 'JM' },
		{ code: 'JO', libelle: 'JO' },
		{ code: 'JP', libelle: 'JP' },
		{ code: 'KE', libelle: 'KE' },
		{ code: 'KG', libelle: 'KG' },
		{ code: 'KH', libelle: 'KH' },
		{ code: 'KI', libelle: 'KI' },
		{ code: 'KM', libelle: 'KM' },
		{ code: 'KN', libelle: 'KN' },
		{ code: 'KP', libelle: 'KP' },
		{ code: 'KR', libelle: 'KR' },
		{ code: 'KW', libelle: 'KW' },
		{ code: 'KY', libelle: 'KY' },
		{ code: 'KZ', libelle: 'KZ' },
		{ code: 'LA', libelle: 'LA' },
		{ code: 'LB', libelle: 'LB' },
		{ code: 'LC', libelle: 'LC' },
		{ code: 'LK', libelle: 'LK' },
		{ code: 'LR', libelle: 'LR' },
		{ code: 'LS', libelle: 'LS' },
		{ code: 'LY', libelle: 'LY' },
		{ code: 'MA', libelle: 'MA' },
		{ code: 'MC', libelle: 'MC' },
		{ code: 'MD', libelle: 'MD' },
		{ code: 'MG', libelle: 'MG' },
		{ code: 'MH', libelle: 'MH' },
		{ code: 'ML', libelle: 'ML' },
		{ code: 'MM', libelle: 'MM' },
		{ code: 'MN', libelle: 'MN' },
		{ code: 'MO', libelle: 'MO' },
		{ code: 'MP', libelle: 'MP' },
		{ code: 'MR', libelle: 'MR' },
		{ code: 'MS', libelle: 'MS' },
		{ code: 'MU', libelle: 'MU' },
		{ code: 'MV', libelle: 'MV' },
		{ code: 'MW', libelle: 'MW' },
		{ code: 'MX', libelle: 'MX' },
		{ code: 'MY', libelle: 'MY' },
		{ code: 'MZ', libelle: 'MZ' },
		{ code: 'NA', libelle: 'NA' },
		{ code: 'NC', libelle: 'NC' },
		{ code: 'NE', libelle: 'NE' },
		{ code: 'NF', libelle: 'NF' },
		{ code: 'NG', libelle: 'NG' },
		{ code: 'NI', libelle: 'NI' },
		{ code: 'NP', libelle: 'NP' },
		{ code: 'NR', libelle: 'NR' },
		{ code: 'NU', libelle: 'NU' },
		{ code: 'NZ', libelle: 'NZ' },
		{ code: 'OM', libelle: 'OM' },
		{ code: 'PA', libelle: 'PA' },
		{ code: 'PE', libelle: 'PE' },
		{ code: 'PF', libelle: 'PF' },
		{ code: 'PG', libelle: 'PG' },
		{ code: 'PH', libelle: 'PH' },
		{ code: 'PK', libelle: 'PK' },
		{ code: 'PM', libelle: 'PM' },
		{ code: 'PN', libelle: 'PN' },
		{ code: 'PR', libelle: 'PR' },
		{ code: 'PS', libelle: 'PS' },
		{ code: 'PW', libelle: 'PW' },
		{ code: 'PY', libelle: 'PY' },
		{ code: 'QA', libelle: 'QA' },
		{ code: 'RU', libelle: 'RU' },
		{ code: 'RW', libelle: 'RW' },
		{ code: 'SA', libelle: 'SA' },
		{ code: 'SB', libelle: 'SB' },
		{ code: 'SC', libelle: 'SC' },
		{ code: 'SD', libelle: 'SD' },
		{ code: 'SG', libelle: 'SG' },
		{ code: 'SH', libelle: 'SH' },
		{ code: 'SJ', libelle: 'SJ' },
		{ code: 'SL', libelle: 'SL' },
		{ code: 'SM', libelle: 'SM' },
		{ code: 'SN', libelle: 'SN' },
		{ code: 'SO', libelle: 'SO' },
		{ code: 'SR', libelle: 'SR' },
		{ code: 'SS', libelle: 'SS' },
		{ code: 'ST', libelle: 'ST' },
		{ code: 'SV', libelle: 'SV' },
		{ code: 'SX', libelle: 'SX' },
		{ code: 'SY', libelle: 'SY' },
		{ code: 'SZ', libelle: 'SZ' },
		{ code: 'TC', libelle: 'TC' },
		{ code: 'TD', libelle: 'TD' },
		{ code: 'TF', libelle: 'TF' },
		{ code: 'TG', libelle: 'TG' },
		{ code: 'TH', libelle: 'TH' },
		{ code: 'TJ', libelle: 'TJ' },
		{ code: 'TK', libelle: 'TK' },
		{ code: 'TL', libelle: 'TL' },
		{ code: 'TM', libelle: 'TM' },
		{ code: 'TN', libelle: 'TN' },
		{ code: 'TO', libelle: 'TO' },
		{ code: 'TT', libelle: 'TT' },
		{ code: 'TV', libelle: 'TV' },
		{ code: 'TW', libelle: 'TW' },
		{ code: 'TZ', libelle: 'TZ' },
		{ code: 'UA', libelle: 'UA' },
		{ code: 'UG', libelle: 'UG' },
		{ code: 'UM', libelle: 'UM' },
		{ code: 'US', libelle: 'US' },
		{ code: 'UY', libelle: 'UY' },
		{ code: 'UZ', libelle: 'UZ' },
		{ code: 'VA', libelle: 'VA' },
		{ code: 'VC', libelle: 'VC' },
		{ code: 'VE', libelle: 'VE' },
		{ code: 'VG', libelle: 'VG' },
		{ code: 'VI', libelle: 'VI' },
		{ code: 'VN', libelle: 'VN' },
		{ code: 'VU', libelle: 'VU' },
		{ code: 'WF', libelle: 'WF' },
		{ code: 'WS', libelle: 'WS' },
		{ code: 'YE', libelle: 'YE' },
		{ code: 'ZA', libelle: 'ZA' },
		{ code: 'ZM', libelle: 'ZM' },
		{ code: 'ZW', libelle: 'ZW' }];

	private pays = [
		{ code: '', libelle: 'FRANCE' },
		{ code: 'AD', libelle: 'ANDORRE' },
		{ code: 'AE', libelle: 'EMIRATS ARABES UNIS' },
		{ code: 'AF', libelle: 'AFGHANISTAN' },
		{ code: 'AG', libelle: 'ANTIGUA ET BARBUDA' },
		{ code: 'AI', libelle: 'ANGUILLA' },
		{ code: 'AL', libelle: 'ALBANIE' },
		{ code: 'AM', libelle: 'ARMÉNIE' },
		// { code: 'AN', libelle: 'ANTILLES NÉERLANDAISES'},
		{ code: 'AO', libelle: 'ANGOLA' },
		{ code: 'AQ', libelle: 'ANTARCTIQUE' },
		{ code: 'AR', libelle: 'ARGENTINE' },
		{ code: 'AS', libelle: 'SAMOA AMÉRICAINES' },
		{ code: 'AT', libelle: 'AUTRICHE' },
		{ code: 'AU', libelle: 'AUSTRALIE' },
		{ code: 'AW', libelle: 'ARUBA' },
		{ code: 'AX', libelle: 'ÅLAND, ÎLES' },
		{ code: 'AZ', libelle: 'AZERBAÏDJAN' },
		{ code: 'BA', libelle: 'BOSNIE-HERZÉGOVINE' },
		{ code: 'BB', libelle: 'BARBADE' },
		{ code: 'BD', libelle: 'BANGLADESH' },
		{ code: 'BE', libelle: 'BELGIQUE' },
		{ code: 'BF', libelle: 'BURKINA FASO' },
		{ code: 'BG', libelle: 'BULGARIE' },
		{ code: 'BH', libelle: 'BAHREIN' },
		{ code: 'BI', libelle: 'BURUNDI' },
		{ code: 'BJ', libelle: 'BÉNIN' },
		{ code: 'BL', libelle: 'SAINT-BARTHÉLEMY' },
		{ code: 'BM', libelle: 'BERMUDES' },
		{ code: 'BN', libelle: 'BRUNÉI DARUSSALAM' },
		{ code: 'BO', libelle: 'BOLIVIE (ÉTAT PLURINATIONAL DE)' },
		{ code: 'BQ', libelle: 'BONAIRE, SAINT-EUSTACHE ET SABA' },
		{ code: 'BR', libelle: 'BRÉSIL' },
		{ code: 'BS', libelle: 'BAHAMAS' },
		{ code: 'BT', libelle: 'BHOUTAN' },
		{ code: 'BV', libelle: 'BOUVET, ILE' },
		{ code: 'BW', libelle: 'BOTSWANA' },
		{ code: 'BY', libelle: 'BÉLARUS' },
		{ code: 'BZ', libelle: 'BÉLIZE' },
		{ code: 'CA', libelle: 'CANADA' },
		{ code: 'CC', libelle: 'COCOS/KEELING (ÎLES)' },
		{ code: 'CD', libelle: 'CONGO, RÉPUBLIQUE DÉMOCRATIQUE DU' },
		{ code: 'CF', libelle: 'RÉPUBLIQUE CENTRAFRICAINE' },
		{ code: 'CG', libelle: 'CONGO' },
		{ code: 'CH', libelle: 'SUISSE' },
		{ code: 'CI', libelle: 'CÔTE D\'IVOIRE' },
		{ code: 'CK', libelle: 'COOK, ILES' },
		{ code: 'CL', libelle: 'CHILI' },
		{ code: 'CM', libelle: 'CAMEROUN' },
		{ code: 'CN', libelle: 'CHINE' },
		{ code: 'CO', libelle: 'COLOMBIE' },
		//{ code: 'CP', libelle: '' },
		{ code: 'CR', libelle: 'COSTA RICA' },
		{ code: 'CU', libelle: 'CUBA' },
		{ code: 'CV', libelle: 'CAP-VERT' },
		{ code: 'CW', libelle: 'CURAÇAO' },
		{ code: 'CX', libelle: 'CHRISTMAS, ÎLE' },
		{ code: 'CY', libelle: 'CHYPRE' },
		{ code: 'CZ', libelle: 'TCHÈQUE, RÉPUBLIQUE' },
		{ code: 'DE', libelle: 'ALLEMAGNE' },
		{ code: 'DJ', libelle: 'DJIBOUTI' },
		{ code: 'DK', libelle: 'DANEMARK' },
		{ code: 'DM', libelle: 'DOMINIQUE' },
		{ code: 'DO', libelle: 'DOMINICAINE, RÉPUBLIQUE' },
		{ code: 'DZ', libelle: 'ALGÉRIE' },
		{ code: 'EC', libelle: 'EQUATEUR' },
		{ code: 'EE', libelle: 'ESTONIE' },
		{ code: 'EG', libelle: 'EGYPTE' },
		{ code: 'EH', libelle: 'SAHARA OCCIDENTAL' },
		{ code: 'ER', libelle: 'ERYTHRÉE' },
		{ code: 'ES', libelle: 'ESPAGNE' },
		{ code: 'ET', libelle: 'ETHIOPIE' },
		{ code: 'FI', libelle: 'FINLANDE' },
		{ code: 'FJ', libelle: 'FIDJI' },
		{ code: 'FK', libelle: 'FALKLAND/MALOUINES (ÎLES)' },
		{ code: 'FM', libelle: 'MICRONÉSIE, ETATS FÉDÉRÉS DE' },
		{ code: 'FO', libelle: 'FÉROÉ, ÎLES' },
		//{ code: 'FR' , libelle : 'FRANCE'},
		{ code: 'GA', libelle: 'GABON' },
		// { code: 'GB' , libelle : 'ROYAUME-UNI'},
		{ code: 'GD', libelle: 'GRENADE' },
		{ code: 'GE', libelle: 'GÉORGIE' },
		{ code: 'GF', libelle: 'GUYANE FRANÇAISE' },
		{ code: 'GG', libelle: 'GUERNESEY' },
		{ code: 'GH', libelle: 'GHANA' },
		{ code: 'GI', libelle: 'GIBRALTAR' },
		{ code: 'GL', libelle: 'GROENLAND' },
		{ code: 'GM', libelle: 'GAMBIE' },
		{ code: 'GN', libelle: 'GUINÉE' },
		{ code: 'GP', libelle: 'GUADELOUPE' },
		{ code: 'GQ', libelle: 'GUINÉE ÉQUATORIALE' },
		{ code: 'GR', libelle: 'GRÈCE' },
		{ code: 'GS', libelle: 'GÉORGIE DU SUD ET LES ÎLES SANDWICH DU SUD' },
		{ code: 'GT', libelle: 'GUATEMALA' },
		{ code: 'GU', libelle: 'GUAM' },
		{ code: 'GW', libelle: 'GUINÉE-BISSAU' },
		{ code: 'GY', libelle: 'GUYANA' },
		{ code: 'HK', libelle: 'HONG KONG' },
		{ code: 'HM', libelle: 'HEARD, ILE ET MACDONALD, ÎLES' },
		{ code: 'HN', libelle: 'HONDURAS' },
		{ code: 'HR', libelle: 'CROATIE' },
		{ code: 'HT', libelle: 'HAÏTI' },
		{ code: 'HU', libelle: 'HONGRIE' },
		{ code: 'ID', libelle: 'INDONÉSIE' },
		{ code: 'IE', libelle: 'IRLANDE' },
		{ code: 'IL', libelle: 'ISRAËL' },
		{ code: 'IM', libelle: 'ÎLE DE MAN' },
		{ code: 'IN', libelle: 'INDE' },
		{ code: 'IO', libelle: 'INDIEN (TERRITOIRE BRITANNIQUE DE L\'OCÉAN)' },
		{ code: 'IQ', libelle: 'IRAQ' },
		{ code: 'IR', libelle: 'IRAN, RÉPUBLIQUE ISLAMIQUE D\'' },
		{ code: 'IS', libelle: 'ISLANDE' },
		{ code: 'IT', libelle: 'ITALIE' },
		{ code: 'JE', libelle: 'JERSEY' },
		{ code: 'JM', libelle: 'JAMAÏQUE' },
		{ code: 'JO', libelle: 'JORDANIE' },
		{ code: 'JP', libelle: 'JAPON' },
		{ code: 'KE', libelle: 'KENYA' },
		{ code: 'KG', libelle: 'KIRGHIZISTAN' },
		{ code: 'KH', libelle: 'CAMBODGE' },
		{ code: 'KI', libelle: 'KIRIBATI' },
		{ code: 'KM', libelle: 'COMORES' },
		{ code: 'KN', libelle: 'SAINT-KITTS-ET-NEVIS' },
		{ code: 'KP', libelle: 'CORÉE, RÉPUBLIQUE POPULAIRE DÉMOCRATIQUE DE' },
		{ code: 'KR', libelle: 'CORÉE, RÉPUBLIQUE DE' },
		{ code: 'KW', libelle: 'KOWEÏT' },
		{ code: 'KY', libelle: 'CAÏMANS, ILES' },
		{ code: 'KZ', libelle: 'KAZAKHSTAN' },
		{ code: 'LA', libelle: 'LAO, RÉPUBLIQUE DÉMOCRATIQUE POPULAIRE' },
		{ code: 'LB', libelle: 'LIBAN' },
		{ code: 'LC', libelle: 'SAINTE-LUCIE' },
		{ code: 'LI', libelle: 'LIECHTENSTEIN' },
		{ code: 'LK', libelle: 'SRI LANKA' },
		{ code: 'LR', libelle: 'LIBÉRIA' },
		{ code: 'LS', libelle: 'LESOTHO' },
		{ code: 'LT', libelle: 'LITUANIE' },
		{ code: 'LU', libelle: 'LUXEMBOURG' },
		{ code: 'LV', libelle: 'LETTONIE' },
		{ code: 'LY', libelle: 'LIBYE' },
		{ code: 'MA', libelle: 'MAROC' },
		{ code: 'MC', libelle: 'MONACO' },
		{ code: 'MD', libelle: 'MOLDOVA, RÉPUBLIQUE DE' },
		{ code: 'ME', libelle: 'MONTÉNÉGRO' },
		{ code: 'MF', libelle: 'SAINT-MARTIN (PARTIE FRANÇAISE)' },
		{ code: 'MG', libelle: 'MADAGASCAR' },
		{ code: 'MH', libelle: 'MARSHALL, ILES' },
		{ code: 'MK', libelle: 'MACÉDOINE, L\'EX-RÉPUBLIQUE YOUGOSLAVE DE' },
		{ code: 'ML', libelle: 'MALI' },
		{ code: 'MM', libelle: 'MYANMAR' },
		{ code: 'MN', libelle: 'MONGOLIE' },
		{ code: 'MO', libelle: 'MACAO' },
		{ code: 'MP', libelle: 'MARIANNES DU NORD, ILES' },
		{ code: 'MQ', libelle: 'MARTINIQUE' },
		{ code: 'MR', libelle: 'MAURITANIE' },
		{ code: 'MS', libelle: 'MONTSERRAT' },
		{ code: 'MT', libelle: 'MALTE' },
		{ code: 'MU', libelle: 'MAURICE' },
		{ code: 'MV', libelle: 'MALDIVES' },
		{ code: 'MW', libelle: 'MALAWI' },
		{ code: 'MX', libelle: 'MEXIQUE' },
		{ code: 'MY', libelle: 'MALAISIE' },
		{ code: 'MZ', libelle: 'MOZAMBIQUE' },
		{ code: 'NA', libelle: 'NAMIBIE' },
		{ code: 'NC', libelle: 'NOUVELLE-CALÉDONIE' },
		{ code: 'NE', libelle: 'NIGER' },
		{ code: 'NF', libelle: 'NORFOLK, ILE' },
		{ code: 'NG', libelle: 'NIGÉRIA' },
		{ code: 'NI', libelle: 'NICARAGUA' },
		{ code: 'NL', libelle: 'PAYS-BAS' },
		{ code: 'NO', libelle: 'NORVÈGE' },
		{ code: 'NP', libelle: 'NÉPAL' },
		{ code: 'NR', libelle: 'NAURU' },
		{ code: 'NU', libelle: 'NIUE' },
		{ code: 'NZ', libelle: 'NOUVELLE-ZÉLANDE' },
		{ code: 'OM', libelle: 'OMAN' },
		{ code: 'PA', libelle: 'PANAMA' },
		{ code: 'PE', libelle: 'PÉROU' },
		{ code: 'PF', libelle: 'POLYNÉSIE FRANÇAISE' },
		{ code: 'PG', libelle: 'PAPOUASIE-NOUVELLE-GUINÉE' },
		{ code: 'PH', libelle: 'PHILIPPINES' },
		{ code: 'PK', libelle: 'PAKISTAN' },
		{ code: 'PL', libelle: 'POLOGNE' },
		{ code: 'PM', libelle: 'SAINT-PIERRE-ET-MIQUELON' },
		{ code: 'PN', libelle: 'PITCAIRN' },
		{ code: 'PR', libelle: 'PORTO RICO' },
		{ code: 'PS', libelle: 'PALESTINE, ETAT DE' },
		{ code: 'PT', libelle: 'PORTUGAL' },
		{ code: 'PW', libelle: 'PALAOS' },
		{ code: 'PY', libelle: 'PARAGUAY' },
		{ code: 'QA', libelle: 'QATAR' },
		{ code: 'RE', libelle: 'RÉUNION' },
		{ code: 'RO', libelle: 'ROUMANIE' },
		{ code: 'RS', libelle: 'SERBIE' },
		{ code: 'RU', libelle: 'RUSSIE, FÉDÉRATION DE' },
		{ code: 'RW', libelle: 'RWANDA' },
		{ code: 'SA', libelle: 'ARABIE SAOUDITE' },
		{ code: 'SB', libelle: 'SALOMON, ILES' },
		{ code: 'SC', libelle: 'SEYCHELLES' },
		{ code: 'SD', libelle: 'SOUDAN' },
		{ code: 'SE', libelle: 'SUÈDE' },
		{ code: 'SG', libelle: 'SINGAPOUR' },
		{ code: 'SH', libelle: 'SAINTE-HÉLÈNE, ASCENSION ET TRISTAN DA CUNHA' },
		{ code: 'SI', libelle: 'SLOVÉNIE' },
		{ code: 'SJ', libelle: 'SVALBARD ET ÎLE JAN MAYEN' },
		{ code: 'SK', libelle: 'SLOVAQUIE' },
		{ code: 'SL', libelle: 'SIERRA LEONE' },
		{ code: 'SM', libelle: 'SAINT-MARIN' },
		{ code: 'SN', libelle: 'SÉNÉGAL' },
		{ code: 'SO', libelle: 'SOMALIE' },
		{ code: 'SR', libelle: 'SURINAME' },
		{ code: 'SS', libelle: 'SOUDAN DU SUD' },
		{ code: 'ST', libelle: 'SAO TOMÉ-ET-PRINCIPE' },
		{ code: 'SV', libelle: 'EL SALVADOR' },
		{ code: 'SX', libelle: 'SAINT-MARTIN (PARTIE NÉERLANDAISE)' },
		{ code: 'SY', libelle: 'RÉPUBLIQUE ARABE SYRIENNE' },
		{ code: 'SZ', libelle: 'SWAZILAND' },
		{ code: 'TC', libelle: 'TURKS-ET-CAÏCOS (ÎLES)' },
		{ code: 'TD', libelle: 'TCHAD' },
		{ code: 'TF', libelle: 'TERRES AUSTRALES FRANÇAISES' },
		{ code: 'TG', libelle: 'TOGO' },
		{ code: 'TH', libelle: 'THAÏLANDE' },
		{ code: 'TJ', libelle: 'TADJIKISTAN' },
		{ code: 'TK', libelle: 'TOKELAU' },
		{ code: 'TL', libelle: 'TIMOR-LESTE' },
		{ code: 'TM', libelle: 'TURKMÉNISTAN' },
		{ code: 'TN', libelle: 'TUNISIE' },
		{ code: 'TO', libelle: 'TONGA' },
		{ code: 'TR', libelle: 'TURQUIE' },
		{ code: 'TT', libelle: 'TRINITÉ-ET-TOBAGO' },
		{ code: 'TV', libelle: 'TUVALU' },
		{ code: 'TW', libelle: 'TAÏWAN, PROVINCE DE CHINE' },
		{ code: 'TZ', libelle: 'TANZANIE, RÉPUBLIQUE UNIE DE' },
		{ code: 'UA', libelle: 'UKRAINE' },
		{ code: 'UG', libelle: 'OUGANDA' },
		{ code: 'UK', libelle: 'ROYAUME-UNI (UNITED KINGDOM)' },
		{ code: 'UM', libelle: 'ÎLES MINEURES ÉLOIGNÉES DES ETATS-UNIS' },
		{ code: 'US', libelle: 'ETATS-UNIS D\'AMÉRIQUE' },
		{ code: 'UY', libelle: 'URUGUAY' },
		{ code: 'UZ', libelle: 'OUZBÉKISTAN' },
		{ code: 'VA', libelle: 'SAINT-SIÈGE' },
		{ code: 'VC', libelle: 'SAINT-VINCENT-ET-LES-GRENADINES' },
		{ code: 'VE', libelle: 'VENEZUELA (RÉPUBLIQUE BOLIVARIENNE DU)' },
		{ code: 'VG', libelle: 'ÎLES VIERGES BRITANNIQUES' },
		{ code: 'VI', libelle: 'ÎLES VIERGES DES ETATS-UNIS' },
		{ code: 'VN', libelle: 'VIET NAM' },
		{ code: 'VU', libelle: 'VANUATU' },
		{ code: 'WF', libelle: 'WALLIS ET FUTUNA' },
		{ code: 'WS', libelle: 'SAMOA' },
		{ code: 'YE', libelle: 'YÉMEN' },
		{ code: 'YT', libelle: 'MAYOTTE' },
		{ code: 'ZA', libelle: 'AFRIQUE DU SUD' },
		{ code: 'ZM', libelle: 'ZAMBIE' },
		{ code: 'ZW', libelle: 'ZIMBABWE' }
	];

	private mot_clef = [
		{ code: '1', libelle: 'Abris' },
		{ code: '2', libelle: 'Abonnement' },
		{ code: '3', libelle: 'Acier' },
		{ code: '4', libelle: 'Aéronautique' },
		{ code: '5', libelle: 'Alarme' },
		{ code: '6', libelle: 'Alimentation en eau potable' },
		{ code: '7', libelle: 'Aliments pour animaux' },
		{ code: '8', libelle: 'Analyses médicales, biologiques' },
		{ code: '9', libelle: 'Animaux' },
		{ code: '10', libelle: 'Antenne' },
		{ code: '11', libelle: 'Appareil élévateur' },
		{ code: '12', libelle: 'Armement' },
		{ code: '13', libelle: 'Arrosage' },
		{ code: '14', libelle: 'Automatisation' },
		{ code: '15', libelle: 'Articles à usage unique' },
		{ code: '16', libelle: 'Articles de bureau et articles scolaires' },
		{ code: '17', libelle: 'Ascenseur' },
		{ code: '18', libelle: 'Assainissement' },
		{ code: '19', libelle: 'Assistance technique' },
		{ code: '20', libelle: 'Assurance' },
		{ code: '21', libelle: 'Audit' },
		{ code: '22', libelle: 'Audiovisuel' },
		{ code: '23', libelle: 'Autocommutateur' },
		{ code: '24', libelle: 'Amiante' },
		{ code: '27', libelle: 'Bâtiments modulaires' },
		{ code: '28', libelle: 'Bassin, étang' },
		{ code: '29', libelle: 'Banc d\'essais' },
		{ code: '30', libelle: 'Bardage' },
		{ code: '31', libelle: 'Barrage' },
		{ code: '32', libelle: 'Barquettes alimentaires' },
		{ code: '33', libelle: 'Bâtiment' },
		{ code: '34', libelle: 'Benne' },
		{ code: '35', libelle: 'Berge' },
		{ code: '36', libelle: 'Blanchissage' },
		{ code: '37', libelle: 'Blanchisserie (matériel)' },
		{ code: '38', libelle: 'Bois' },
		{ code: '39', libelle: 'Boisson' },
		{ code: '40', libelle: 'Busage' },
		{ code: '41', libelle: 'Boîtes aux lettres' },
		{ code: '45', libelle: 'Cd, DVD' },
		{ code: '46', libelle: 'Cabine de peinture' },
		{ code: '47', libelle: 'Câblage' },
		{ code: '48', libelle: 'Canalisations' },
		{ code: '49', libelle: 'Candélabre' },
		{ code: '50', libelle: 'Caoutchouc' },
		{ code: '51', libelle: 'Captage' },
		{ code: '52', libelle: 'Carburant, hydrocarbure' },
		{ code: '53', libelle: 'Carrelage' },
		{ code: '54', libelle: 'Carton' },
		{ code: '55', libelle: 'Cercueils' },
		{ code: '56', libelle: 'Chambre froide' },
		{ code: '57', libelle: 'Charpente' },
		{ code: '58', libelle: 'Chaudronnerie' },
		{ code: '59', libelle: 'Chauffage (exploitation, entretien)' },
		{ code: '60', libelle: 'Chauffage (matériel)' },
		{ code: '61', libelle: 'Chauffage (travaux)' },
		{ code: '62', libelle: 'Climatisation' },
		{ code: '63', libelle: 'Cloison, faux plafond' },
		{ code: '64', libelle: 'Clôture' },
		{ code: '65', libelle: 'Colis' },
		{ code: '66', libelle: 'Restauration collective' },
		{ code: '67', libelle: 'Conditionnement' },
		{ code: '68', libelle: 'Consommables informatiques' },
		{ code: '69', libelle: 'Consommables médicaux' },
		{ code: '70', libelle: 'Construction navale' },
		{ code: '71', libelle: 'Conteneur, poubelles' },
		{ code: '72', libelle: 'Contrôle technique' },
		{ code: '73', libelle: 'Couches' },
		{ code: '74', libelle: 'Couverture' },
		{ code: '75', libelle: 'Crédit-bail' },
		{ code: '76', libelle: 'Cuir' },
		{ code: '77', libelle: 'Cuisine (équipement)' },
		{ code: '78', libelle: 'Curage' },
		{ code: '79', libelle: 'Chaussures ou articles chaussants' },
		{ code: '80', libelle: 'Clocher' },
		{ code: '81', libelle: 'Contrôle d\'accès' },
		{ code: '82', libelle: 'Collecte sélective' },
		{ code: '83', libelle: 'Déclencheur d\'avalanche,explosif' },
		{ code: '84', libelle: 'Décharge' },
		{ code: '85', libelle: 'Décoration (travaux)' },
		{ code: '86', libelle: 'Déménagement' },
		{ code: '87', libelle: 'Démolition' },
		{ code: '88', libelle: 'Denrées alimentaires' },
		{ code: '89', libelle: 'Dératisation, désinsectisation' },
		{ code: '90', libelle: 'Détection incendie' },
		{ code: '91', libelle: 'Digue' },
		{ code: '92', libelle: 'Disque, disquette' },
		{ code: '93', libelle: 'Dragage' },
		{ code: '94', libelle: 'Drainage' },
		{ code: '95', libelle: 'Droguerie' },
		{ code: '96', libelle: 'Déchetterie (travaux)' },
		{ code: '97', libelle: 'Dématérialisation' },
		{ code: '98', libelle: 'Déneigement' },
		{ code: '101', libelle: 'Echafaudage' },
		{ code: '102', libelle: 'Eclairage public' },
		{ code: '103', libelle: 'Ecluse' },
		{ code: '104', libelle: 'Edition' },
		{ code: '105', libelle: 'Electricité (travaux)' },
		{ code: '106', libelle: 'Electrification rurale' },
		{ code: '107', libelle: 'Electromécanique' },
		{ code: '108', libelle: 'Electroménager' },
		{ code: '109', libelle: 'Enneigement artificiel' },
		{ code: '110', libelle: 'Enrochements' },
		{ code: '111', libelle: 'Equipement hydraulique' },
		{ code: '112', libelle: 'Equipement industriel' },
		{ code: '113', libelle: 'Equipement sportif' },
		{ code: '114', libelle: 'Equipement thermique' },
		{ code: '115', libelle: 'Equipements spécialisés' },
		{ code: '116', libelle: 'Espaces verts' },
		{ code: '117', libelle: 'Etanchéité' },
		{ code: '118', libelle: 'Etude' },
		{ code: '119', libelle: 'Extincteur' },
		{ code: '120', libelle: 'Equipement de piscine' },
		{ code: '125', libelle: 'Falaise' },
		{ code: '126', libelle: 'Ferronnerie' },
		{ code: '127', libelle: 'Film' },
		{ code: '128', libelle: 'Fluides médicaux' },
		{ code: '129', libelle: 'Fondations spéciales' },
		{ code: '130', libelle: 'Fonderie' },
		{ code: '131', libelle: 'Fontainerie' },
		{ code: '132', libelle: 'Forage' },
		{ code: '133', libelle: 'Fibre optique' },
		{ code: '138', libelle: 'Gardiennage' },
		{ code: '139', libelle: 'Gaz divers' },
		{ code: '140', libelle: 'Gaz médicaux' },
		{ code: '141', libelle: 'Génie civil' },
		{ code: '142', libelle: 'Glissières de sécurité' },
		{ code: '143', libelle: 'Groupe électrogène' },
		{ code: '144', libelle: 'Gros oeuvre' },
		{ code: '145', libelle: 'Gouttières' },
		{ code: '150', libelle: 'Habillement' },
		{ code: '151', libelle: 'Horodateur' },
		{ code: '152', libelle: 'Hydraulique agricole' },
		{ code: '153', libelle: 'Hygiène (articles)' },
		{ code: '154', libelle: 'Houille, lignite et tourbe' },
		{ code: '155', libelle: 'Hydrocarbures naturels' },
		{ code: '159', libelle: 'Implants' },
		{ code: '160', libelle: 'Impression' },
		{ code: '161', libelle: 'Imprimés' },
		{ code: '162', libelle: 'Informatique (matériel)' },
		{ code: '163', libelle: 'Informatique (prestations de services)' },
		{ code: '164', libelle: 'Insignes' },
		{ code: '165', libelle: 'Installation portuaire' },
		{ code: '166', libelle: 'Instruments de musique' },
		{ code: '167', libelle: 'Interphone' },
		{ code: '168', libelle: 'Irrigation' },
		{ code: '169', libelle: 'Isolation' },
		{ code: '170', libelle: 'Illumination' },
		{ code: '171', libelle: 'Site internet' },
		{ code: '175', libelle: 'Jeux, jouets' },
		{ code: '181', libelle: 'Laboratoire (fourniture)' },
		{ code: '182', libelle: 'Lagunage' },
		{ code: '183', libelle: 'Literie' },
		{ code: '184', libelle: 'Livres' },
		{ code: '185', libelle: 'Location (matériels)' },
		{ code: '186', libelle: 'Logiciel' },
		{ code: '187', libelle: 'Lubrifiants' },
		{ code: '188', libelle: 'Laboratoire (matériel)' },
		{ code: '194', libelle: 'Machines-outils' },
		{ code: '195', libelle: 'Maçonnerie' },
		{ code: '196', libelle: 'Maintenance' },
		{ code: '197', libelle: 'Maîtrise d\'oeuvre' },
		{ code: '198', libelle: 'Matériaux de construction' },
		{ code: '199', libelle: 'Matériaux routiers' },
		{ code: '200', libelle: 'Matériel agricole, horticole' },
		{ code: '201', libelle: 'Matériel dentaire' },
		{ code: '202', libelle: 'Matériel didactique' },
		{ code: '203', libelle: 'Matériel électrique' },
		{ code: '204', libelle: 'Matériel électronique' },
		{ code: '205', libelle: 'Matériel électronique médical' },
		{ code: '206', libelle: 'Matériel ferroviaire' },
		{ code: '207', libelle: 'Matériel de bureau' },
		{ code: '208', libelle: 'Matériel de manutention' },
		{ code: '209', libelle: 'Matériel de sécurité' },
		{ code: '210', libelle: 'Matériel de transmission' },
		{ code: '211', libelle: 'Matériel d\'imprimerie' },
		{ code: '212', libelle: 'Matériel médical' },
		{ code: '213', libelle: 'Matériel phonique' },
		{ code: '214', libelle: 'Matériel photographique et cinématographique' },
		{ code: '215', libelle: 'Matériel de précision' },
		{ code: '216', libelle: 'Matériel scénique' },
		{ code: '217', libelle: 'Matériel de secours et d\'incendie' },
		{ code: '218', libelle: 'Matériel de stérilisation' },
		{ code: '220', libelle: 'Matériel de travaux publics' },
		{ code: '221', libelle: 'Mécanique' },
		{ code: '222', libelle: 'Menuiserie' },
		{ code: '223', libelle: 'Métallerie' },
		{ code: '224', libelle: 'Métallurgie' },
		{ code: '225', libelle: 'Métaux précieux' },
		{ code: '226', libelle: 'Microfiches' },
		{ code: '227', libelle: 'Microfilmage' },
		{ code: '228', libelle: 'Minéraux divers' },
		{ code: '229', libelle: 'Miroiterie' },
		{ code: '230', libelle: 'Mobilier' },
		{ code: '231', libelle: 'Mobilier urbain' },
		{ code: '232', libelle: 'Mur antibruit' },
		{ code: '233', libelle: 'Mur de soutènement' },
		{ code: '234', libelle: 'Mission d\'ordonnancement, pilotage, coordination (OPC)' },
		{ code: '235', libelle: 'Minerais métalliques' },
		{ code: '236', libelle: 'Monuments historiques' },
		{ code: '237', libelle: 'Manutention' },
		{ code: '239', libelle: 'Nettoyage de locaux' },
		{ code: '240', libelle: 'Nettoyage urbain' },
		{ code: '241', libelle: 'Non-tissés' },
		{ code: '247', libelle: 'Oeuvre d\'art' },
		{ code: '248', libelle: 'Optique' },
		{ code: '249', libelle: 'Ordures ménagères (prestations)' },
		{ code: '250', libelle: 'Orgue' },
		{ code: '251', libelle: 'Outillage' },
		{ code: '252', libelle: 'Ouvrage d\'art' },
		{ code: '253', libelle: 'Ouvrage d\'infrastructure' },
		{ code: '254', libelle: 'Ouvrage métallique' },
		{ code: '255', libelle: 'Ouvrage hydraulique' },
		{ code: '260', libelle: 'Palplanches' },
		{ code: '261', libelle: 'Panneaux' },
		{ code: '262', libelle: 'Papeterie' },
		{ code: '263', libelle: 'Peinture (fourniture)' },
		{ code: '264', libelle: 'Peinture (travaux)' },
		{ code: '265', libelle: 'Piscine' },
		{ code: '266', libelle: 'Pièces détachées' },
		{ code: '267', libelle: 'Plancher technique' },
		{ code: '268', libelle: 'Plastique' },
		{ code: '269', libelle: 'Plâtrerie' },
		{ code: '270', libelle: 'Plomberie (travaux)' },
		{ code: '271', libelle: 'Pneumatiques' },
		{ code: '272', libelle: 'Pompes' },
		{ code: '273', libelle: 'Poteaux d\'incendie' },
		{ code: '274', libelle: 'Prestations de services' },
		{ code: '275', libelle: 'Produits chimiques' },
		{ code: '276', libelle: 'Produits de l\'agriculture' },
		{ code: '277', libelle: 'Produits de récupération' },
		{ code: '278', libelle: 'Produits d\'entretien' },
		{ code: '279', libelle: 'Produits des industries diverses' },
		{ code: '280', libelle: 'Produits pharmaceutiques' },
		{ code: '281', libelle: 'Produits travail des métaux' },
		{ code: '282', libelle: 'Produits radioactifs' },
		{ code: '283', libelle: 'Progiciel' },
		{ code: '284', libelle: 'Prothèses' },
		{ code: '285', libelle: 'Publicité, Communication' },
		{ code: '286', libelle: 'Passerelle' },
		{ code: '287', libelle: 'Passe à poissons' },
		{ code: '288', libelle: 'Protection, chutes de pierres' },
		{ code: '289', libelle: 'Plage' },
		{ code: '291', libelle: 'Quincaillerie (articles)' },
		{ code: '297', libelle: 'Radar' },
		{ code: '298', libelle: 'Radiologie (produits)' },
		{ code: '299', libelle: 'Ravalement' },
		{ code: '300', libelle: 'Rayonnage' },
		{ code: '301', libelle: 'Réactifs' },
		{ code: '302', libelle: 'Reliure' },
		{ code: '303', libelle: 'Remembrement (travaux connexes)' },
		{ code: '304', libelle: 'Repas, traiteur' },
		{ code: '305', libelle: 'Reprographie' },
		{ code: '306', libelle: 'Réseaux divers' },
		{ code: '307', libelle: 'Réservoir' },
		{ code: '308', libelle: 'Revêtements de sols' },
		{ code: '309', libelle: 'Revêtements muraux' },
		{ code: '310', libelle: 'Rivières/ruisseaux' },
		{ code: '311', libelle: 'Matériel robinetterie' },
		{ code: '312', libelle: 'Routage' },
		{ code: '313', libelle: 'Radiologie (matériel)' },
		{ code: '318', libelle: 'Sacs' },
		{ code: '319', libelle: 'Sanitaire' },
		{ code: '320', libelle: 'Sel de déneigement' },
		{ code: '321', libelle: 'Serrurerie' },
		{ code: '322', libelle: 'Signalisation' },
		{ code: '323', libelle: 'Sondage' },
		{ code: '324', libelle: 'Sonorisation' },
		{ code: '325', libelle: 'Stand' },
		{ code: '326', libelle: 'Station de pompage' },
		{ code: '327', libelle: 'Station de relevage' },
		{ code: '328', libelle: 'Station d\'épuration (travaux)' },
		{ code: '329', libelle: 'Stimulateurs cardiaques' },
		{ code: '330', libelle: 'Surgelés' },
		{ code: '331', libelle: 'Surveillance' },
		{ code: '332', libelle: 'Sécurité incendie' },
		{ code: '333', libelle: 'Signalétique' },
		{ code: '334', libelle: 'Station de refoulement' },
		{ code: '335', libelle: 'Station d\'épuration (exploitation)' },
		{ code: '336', libelle: 'Tabac' },
		{ code: '337', libelle: 'Télécabines, télésièges, téléskis' },
		{ code: '338', libelle: 'Télécommunications' },
		{ code: '339', libelle: 'Matériel de téléphonie' },
		{ code: '340', libelle: 'Télévision' },
		{ code: '341', libelle: 'Terrassement' },
		{ code: '342', libelle: 'Terrain de sport' },
		{ code: '343', libelle: 'Textile' },
		{ code: '344', libelle: 'Topographie' },
		{ code: '345', libelle: 'Tous corps d\'état' },
		{ code: '346', libelle: 'Transformateur' },
		{ code: '347', libelle: 'Transport' },
		{ code: '348', libelle: 'Travaux agricoles' },
		{ code: '349', libelle: 'Travaux dans l\'eau' },
		{ code: '350', libelle: 'Travaux forestiers' },
		{ code: '351', libelle: 'Travaux sous-marins' },
		{ code: '352', libelle: 'Télégestion' },
		{ code: '353', libelle: 'Travaux de viabilité' },
		{ code: '354', libelle: 'Terrasse' },
		{ code: '357', libelle: 'Vaisselle' },
		{ code: '358', libelle: 'Végétaux' },
		{ code: '359', libelle: 'Véhicules' },
		{ code: '360', libelle: 'Ventilation' },
		{ code: '361', libelle: 'Verre' },
		{ code: '362', libelle: 'Vidéo, cinéma' },
		{ code: '363', libelle: 'Vitrerie' },
		{ code: '364', libelle: 'Voies ferrées' },
		{ code: '365', libelle: 'Voirie' },
		{ code: '366', libelle: 'Voirie et réseaux divers' },
		{ code: '367', libelle: 'Voyage' },
		{ code: '372', libelle: 'Zinguerie' },
		{ code: '400', libelle: 'Aire de jeux' },
		{ code: '401', libelle: 'Articles funéraires, cercueil' },
		{ code: '402', libelle: 'Automate' },
		{ code: '403', libelle: 'Carte magnétique, carte à puce' },
		{ code: '404', libelle: 'Déchets non ménagers (prestations)' },
		{ code: '405', libelle: 'Déchetterie (exploitation)' },
		{ code: '406', libelle: 'Délégation de service public' },
		{ code: '407', libelle: 'Diététique' },
		{ code: '408', libelle: 'Equarrissage' },
		{ code: '409', libelle: 'Equipement muséographique' },
		{ code: '410', libelle: 'Formation' },
		{ code: '411', libelle: 'Paratonnerre' },
		{ code: '412', libelle: 'Porte automatique, portail' },
		{ code: '413', libelle: 'Ramonage' },
		{ code: '414', libelle: 'Occultation' },
		{ code: '415', libelle: 'Télésurveillance' },
		{ code: '416', libelle: 'Titres restaurant' },
		{ code: '417', libelle: 'Titres de transport' },
		{ code: '418', libelle: 'Vitraux' },
		{ code: '430', libelle: 'Aire d\'accueil' },
		{ code: '431', libelle: 'Amiante (diagnostic)' },
		{ code: '432', libelle: 'Antipollution (équipement)' },
		{ code: '433', libelle: 'Assistance à maîtrise d\'ouvrage' },
		{ code: '434', libelle: 'Assistance juridique' },
		{ code: '435', libelle: 'Bâche' },
		{ code: '436', libelle: 'Chèque cadeau' },
		{ code: '437', libelle: 'Cimetière' },
		{ code: '438', libelle: 'Combustible' },
		{ code: '439', libelle: 'Composteur' },
		{ code: '440', libelle: 'Compteur d\'eau' },
		{ code: '442', libelle: 'Dépollution' },
		{ code: '443', libelle: 'Electricité, gaz (fourniture)' },
		{ code: '444', libelle: 'Eolienne' },
		{ code: '445', libelle: 'Evénementiel' },
		{ code: '446', libelle: 'Expertise comptable' },
		{ code: '447', libelle: 'Feu d\'artifice' },
		{ code: '448', libelle: 'Film plastique' },
		{ code: '449', libelle: 'Fontaine' },
		{ code: '450', libelle: 'Fouille archéologique' },
		{ code: '451', libelle: 'Fourrière' },
		{ code: '452', libelle: 'Géothermie' },
		{ code: '453', libelle: 'Informatique (assistance)' },
		{ code: '454', libelle: 'Informatique (maintenance serveurs et réseaux)' },
		{ code: '455', libelle: 'Ingénierie' },
		{ code: '458', libelle: 'Matériel de puériculture' },
		{ code: '461', libelle: 'Mise à disposition de personnel' },
		{ code: '463', libelle: 'Numérisation' },
		{ code: '464', libelle: 'Objet publicitaire' },
		{ code: '465', libelle: 'Onduleur' },
		{ code: '466', libelle: 'Prestation hotelière' },
		{ code: '469', libelle: 'Serre' },
		{ code: '471', libelle: 'Sondage, enquête' },
		{ code: '472', libelle: 'Spectacle' },
		{ code: '473', libelle: 'Tente' },
		{ code: '474', libelle: 'Véhicules (location)' },
		{ code: '475', libelle: 'Véhicules (acquisition)' },
		{ code: '476', libelle: 'Photovoltaïque' },
		{ code: '478', libelle: 'Sondage (travaux)' },
		{ code: '479', libelle: 'Amiante (désamiantage)' }
	];

	private edition = [
		{ code: 'A', libelle: 'A_libelle' },
		{ code: 'B', libelle: 'B_libelle' },
		{ code: 'C', libelle: 'C_libelle' }];

	private genre = [
		{ code: 'M', libelle: 'M.' },
		{ code: 'MME', libelle: 'Mme' }];

	private rubrique = [
		{ code: '', libelle: '- Sélectionner -'},
		{ code: 'ReceptCandidatures', libelle: 'Réception des candidatures' },
		{ code: 'ReceptionOffres', libelle: 'Réception des offres' },
		{ code: 'EnvoiInvitation', libelle: 'Envoi des invitations' },
		{ code: 'RemiseCandidatures', libelle: 'Remise des candidatures' },
	]

	private typeRens = [
		{ code: '', libelle: '- Sélectionner -'},
		{ code: 'admEtTech', libelle: 'Obtenir des renseignements d\'ordre administratif et technique' },
		{ code: 'tech', libelle: 'Obtenir des renseignements d\'ordre technique' },
		{ code: 'adm', libelle: 'Obtenir des renseignements d\'ordre administratif' },
		{ code: 'document', libelle: 'Obtenir des documents' },
		{ code: 'envoi', libelle: 'Envoyer les offres/les candidatures/les demandes de participation' },
		{ code: 'rensComplementaires', libelle: 'Obtenir des renseignements complémentaires' }
	]

	private rappel = [
		{ code: '', libelle: '- Sélectionner -' },
		{ code: '01', libelle: '01 - Ain' },
		{ code: '02', libelle: '02 - Aisne' },
		{ code: '03', libelle: '03 - Allier' },
		{ code: '04', libelle: '04 - Alpes-de-Haute-Provence' },
		{ code: '05', libelle: '05 - Hautes-Alpes' },
		{ code: '06', libelle: '06 - Alpes-Maritimes' },
		{ code: '07', libelle: '07 - Ardèche' },
		{ code: '08', libelle: '08 - Ardennes' },
		{ code: '09', libelle: '09 - Ariège' },
		{ code: '10', libelle: '10 - Aube' },
		{ code: '11', libelle: '11 - Aude' },
		{ code: '12', libelle: '12 - Aveyron' },
		{ code: '13', libelle: '13 - Bouches-du-Rhône' },
		{ code: '14', libelle: '14 - Calvados' },
		{ code: '15', libelle: '15 - Cantal' },
		{ code: '16', libelle: '16 - Charente' },
		{ code: '17', libelle: '17 - Charente-Maritime' },
		{ code: '18', libelle: '18 - Cher' },
		{ code: '19', libelle: '19 - Corrèze' },
		{ code: '20A', libelle: '20A - Corse-du-Sud' },
		{ code: '20B', libelle: '20B - Haute-Corse' },
		{ code: '21', libelle: '21 - Côte-d\'Or' },
		{ code: '22', libelle: '22 - Côtes-d\'Armor' },
		{ code: '23', libelle: '23 - Creuse' },
		{ code: '24', libelle: '24 - Dordogne' },
		{ code: '25', libelle: '25 - Doubs' },
		{ code: '26', libelle: '26 - Drôme' },
		{ code: '27', libelle: '27 - Eure' },
		{ code: '28', libelle: '28 - Eure-et-Loir' },
		{ code: '29', libelle: '29 - Finistère' },
		{ code: '30', libelle: '30 - Gard' },
		{ code: '31', libelle: '31 - Haute-Garonne' },
		{ code: '32', libelle: '32 - Gers' },
		{ code: '33', libelle: '33 - Gironde' },
		{ code: '34', libelle: '34 - Hérault' },
		{ code: '35', libelle: '35 - Ille-et-Vilaine' },
		{ code: '36', libelle: '36 - Indre' },
		{ code: '37', libelle: '37 - Indre-et-Loire' },
		{ code: '38', libelle: '38 - Isère' },
		{ code: '39', libelle: '39 - Jura' },
		{ code: '40', libelle: '40 - Landes' },
		{ code: '41', libelle: '41 - Loir-et-Cher' },
		{ code: '42', libelle: '42 - Loire' },
		{ code: '43', libelle: '43 - Haute-Loire' },
		{ code: '44', libelle: '44 - Loire-Atlantique' },
		{ code: '45', libelle: '45 - Loiret' },
		{ code: '46', libelle: '46 - Lot' },
		{ code: '47', libelle: '47 - Lot-et-Garonne' },
		{ code: '48', libelle: '48 - Lozère' },
		{ code: '49', libelle: '49 - Maine-et-Loire' },
		{ code: '50', libelle: '50 - Manche' },
		{ code: '51', libelle: '51 - Marne' },
		{ code: '52', libelle: '52 - Haute-Marne' },
		{ code: '53', libelle: '53 - Mayenne' },
		{ code: '54', libelle: '54 - Meurthe-et-Moselle' },
		{ code: '55', libelle: '55 - Meuse' },
		{ code: '56', libelle: '56 - Morbihan' },
		{ code: '57', libelle: '57 - Moselle' },
		{ code: '58', libelle: '58 - Nièvre' },
		{ code: '59', libelle: '59 - Nord' },
		{ code: '60', libelle: '60 - Oise' },
		{ code: '61', libelle: '61 - Orne' },
		{ code: '62', libelle: '62 - Pas-de-Calais' },
		{ code: '63', libelle: '63 - Puy-de-Dôme' },
		{ code: '64', libelle: '64 - Pyrénées-Atlantiques' },
		{ code: '65', libelle: '65 - Hautes-Pyrénées' },
		{ code: '66', libelle: '66 - Pyrénées-Orientales' },
		{ code: '67', libelle: '67 - Bas-Rhin' },
		{ code: '68', libelle: '68 - Haut-Rhin' },
		{ code: '69', libelle: '69 - Rhône' },
		{ code: '70', libelle: '70 - Haute-Saône' },
		{ code: '71', libelle: '71 - Saône-et-Loire' },
		{ code: '72', libelle: '72 - Sarthe' },
		{ code: '73', libelle: '73 - Savoie' },
		{ code: '74', libelle: '74 - Haute-Savoie' },
		{ code: '75', libelle: '75 - Paris' },
		{ code: '76', libelle: '76 - Seine-Maritime' },
		{ code: '77', libelle: '77 - Seine-et-Marne' },
		{ code: '78', libelle: '78 - Yvelines' },
		{ code: '79', libelle: '79 - Deux-Sèvres' },
		{ code: '80', libelle: '80 - Somme' },
		{ code: '81', libelle: '81 - Tarn' },
		{ code: '82', libelle: '82 - Tarn-et-Garonne' },
		{ code: '83', libelle: '83 - Var' },
		{ code: '84', libelle: '84 - Vaucluse' },
		{ code: '85', libelle: '85 - Vendée' },
		{ code: '86', libelle: '86 - Vienne' },
		{ code: '87', libelle: '87 - Haute-Vienne' },
		{ code: '88', libelle: '88 - Vosges' },
		{ code: '89', libelle: '89 - Yonne' },
		{ code: '90', libelle: '90 - Territoire de Belfort' },
		{ code: '91', libelle: '91 - Essonne' },
		{ code: '92', libelle: '92 - Hauts-de-Seine' },
		{ code: '93', libelle: '93 - Seine-St-Denis' },
		{ code: '94', libelle: '94 - Val-de-Marne' },
		{ code: '95', libelle: '95 - Val-D\'Oise' },
		{ code: '99', libelle: '99 - Etranger' },
		{ code: '971', libelle: '971 - Guadeloupe' },
		{ code: '972', libelle: '972 - Martinique' },
		{ code: '973', libelle: '973 - Guyane' },
		{ code: '974', libelle: '974 - La Réunion' },
		{ code: '975', libelle: '975 - ST-PIERRE-ET-MIQUELON' },
		{ code: '976', libelle: '976 - Mayotte' },
		{ code: '977', libelle: '977 - SAINT-BARTHÉLEMY' },
		{ code: '978', libelle: '978 - SAINT-MARTIN' },
		{ code: '986', libelle: '986 - Wallis-et-Futuna' },
		{ code: '987', libelle: '987 - Polynésie française' },
		{ code: '988', libelle: '988 - Nouvelle-Calédonie' }];

	private lieucodenuts = [
		{ code: 'BE', libelle: 'BE' },
		{ code: 'BE1', libelle: 'BE1' },
		{ code: 'BE10', libelle: 'BE10' },
		{ code: 'BE100', libelle: 'BE100' },
		{ code: 'BE2', libelle: 'BE2' },
		{ code: 'BE21', libelle: 'BE21' },
		{ code: 'BE211', libelle: 'BE211' },
		{ code: 'BE212', libelle: 'BE212' },
		{ code: 'BE213', libelle: 'BE213' },
		{ code: 'BE22', libelle: 'BE22' },
		{ code: 'BE223', libelle: 'BE223' },
		{ code: 'BE224', libelle: 'BE224' },
		{ code: 'BE225', libelle: 'BE225' },
		{ code: 'BE23', libelle: 'BE23' },
		{ code: 'BE231', libelle: 'BE231' },
		{ code: 'BE232', libelle: 'BE232' },
		{ code: 'BE233', libelle: 'BE233' },
		{ code: 'BE234', libelle: 'BE234' },
		{ code: 'BE235', libelle: 'BE235' },
		{ code: 'BE236', libelle: 'BE236' },
		{ code: 'BE24', libelle: 'BE24' },
		{ code: 'BE241', libelle: 'BE241' },
		{ code: 'BE242', libelle: 'BE242' },
		{ code: 'BE25', libelle: 'BE25' },
		{ code: 'BE251', libelle: 'BE251' },
		{ code: 'BE252', libelle: 'BE252' },
		{ code: 'BE253', libelle: 'BE253' },
		{ code: 'BE254', libelle: 'BE254' },
		{ code: 'BE255', libelle: 'BE255' },
		{ code: 'BE256', libelle: 'BE256' },
		{ code: 'BE257', libelle: 'BE257' },
		{ code: 'BE258', libelle: 'BE258' },
		{ code: 'BE3', libelle: 'BE3' },
		{ code: 'BE31', libelle: 'BE31' },
		{ code: 'BE310', libelle: 'BE310' },
		{ code: 'BE32', libelle: 'BE32' },
		{ code: 'BE323', libelle: 'BE323' },
		{ code: 'BE328', libelle: 'BE328' },
		{ code: 'BE329', libelle: 'BE329' },
		{ code: 'BE32A', libelle: 'BE32A' },
		{ code: 'BE32B', libelle: 'BE32B' },
		{ code: 'BE32C', libelle: 'BE32C' },
		{ code: 'BE32D', libelle: 'BE32D' },
		{ code: 'BE33', libelle: 'BE33' },
		{ code: 'BE331', libelle: 'BE331' },
		{ code: 'BE332', libelle: 'BE332' },
		{ code: 'BE334', libelle: 'BE334' },
		{ code: 'BE335', libelle: 'BE335' },
		{ code: 'BE336', libelle: 'BE336' },
		{ code: 'BE34', libelle: 'BE34' },
		{ code: 'BE341', libelle: 'BE341' },
		{ code: 'BE342', libelle: 'BE342' },
		{ code: 'BE343', libelle: 'BE343' },
		{ code: 'BE344', libelle: 'BE344' },
		{ code: 'BE345', libelle: 'BE345' },
		{ code: 'BE35', libelle: 'BE35' },
		{ code: 'BE351', libelle: 'BE351' },
		{ code: 'BE352', libelle: 'BE352' },
		{ code: 'BE353', libelle: 'BE353' },
		{ code: 'BEZ', libelle: 'BEZ' },
		{ code: 'BEZZ', libelle: 'BEZZ' },
		{ code: 'BEZZZ', libelle: 'BEZZZ' },
		{ code: 'BG', libelle: 'BG' },
		{ code: 'BG3', libelle: 'BG3' },
		{ code: 'BG31', libelle: 'BG31' },
		{ code: 'BG311', libelle: 'BG311' },
		{ code: 'BG312', libelle: 'BG312' },
		{ code: 'BG313', libelle: 'BG313' },
		{ code: 'BG314', libelle: 'BG314' },
		{ code: 'BG315', libelle: 'BG315' },
		{ code: 'BG32', libelle: 'BG32' },
		{ code: 'BG321', libelle: 'BG321' },
		{ code: 'BG322', libelle: 'BG322' },
		{ code: 'BG323', libelle: 'BG323' },
		{ code: 'BG324', libelle: 'BG324' },
		{ code: 'BG325', libelle: 'BG325' },
		{ code: 'BG33', libelle: 'BG33' },
		{ code: 'BG331', libelle: 'BG331' },
		{ code: 'BG332', libelle: 'BG332' },
		{ code: 'BG333', libelle: 'BG333' },
		{ code: 'BG334', libelle: 'BG334' },
		{ code: 'BG34', libelle: 'BG34' },
		{ code: 'BG341', libelle: 'BG341' },
		{ code: 'BG342', libelle: 'BG342' },
		{ code: 'BG343', libelle: 'BG343' },
		{ code: 'BG344', libelle: 'BG344' },
		{ code: 'BG4', libelle: 'BG4' },
		{ code: 'BG41', libelle: 'BG41' },
		{ code: 'BG411', libelle: 'BG411' },
		{ code: 'BG412', libelle: 'BG412' },
		{ code: 'BG413', libelle: 'BG413' },
		{ code: 'BG414', libelle: 'BG414' },
		{ code: 'BG415', libelle: 'BG415' },
		{ code: 'BG42', libelle: 'BG42' },
		{ code: 'BG421', libelle: 'BG421' },
		{ code: 'BG422', libelle: 'BG422' },
		{ code: 'BG423', libelle: 'BG423' },
		{ code: 'BG424', libelle: 'BG424' },
		{ code: 'BG425', libelle: 'BG425' },
		{ code: 'BGZ', libelle: 'BGZ' },
		{ code: 'BGZZ', libelle: 'BGZZ' },
		{ code: 'BGZZZ', libelle: 'BGZZZ' },
		{ code: 'CZ', libelle: 'CZ' },
		{ code: 'CZ0', libelle: 'CZ0' },
		{ code: 'CZ01', libelle: 'CZ01' },
		{ code: 'CZ010', libelle: 'CZ010' },
		{ code: 'CZ02', libelle: 'CZ02' },
		{ code: 'CZ020', libelle: 'CZ020' },
		{ code: 'CZ03', libelle: 'CZ03' },
		{ code: 'CZ031', libelle: 'CZ031' },
		{ code: 'CZ032', libelle: 'CZ032' },
		{ code: 'CZ04', libelle: 'CZ04' },
		{ code: 'CZ041', libelle: 'CZ041' },
		{ code: 'CZ042', libelle: 'CZ042' },
		{ code: 'CZ05', libelle: 'CZ05' },
		{ code: 'CZ051', libelle: 'CZ051' },
		{ code: 'CZ052', libelle: 'CZ052' },
		{ code: 'CZ053', libelle: 'CZ053' },
		{ code: 'CZ06', libelle: 'CZ06' },
		{ code: 'CZ063', libelle: 'CZ063' },
		{ code: 'CZ064', libelle: 'CZ064' },
		{ code: 'CZ07', libelle: 'CZ07' },
		{ code: 'CZ071', libelle: 'CZ071' },
		{ code: 'CZ072', libelle: 'CZ072' },
		{ code: 'CZ08', libelle: 'CZ08' },
		{ code: 'CZ080', libelle: 'CZ080' },
		{ code: 'CZZ', libelle: 'CZZ' },
		{ code: 'CZZZ', libelle: 'CZZZ' },
		{ code: 'CZZZZ', libelle: 'CZZZZ' },
		{ code: 'DK', libelle: 'DK' },
		{ code: 'DK0', libelle: 'DK0' },
		{ code: 'DK01', libelle: 'DK01' },
		{ code: 'DK011', libelle: 'DK011' },
		{ code: 'DK012', libelle: 'DK012' },
		{ code: 'DK013', libelle: 'DK013' },
		{ code: 'DK014', libelle: 'DK014' },
		{ code: 'DK02', libelle: 'DK02' },
		{ code: 'DK021', libelle: 'DK021' },
		{ code: 'DK022', libelle: 'DK022' },
		{ code: 'DK03', libelle: 'DK03' },
		{ code: 'DK031', libelle: 'DK031' },
		{ code: 'DK032', libelle: 'DK032' },
		{ code: 'DK04', libelle: 'DK04' },
		{ code: 'DK041', libelle: 'DK041' },
		{ code: 'DK042', libelle: 'DK042' },
		{ code: 'DK05', libelle: 'DK05' },
		{ code: 'DK050', libelle: 'DK050' },
		{ code: 'DKZ', libelle: 'DKZ' },
		{ code: 'DKZZ', libelle: 'DKZZ' },
		{ code: 'DKZZZ', libelle: 'DKZZZ' },
		{ code: 'DE', libelle: 'DE' },
		{ code: 'DE1', libelle: 'DE1' },
		{ code: 'DE11', libelle: 'DE11' },
		{ code: 'DE111', libelle: 'DE111' },
		{ code: 'DE112', libelle: 'DE112' },
		{ code: 'DE113', libelle: 'DE113' },
		{ code: 'DE114', libelle: 'DE114' },
		{ code: 'DE115', libelle: 'DE115' },
		{ code: 'DE116', libelle: 'DE116' },
		{ code: 'DE117', libelle: 'DE117' },
		{ code: 'DE118', libelle: 'DE118' },
		{ code: 'DE119', libelle: 'DE119' },
		{ code: 'DE11A', libelle: 'DE11A' },
		{ code: 'DE11B', libelle: 'DE11B' },
		{ code: 'DE11C', libelle: 'DE11C' },
		{ code: 'DE11D', libelle: 'DE11D' },
		{ code: 'DE12', libelle: 'DE12' },
		{ code: 'DE121', libelle: 'DE121' },
		{ code: 'DE122', libelle: 'DE122' },
		{ code: 'DE123', libelle: 'DE123' },
		{ code: 'DE124', libelle: 'DE124' },
		{ code: 'DE125', libelle: 'DE125' },
		{ code: 'DE126', libelle: 'DE126' },
		{ code: 'DE127', libelle: 'DE127' },
		{ code: 'DE128', libelle: 'DE128' },
		{ code: 'DE129', libelle: 'DE129' },
		{ code: 'DE12A', libelle: 'DE12A' },
		{ code: 'DE12B', libelle: 'DE12B' },
		{ code: 'DE12C', libelle: 'DE12C' },
		{ code: 'DE13', libelle: 'DE13' },
		{ code: 'DE131', libelle: 'DE131' },
		{ code: 'DE132', libelle: 'DE132' },
		{ code: 'DE133', libelle: 'DE133' },
		{ code: 'DE134', libelle: 'DE134' },
		{ code: 'DE135', libelle: 'DE135' },
		{ code: 'DE136', libelle: 'DE136' },
		{ code: 'DE137', libelle: 'DE137' },
		{ code: 'DE138', libelle: 'DE138' },
		{ code: 'DE139', libelle: 'DE139' },
		{ code: 'DE13A', libelle: 'DE13A' },
		{ code: 'DE14', libelle: 'DE14' },
		{ code: 'DE141', libelle: 'DE141' },
		{ code: 'DE142', libelle: 'DE142' },
		{ code: 'DE143', libelle: 'DE143' },
		{ code: 'DE144', libelle: 'DE144' },
		{ code: 'DE145', libelle: 'DE145' },
		{ code: 'DE146', libelle: 'DE146' },
		{ code: 'DE147', libelle: 'DE147' },
		{ code: 'DE148', libelle: 'DE148' },
		{ code: 'DE149', libelle: 'DE149' },
		{ code: 'DE2', libelle: 'DE2' },
		{ code: 'DE21', libelle: 'DE21' },
		{ code: 'DE211', libelle: 'DE211' },
		{ code: 'DE212', libelle: 'DE212' },
		{ code: 'DE213', libelle: 'DE213' },
		{ code: 'DE214', libelle: 'DE214' },
		{ code: 'DE215', libelle: 'DE215' },
		{ code: 'DE216', libelle: 'DE216' },
		{ code: 'DE217', libelle: 'DE217' },
		{ code: 'DE218', libelle: 'DE218' },
		{ code: 'DE219', libelle: 'DE219' },
		{ code: 'DE21A', libelle: 'DE21A' },
		{ code: 'DE21B', libelle: 'DE21B' },
		{ code: 'DE21C', libelle: 'DE21C' },
		{ code: 'DE21D', libelle: 'DE21D' },
		{ code: 'DE21E', libelle: 'DE21E' },
		{ code: 'DE21F', libelle: 'DE21F' },
		{ code: 'DE21G', libelle: 'DE21G' },
		{ code: 'DE21H', libelle: 'DE21H' },
		{ code: 'DE21I', libelle: 'DE21I' },
		{ code: 'DE21J', libelle: 'DE21J' },
		{ code: 'DE21K', libelle: 'DE21K' },
		{ code: 'DE21L', libelle: 'DE21L' },
		{ code: 'DE21M', libelle: 'DE21M' },
		{ code: 'DE21N', libelle: 'DE21N' },
		{ code: 'DE22', libelle: 'DE22' },
		{ code: 'DE221', libelle: 'DE221' },
		{ code: 'DE222', libelle: 'DE222' },
		{ code: 'DE223', libelle: 'DE223' },
		{ code: 'DE224', libelle: 'DE224' },
		{ code: 'DE225', libelle: 'DE225' },
		{ code: 'DE226', libelle: 'DE226' },
		{ code: 'DE227', libelle: 'DE227' },
		{ code: 'DE228', libelle: 'DE228' },
		{ code: 'DE229', libelle: 'DE229' },
		{ code: 'DE22A', libelle: 'DE22A' },
		{ code: 'DE22B', libelle: 'DE22B' },
		{ code: 'DE22C', libelle: 'DE22C' },
		{ code: 'DE23', libelle: 'DE23' },
		{ code: 'DE231', libelle: 'DE231' },
		{ code: 'DE232', libelle: 'DE232' },
		{ code: 'DE233', libelle: 'DE233' },
		{ code: 'DE234', libelle: 'DE234' },
		{ code: 'DE235', libelle: 'DE235' },
		{ code: 'DE236', libelle: 'DE236' },
		{ code: 'DE237', libelle: 'DE237' },
		{ code: 'DE238', libelle: 'DE238' },
		{ code: 'DE239', libelle: 'DE239' },
		{ code: 'DE23A', libelle: 'DE23A' },
		{ code: 'DE24', libelle: 'DE24' },
		{ code: 'DE241', libelle: 'DE241' },
		{ code: 'DE242', libelle: 'DE242' },
		{ code: 'DE243', libelle: 'DE243' },
		{ code: 'DE244', libelle: 'DE244' },
		{ code: 'DE245', libelle: 'DE245' },
		{ code: 'DE246', libelle: 'DE246' },
		{ code: 'DE247', libelle: 'DE247' },
		{ code: 'DE248', libelle: 'DE248' },
		{ code: 'DE249', libelle: 'DE249' },
		{ code: 'DE24A', libelle: 'DE24A' },
		{ code: 'DE24B', libelle: 'DE24B' },
		{ code: 'DE24C', libelle: 'DE24C' },
		{ code: 'DE24D', libelle: 'DE24D' },
		{ code: 'DE25', libelle: 'DE25' },
		{ code: 'DE251', libelle: 'DE251' },
		{ code: 'DE252', libelle: 'DE252' },
		{ code: 'DE253', libelle: 'DE253' },
		{ code: 'DE254', libelle: 'DE254' },
		{ code: 'DE255', libelle: 'DE255' },
		{ code: 'DE256', libelle: 'DE256' },
		{ code: 'DE257', libelle: 'DE257' },
		{ code: 'DE258', libelle: 'DE258' },
		{ code: 'DE259', libelle: 'DE259' },
		{ code: 'DE25A', libelle: 'DE25A' },
		{ code: 'DE25B', libelle: 'DE25B' },
		{ code: 'DE25C', libelle: 'DE25C' },
		{ code: 'DE26', libelle: 'DE26' },
		{ code: 'DE261', libelle: 'DE261' },
		{ code: 'DE262', libelle: 'DE262' },
		{ code: 'DE263', libelle: 'DE263' },
		{ code: 'DE264', libelle: 'DE264' },
		{ code: 'DE265', libelle: 'DE265' },
		{ code: 'DE266', libelle: 'DE266' },
		{ code: 'DE267', libelle: 'DE267' },
		{ code: 'DE268', libelle: 'DE268' },
		{ code: 'DE269', libelle: 'DE269' },
		{ code: 'DE26A', libelle: 'DE26A' },
		{ code: 'DE26B', libelle: 'DE26B' },
		{ code: 'DE26C', libelle: 'DE26C' },
		{ code: 'DE27', libelle: 'DE27' },
		{ code: 'DE271', libelle: 'DE271' },
		{ code: 'DE272', libelle: 'DE272' },
		{ code: 'DE273', libelle: 'DE273' },
		{ code: 'DE274', libelle: 'DE274' },
		{ code: 'DE275', libelle: 'DE275' },
		{ code: 'DE276', libelle: 'DE276' },
		{ code: 'DE277', libelle: 'DE277' },
		{ code: 'DE278', libelle: 'DE278' },
		{ code: 'DE279', libelle: 'DE279' },
		{ code: 'DE27A', libelle: 'DE27A' },
		{ code: 'DE27B', libelle: 'DE27B' },
		{ code: 'DE27C', libelle: 'DE27C' },
		{ code: 'DE27D', libelle: 'DE27D' },
		{ code: 'DE27E', libelle: 'DE27E' },
		{ code: 'DE3', libelle: 'DE3' },
		{ code: 'DE30', libelle: 'DE30' },
		{ code: 'DE300', libelle: 'DE300' },
		{ code: 'DE4', libelle: 'DE4' },
		{ code: 'DE40', libelle: 'DE40' },
		{ code: 'DE401', libelle: 'DE401' },
		{ code: 'DE402', libelle: 'DE402' },
		{ code: 'DE403', libelle: 'DE403' },
		{ code: 'DE404', libelle: 'DE404' },
		{ code: 'DE405', libelle: 'DE405' },
		{ code: 'DE406', libelle: 'DE406' },
		{ code: 'DE407', libelle: 'DE407' },
		{ code: 'DE408', libelle: 'DE408' },
		{ code: 'DE409', libelle: 'DE409' },
		{ code: 'DE40A', libelle: 'DE40A' },
		{ code: 'DE40B', libelle: 'DE40B' },
		{ code: 'DE40C', libelle: 'DE40C' },
		{ code: 'DE40D', libelle: 'DE40D' },
		{ code: 'DE40E', libelle: 'DE40E' },
		{ code: 'DE40F', libelle: 'DE40F' },
		{ code: 'DE40G', libelle: 'DE40G' },
		{ code: 'DE40H', libelle: 'DE40H' },
		{ code: 'DE40I', libelle: 'DE40I' },
		{ code: 'DE5', libelle: 'DE5' },
		{ code: 'DE50', libelle: 'DE50' },
		{ code: 'DE501', libelle: 'DE501' },
		{ code: 'DE502', libelle: 'DE502' },
		{ code: 'DE6', libelle: 'DE6' },
		{ code: 'DE60', libelle: 'DE60' },
		{ code: 'DE600', libelle: 'DE600' },
		{ code: 'DE7', libelle: 'DE7' },
		{ code: 'DE71', libelle: 'DE71' },
		{ code: 'DE711', libelle: 'DE711' },
		{ code: 'DE712', libelle: 'DE712' },
		{ code: 'DE713', libelle: 'DE713' },
		{ code: 'DE714', libelle: 'DE714' },
		{ code: 'DE715', libelle: 'DE715' },
		{ code: 'DE716', libelle: 'DE716' },
		{ code: 'DE717', libelle: 'DE717' },
		{ code: 'DE718', libelle: 'DE718' },
		{ code: 'DE719', libelle: 'DE719' },
		{ code: 'DE71A', libelle: 'DE71A' },
		{ code: 'DE71B', libelle: 'DE71B' },
		{ code: 'DE71C', libelle: 'DE71C' },
		{ code: 'DE71D', libelle: 'DE71D' },
		{ code: 'DE71E', libelle: 'DE71E' },
		{ code: 'DE72', libelle: 'DE72' },
		{ code: 'DE721', libelle: 'DE721' },
		{ code: 'DE722', libelle: 'DE722' },
		{ code: 'DE723', libelle: 'DE723' },
		{ code: 'DE724', libelle: 'DE724' },
		{ code: 'DE725', libelle: 'DE725' },
		{ code: 'DE73', libelle: 'DE73' },
		{ code: 'DE731', libelle: 'DE731' },
		{ code: 'DE732', libelle: 'DE732' },
		{ code: 'DE733', libelle: 'DE733' },
		{ code: 'DE734', libelle: 'DE734' },
		{ code: 'DE735', libelle: 'DE735' },
		{ code: 'DE736', libelle: 'DE736' },
		{ code: 'DE737', libelle: 'DE737' },
		{ code: 'DE8', libelle: 'DE8' },
		{ code: 'DE80', libelle: 'DE80' },
		{ code: 'DE803', libelle: 'DE803' },
		{ code: 'DE804', libelle: 'DE804' },
		{ code: 'DE80J', libelle: 'DE80J' },
		{ code: 'DE80K', libelle: 'DE80K' },
		{ code: 'DE80L', libelle: 'DE80L' },
		{ code: 'DE80M', libelle: 'DE80M' },
		{ code: 'DE80N', libelle: 'DE80N' },
		{ code: 'DE80O', libelle: 'DE80O' },
		{ code: 'DE9', libelle: 'DE9' },
		{ code: 'DE91', libelle: 'DE91' },
		{ code: 'DE911', libelle: 'DE911' },
		{ code: 'DE912', libelle: 'DE912' },
		{ code: 'DE913', libelle: 'DE913' },
		{ code: 'DE914', libelle: 'DE914' },
		{ code: 'DE916', libelle: 'DE916' },
		{ code: 'DE917', libelle: 'DE917' },
		{ code: 'DE918', libelle: 'DE918' },
		{ code: 'DE91A', libelle: 'DE91A' },
		{ code: 'DE91B', libelle: 'DE91B' },
		{ code: 'DE91C', libelle: 'DE91C' },
		{ code: 'DE92', libelle: 'DE92' },
		{ code: 'DE922', libelle: 'DE922' },
		{ code: 'DE923', libelle: 'DE923' },
		{ code: 'DE925', libelle: 'DE925' },
		{ code: 'DE926', libelle: 'DE926' },
		{ code: 'DE927', libelle: 'DE927' },
		{ code: 'DE928', libelle: 'DE928' },
		{ code: 'DE929', libelle: 'DE929' },
		{ code: 'DE93', libelle: 'DE93' },
		{ code: 'DE931', libelle: 'DE931' },
		{ code: 'DE932', libelle: 'DE932' },
		{ code: 'DE933', libelle: 'DE933' },
		{ code: 'DE934', libelle: 'DE934' },
		{ code: 'DE935', libelle: 'DE935' },
		{ code: 'DE936', libelle: 'DE936' },
		{ code: 'DE937', libelle: 'DE937' },
		{ code: 'DE938', libelle: 'DE938' },
		{ code: 'DE939', libelle: 'DE939' },
		{ code: 'DE93A', libelle: 'DE93A' },
		{ code: 'DE93B', libelle: 'DE93B' },
		{ code: 'DE94', libelle: 'DE94' },
		{ code: 'DE941', libelle: 'DE941' },
		{ code: 'DE942', libelle: 'DE942' },
		{ code: 'DE943', libelle: 'DE943' },
		{ code: 'DE944', libelle: 'DE944' },
		{ code: 'DE945', libelle: 'DE945' },
		{ code: 'DE946', libelle: 'DE946' },
		{ code: 'DE947', libelle: 'DE947' },
		{ code: 'DE948', libelle: 'DE948' },
		{ code: 'DE949', libelle: 'DE949' },
		{ code: 'DE94A', libelle: 'DE94A' },
		{ code: 'DE94B', libelle: 'DE94B' },
		{ code: 'DE94C', libelle: 'DE94C' },
		{ code: 'DE94D', libelle: 'DE94D' },
		{ code: 'DE94E', libelle: 'DE94E' },
		{ code: 'DE94F', libelle: 'DE94F' },
		{ code: 'DE94G', libelle: 'DE94G' },
		{ code: 'DE94H', libelle: 'DE94H' },
		{ code: 'DEA', libelle: 'DEA' },
		{ code: 'DEA1', libelle: 'DEA1' },
		{ code: 'DEA11', libelle: 'DEA11' },
		{ code: 'DEA12', libelle: 'DEA12' },
		{ code: 'DEA13', libelle: 'DEA13' },
		{ code: 'DEA14', libelle: 'DEA14' },
		{ code: 'DEA15', libelle: 'DEA15' },
		{ code: 'DEA16', libelle: 'DEA16' },
		{ code: 'DEA17', libelle: 'DEA17' },
		{ code: 'DEA18', libelle: 'DEA18' },
		{ code: 'DEA19', libelle: 'DEA19' },
		{ code: 'DEA1A', libelle: 'DEA1A' },
		{ code: 'DEA1B', libelle: 'DEA1B' },
		{ code: 'DEA1C', libelle: 'DEA1C' },
		{ code: 'DEA1D', libelle: 'DEA1D' },
		{ code: 'DEA1E', libelle: 'DEA1E' },
		{ code: 'DEA1F', libelle: 'DEA1F' },
		{ code: 'DEA2', libelle: 'DEA2' },
		{ code: 'DEA22', libelle: 'DEA22' },
		{ code: 'DEA23', libelle: 'DEA23' },
		{ code: 'DEA24', libelle: 'DEA24' },
		{ code: 'DEA26', libelle: 'DEA26' },
		{ code: 'DEA27', libelle: 'DEA27' },
		{ code: 'DEA28', libelle: 'DEA28' },
		{ code: 'DEA29', libelle: 'DEA29' },
		{ code: 'DEA2A', libelle: 'DEA2A' },
		{ code: 'DEA2B', libelle: 'DEA2B' },
		{ code: 'DEA2C', libelle: 'DEA2C' },
		{ code: 'DEA2D', libelle: 'DEA2D' },
		{ code: 'DEA3', libelle: 'DEA3' },
		{ code: 'DEA31', libelle: 'DEA31' },
		{ code: 'DEA32', libelle: 'DEA32' },
		{ code: 'DEA33', libelle: 'DEA33' },
		{ code: 'DEA34', libelle: 'DEA34' },
		{ code: 'DEA35', libelle: 'DEA35' },
		{ code: 'DEA36', libelle: 'DEA36' },
		{ code: 'DEA37', libelle: 'DEA37' },
		{ code: 'DEA38', libelle: 'DEA38' },
		{ code: 'DEA4', libelle: 'DEA4' },
		{ code: 'DEA41', libelle: 'DEA41' },
		{ code: 'DEA42', libelle: 'DEA42' },
		{ code: 'DEA43', libelle: 'DEA43' },
		{ code: 'DEA44', libelle: 'DEA44' },
		{ code: 'DEA45', libelle: 'DEA45' },
		{ code: 'DEA46', libelle: 'DEA46' },
		{ code: 'DEA47', libelle: 'DEA47' },
		{ code: 'DEA5', libelle: 'DEA5' },
		{ code: 'DEA51', libelle: 'DEA51' },
		{ code: 'DEA52', libelle: 'DEA52' },
		{ code: 'DEA53', libelle: 'DEA53' },
		{ code: 'DEA54', libelle: 'DEA54' },
		{ code: 'DEA55', libelle: 'DEA55' },
		{ code: 'DEA56', libelle: 'DEA56' },
		{ code: 'DEA57', libelle: 'DEA57' },
		{ code: 'DEA58', libelle: 'DEA58' },
		{ code: 'DEA59', libelle: 'DEA59' },
		{ code: 'DEA5A', libelle: 'DEA5A' },
		{ code: 'DEA5B', libelle: 'DEA5B' },
		{ code: 'DEA5C', libelle: 'DEA5C' },
		{ code: 'DEB', libelle: 'DEB' },
		{ code: 'DEB1', libelle: 'DEB1' },
		{ code: 'DEB11', libelle: 'DEB11' },
		{ code: 'DEB12', libelle: 'DEB12' },
		{ code: 'DEB13', libelle: 'DEB13' },
		{ code: 'DEB14', libelle: 'DEB14' },
		{ code: 'DEB15', libelle: 'DEB15' },
		{ code: 'DEB17', libelle: 'DEB17' },
		{ code: 'DEB18', libelle: 'DEB18' },
		{ code: 'DEB1A', libelle: 'DEB1A' },
		{ code: 'DEB1B', libelle: 'DEB1B' },
		{ code: 'DEB1C', libelle: 'DEB1C' },
		{ code: 'DEB1D', libelle: 'DEB1D' },
		{ code: 'DEB2', libelle: 'DEB2' },
		{ code: 'DEB21', libelle: 'DEB21' },
		{ code: 'DEB22', libelle: 'DEB22' },
		{ code: 'DEB23', libelle: 'DEB23' },
		{ code: 'DEB24', libelle: 'DEB24' },
		{ code: 'DEB25', libelle: 'DEB25' },
		{ code: 'DEB3', libelle: 'DEB3' },
		{ code: 'DEB31', libelle: 'DEB31' },
		{ code: 'DEB32', libelle: 'DEB32' },
		{ code: 'DEB33', libelle: 'DEB33' },
		{ code: 'DEB34', libelle: 'DEB34' },
		{ code: 'DEB35', libelle: 'DEB35' },
		{ code: 'DEB36', libelle: 'DEB36' },
		{ code: 'DEB37', libelle: 'DEB37' },
		{ code: 'DEB38', libelle: 'DEB38' },
		{ code: 'DEB39', libelle: 'DEB39' },
		{ code: 'DEB3A', libelle: 'DEB3A' },
		{ code: 'DEB3B', libelle: 'DEB3B' },
		{ code: 'DEB3C', libelle: 'DEB3C' },
		{ code: 'DEB3D', libelle: 'DEB3D' },
		{ code: 'DEB3E', libelle: 'DEB3E' },
		{ code: 'DEB3F', libelle: 'DEB3F' },
		{ code: 'DEB3G', libelle: 'DEB3G' },
		{ code: 'DEB3H', libelle: 'DEB3H' },
		{ code: 'DEB3I', libelle: 'DEB3I' },
		{ code: 'DEB3J', libelle: 'DEB3J' },
		{ code: 'DEB3K', libelle: 'DEB3K' },
		{ code: 'DEC', libelle: 'DEC' },
		{ code: 'DEC0', libelle: 'DEC0' },
		{ code: 'DEC01', libelle: 'DEC01' },
		{ code: 'DEC02', libelle: 'DEC02' },
		{ code: 'DEC03', libelle: 'DEC03' },
		{ code: 'DEC04', libelle: 'DEC04' },
		{ code: 'DEC05', libelle: 'DEC05' },
		{ code: 'DEC06', libelle: 'DEC06' },
		{ code: 'DED', libelle: 'DED' },
		{ code: 'DED2', libelle: 'DED2' },
		{ code: 'DED21', libelle: 'DED21' },
		{ code: 'DED2C', libelle: 'DED2C' },
		{ code: 'DED2D', libelle: 'DED2D' },
		{ code: 'DED2E', libelle: 'DED2E' },
		{ code: 'DED2F', libelle: 'DED2F' },
		{ code: 'DED4', libelle: 'DED4' },
		{ code: 'DED41', libelle: 'DED41' },
		{ code: 'DED42', libelle: 'DED42' },
		{ code: 'DED43', libelle: 'DED43' },
		{ code: 'DED44', libelle: 'DED44' },
		{ code: 'DED45', libelle: 'DED45' },
		{ code: 'DED5', libelle: 'DED5' },
		{ code: 'DED51', libelle: 'DED51' },
		{ code: 'DED52', libelle: 'DED52' },
		{ code: 'DED53', libelle: 'DED53' },
		{ code: 'DEE', libelle: 'DEE' },
		{ code: 'DEE0', libelle: 'DEE0' },
		{ code: 'DEE01', libelle: 'DEE01' },
		{ code: 'DEE02', libelle: 'DEE02' },
		{ code: 'DEE03', libelle: 'DEE03' },
		{ code: 'DEE04', libelle: 'DEE04' },
		{ code: 'DEE05', libelle: 'DEE05' },
		{ code: 'DEE06', libelle: 'DEE06' },
		{ code: 'DEE07', libelle: 'DEE07' },
		{ code: 'DEE08', libelle: 'DEE08' },
		{ code: 'DEE09', libelle: 'DEE09' },
		{ code: 'DEE0A', libelle: 'DEE0A' },
		{ code: 'DEE0B', libelle: 'DEE0B' },
		{ code: 'DEE0C', libelle: 'DEE0C' },
		{ code: 'DEE0D', libelle: 'DEE0D' },
		{ code: 'DEE0E', libelle: 'DEE0E' },
		{ code: 'DEF', libelle: 'DEF' },
		{ code: 'DEF0', libelle: 'DEF0' },
		{ code: 'DEF01', libelle: 'DEF01' },
		{ code: 'DEF02', libelle: 'DEF02' },
		{ code: 'DEF03', libelle: 'DEF03' },
		{ code: 'DEF04', libelle: 'DEF04' },
		{ code: 'DEF05', libelle: 'DEF05' },
		{ code: 'DEF06', libelle: 'DEF06' },
		{ code: 'DEF07', libelle: 'DEF07' },
		{ code: 'DEF08', libelle: 'DEF08' },
		{ code: 'DEF09', libelle: 'DEF09' },
		{ code: 'DEF0A', libelle: 'DEF0A' },
		{ code: 'DEF0B', libelle: 'DEF0B' },
		{ code: 'DEF0C', libelle: 'DEF0C' },
		{ code: 'DEF0D', libelle: 'DEF0D' },
		{ code: 'DEF0E', libelle: 'DEF0E' },
		{ code: 'DEF0F', libelle: 'DEF0F' },
		{ code: 'DEG', libelle: 'DEG' },
		{ code: 'DEG0', libelle: 'DEG0' },
		{ code: 'DEG01', libelle: 'DEG01' },
		{ code: 'DEG02', libelle: 'DEG02' },
		{ code: 'DEG03', libelle: 'DEG03' },
		{ code: 'DEG04', libelle: 'DEG04' },
		{ code: 'DEG05', libelle: 'DEG05' },
		{ code: 'DEG06', libelle: 'DEG06' },
		{ code: 'DEG07', libelle: 'DEG07' },
		{ code: 'DEG09', libelle: 'DEG09' },
		{ code: 'DEG0A', libelle: 'DEG0A' },
		{ code: 'DEG0B', libelle: 'DEG0B' },
		{ code: 'DEG0C', libelle: 'DEG0C' },
		{ code: 'DEG0D', libelle: 'DEG0D' },
		{ code: 'DEG0E', libelle: 'DEG0E' },
		{ code: 'DEG0F', libelle: 'DEG0F' },
		{ code: 'DEG0G', libelle: 'DEG0G' },
		{ code: 'DEG0H', libelle: 'DEG0H' },
		{ code: 'DEG0I', libelle: 'DEG0I' },
		{ code: 'DEG0J', libelle: 'DEG0J' },
		{ code: 'DEG0K', libelle: 'DEG0K' },
		{ code: 'DEG0L', libelle: 'DEG0L' },
		{ code: 'DEG0M', libelle: 'DEG0M' },
		{ code: 'DEG0N', libelle: 'DEG0N' },
		{ code: 'DEG0P', libelle: 'DEG0P' },
		{ code: 'DEZ', libelle: 'DEZ' },
		{ code: 'DEZZ', libelle: 'DEZZ' },
		{ code: 'DEZZZ', libelle: 'DEZZZ' },
		{ code: 'EE', libelle: 'EE' },
		{ code: 'EE0', libelle: 'EE0' },
		{ code: 'EE00', libelle: 'EE00' },
		{ code: 'EE001', libelle: 'EE001' },
		{ code: 'EE004', libelle: 'EE004' },
		{ code: 'EE008', libelle: 'EE008' },
		{ code: 'EE009', libelle: 'EE009' },
		{ code: 'EE00A', libelle: 'EE00A' },
		{ code: 'EEZ', libelle: 'EEZ' },
		{ code: 'EEZZ', libelle: 'EEZZ' },
		{ code: 'EEZZZ', libelle: 'EEZZZ' },
		{ code: 'IE', libelle: 'IE' },
		{ code: 'IE0', libelle: 'IE0' },
		{ code: 'IE04', libelle: 'IE04' },
		{ code: 'IE041', libelle: 'IE041' },
		{ code: 'IE042', libelle: 'IE042' },
		{ code: 'IE05', libelle: 'IE05' },
		{ code: 'IE051', libelle: 'IE051' },
		{ code: 'IE052', libelle: 'IE052' },
		{ code: 'IE053', libelle: 'IE053' },
		{ code: 'IE06', libelle: 'IE06' },
		{ code: 'IE061', libelle: 'IE061' },
		{ code: 'IE062', libelle: 'IE062' },
		{ code: 'IE063', libelle: 'IE063' },
		{ code: 'IEZ', libelle: 'IEZ' },
		{ code: 'IEZZ', libelle: 'IEZZ' },
		{ code: 'IEZZZ', libelle: 'IEZZZ' },
		{ code: 'EL', libelle: 'EL' },
		{ code: 'EL3', libelle: 'EL3' },
		{ code: 'EL30', libelle: 'EL30' },
		{ code: 'EL301', libelle: 'EL301' },
		{ code: 'EL302', libelle: 'EL302' },
		{ code: 'EL303', libelle: 'EL303' },
		{ code: 'EL304', libelle: 'EL304' },
		{ code: 'EL305', libelle: 'EL305' },
		{ code: 'EL306', libelle: 'EL306' },
		{ code: 'EL307', libelle: 'EL307' },
		{ code: 'EL4', libelle: 'EL4' },
		{ code: 'EL41', libelle: 'EL41' },
		{ code: 'EL411', libelle: 'EL411' },
		{ code: 'EL412', libelle: 'EL412' },
		{ code: 'EL413', libelle: 'EL413' },
		{ code: 'EL42', libelle: 'EL42' },
		{ code: 'EL421', libelle: 'EL421' },
		{ code: 'EL422', libelle: 'EL422' },
		{ code: 'EL43', libelle: 'EL43' },
		{ code: 'EL431', libelle: 'EL431' },
		{ code: 'EL432', libelle: 'EL432' },
		{ code: 'EL433', libelle: 'EL433' },
		{ code: 'EL434', libelle: 'EL434' },
		{ code: 'EL5', libelle: 'EL5' },
		{ code: 'EL51', libelle: 'EL51' },
		{ code: 'EL511', libelle: 'EL511' },
		{ code: 'EL512', libelle: 'EL512' },
		{ code: 'EL513', libelle: 'EL513' },
		{ code: 'EL514', libelle: 'EL514' },
		{ code: 'EL515', libelle: 'EL515' },
		{ code: 'EL52', libelle: 'EL52' },
		{ code: 'EL521', libelle: 'EL521' },
		{ code: 'EL522', libelle: 'EL522' },
		{ code: 'EL523', libelle: 'EL523' },
		{ code: 'EL524', libelle: 'EL524' },
		{ code: 'EL525', libelle: 'EL525' },
		{ code: 'EL526', libelle: 'EL526' },
		{ code: 'EL527', libelle: 'EL527' },
		{ code: 'EL53', libelle: 'EL53' },
		{ code: 'EL531', libelle: 'EL531' },
		{ code: 'EL532', libelle: 'EL532' },
		{ code: 'EL533', libelle: 'EL533' },
		{ code: 'EL54', libelle: 'EL54' },
		{ code: 'EL541', libelle: 'EL541' },
		{ code: 'EL542', libelle: 'EL542' },
		{ code: 'EL543', libelle: 'EL543' },
		{ code: 'EL6', libelle: 'EL6' },
		{ code: 'EL61', libelle: 'EL61' },
		{ code: 'EL611', libelle: 'EL611' },
		{ code: 'EL612', libelle: 'EL612' },
		{ code: 'EL613', libelle: 'EL613' },
		{ code: 'EL62', libelle: 'EL62' },
		{ code: 'EL621', libelle: 'EL621' },
		{ code: 'EL622', libelle: 'EL622' },
		{ code: 'EL623', libelle: 'EL623' },
		{ code: 'EL624', libelle: 'EL624' },
		{ code: 'EL63', libelle: 'EL63' },
		{ code: 'EL631', libelle: 'EL631' },
		{ code: 'EL632', libelle: 'EL632' },
		{ code: 'EL633', libelle: 'EL633' },
		{ code: 'EL64', libelle: 'EL64' },
		{ code: 'EL641', libelle: 'EL641' },
		{ code: 'EL642', libelle: 'EL642' },
		{ code: 'EL643', libelle: 'EL643' },
		{ code: 'EL644', libelle: 'EL644' },
		{ code: 'EL645', libelle: 'EL645' },
		{ code: 'EL65', libelle: 'EL65' },
		{ code: 'EL651', libelle: 'EL651' },
		{ code: 'EL652', libelle: 'EL652' },
		{ code: 'EL653', libelle: 'EL653' },
		{ code: 'ELZ', libelle: 'ELZ' },
		{ code: 'ELZZ', libelle: 'ELZZ' },
		{ code: 'ELZZZ', libelle: 'ELZZZ' },
		{ code: 'ES', libelle: 'ES' },
		{ code: 'ES1', libelle: 'ES1' },
		{ code: 'ES11', libelle: 'ES11' },
		{ code: 'ES111', libelle: 'ES111' },
		{ code: 'ES112', libelle: 'ES112' },
		{ code: 'ES113', libelle: 'ES113' },
		{ code: 'ES114', libelle: 'ES114' },
		{ code: 'ES12', libelle: 'ES12' },
		{ code: 'ES120', libelle: 'ES120' },
		{ code: 'ES13', libelle: 'ES13' },
		{ code: 'ES130', libelle: 'ES130' },
		{ code: 'ES2', libelle: 'ES2' },
		{ code: 'ES21', libelle: 'ES21' },
		{ code: 'ES211', libelle: 'ES211' },
		{ code: 'ES212', libelle: 'ES212' },
		{ code: 'ES213', libelle: 'ES213' },
		{ code: 'ES22', libelle: 'ES22' },
		{ code: 'ES220', libelle: 'ES220' },
		{ code: 'ES23', libelle: 'ES23' },
		{ code: 'ES230', libelle: 'ES230' },
		{ code: 'ES24', libelle: 'ES24' },
		{ code: 'ES241', libelle: 'ES241' },
		{ code: 'ES242', libelle: 'ES242' },
		{ code: 'ES243', libelle: 'ES243' },
		{ code: 'ES3', libelle: 'ES3' },
		{ code: 'ES30', libelle: 'ES30' },
		{ code: 'ES300', libelle: 'ES300' },
		{ code: 'ES4', libelle: 'ES4' },
		{ code: 'ES41', libelle: 'ES41' },
		{ code: 'ES411', libelle: 'ES411' },
		{ code: 'ES412', libelle: 'ES412' },
		{ code: 'ES413', libelle: 'ES413' },
		{ code: 'ES414', libelle: 'ES414' },
		{ code: 'ES415', libelle: 'ES415' },
		{ code: 'ES416', libelle: 'ES416' },
		{ code: 'ES417', libelle: 'ES417' },
		{ code: 'ES418', libelle: 'ES418' },
		{ code: 'ES419', libelle: 'ES419' },
		{ code: 'ES42', libelle: 'ES42' },
		{ code: 'ES421', libelle: 'ES421' },
		{ code: 'ES422', libelle: 'ES422' },
		{ code: 'ES423', libelle: 'ES423' },
		{ code: 'ES424', libelle: 'ES424' },
		{ code: 'ES425', libelle: 'ES425' },
		{ code: 'ES43', libelle: 'ES43' },
		{ code: 'ES431', libelle: 'ES431' },
		{ code: 'ES432', libelle: 'ES432' },
		{ code: 'ES5', libelle: 'ES5' },
		{ code: 'ES51', libelle: 'ES51' },
		{ code: 'ES511', libelle: 'ES511' },
		{ code: 'ES512', libelle: 'ES512' },
		{ code: 'ES513', libelle: 'ES513' },
		{ code: 'ES514', libelle: 'ES514' },
		{ code: 'ES52', libelle: 'ES52' },
		{ code: 'ES521', libelle: 'ES521' },
		{ code: 'ES522', libelle: 'ES522' },
		{ code: 'ES523', libelle: 'ES523' },
		{ code: 'ES53', libelle: 'ES53' },
		{ code: 'ES531', libelle: 'ES531' },
		{ code: 'ES532', libelle: 'ES532' },
		{ code: 'ES533', libelle: 'ES533' },
		{ code: 'ES6', libelle: 'ES6' },
		{ code: 'ES61', libelle: 'ES61' },
		{ code: 'ES611', libelle: 'ES611' },
		{ code: 'ES612', libelle: 'ES612' },
		{ code: 'ES613', libelle: 'ES613' },
		{ code: 'ES614', libelle: 'ES614' },
		{ code: 'ES615', libelle: 'ES615' },
		{ code: 'ES616', libelle: 'ES616' },
		{ code: 'ES617', libelle: 'ES617' },
		{ code: 'ES618', libelle: 'ES618' },
		{ code: 'ES62', libelle: 'ES62' },
		{ code: 'ES620', libelle: 'ES620' },
		{ code: 'ES63', libelle: 'ES63' },
		{ code: 'ES630', libelle: 'ES630' },
		{ code: 'ES64', libelle: 'ES64' },
		{ code: 'ES640', libelle: 'ES640' },
		{ code: 'ES7', libelle: 'ES7' },
		{ code: 'ES70', libelle: 'ES70' },
		{ code: 'ES703', libelle: 'ES703' },
		{ code: 'ES704', libelle: 'ES704' },
		{ code: 'ES705', libelle: 'ES705' },
		{ code: 'ES706', libelle: 'ES706' },
		{ code: 'ES707', libelle: 'ES707' },
		{ code: 'ES708', libelle: 'ES708' },
		{ code: 'ES709', libelle: 'ES709' },
		{ code: 'ESZ', libelle: 'ESZ' },
		{ code: 'ESZZ', libelle: 'ESZZ' },
		{ code: 'ESZZZ', libelle: 'ESZZZ' },
		{ code: 'FR', libelle: 'FR' },
		{ code: 'FR1', libelle: 'FR1' },
		{ code: 'FR10', libelle: 'FR10' },
		{ code: 'FR101', libelle: 'FR101' },
		{ code: 'FR102', libelle: 'FR102' },
		{ code: 'FR103', libelle: 'FR103' },
		{ code: 'FR104', libelle: 'FR104' },
		{ code: 'FR105', libelle: 'FR105' },
		{ code: 'FR106', libelle: 'FR106' },
		{ code: 'FR107', libelle: 'FR107' },
		{ code: 'FR108', libelle: 'FR108' },
		{ code: 'FRB', libelle: 'FRB' },
		{ code: 'FRB0', libelle: 'FRB0' },
		{ code: 'FRB01', libelle: 'FRB01' },
		{ code: 'FRB02', libelle: 'FRB02' },
		{ code: 'FRB03', libelle: 'FRB03' },
		{ code: 'FRB04', libelle: 'FRB04' },
		{ code: 'FRB05', libelle: 'FRB05' },
		{ code: 'FRB06', libelle: 'FRB06' },
		{ code: 'FRC', libelle: 'FRC' },
		{ code: 'FRC1', libelle: 'FRC1' },
		{ code: 'FRC11', libelle: 'FRC11' },
		{ code: 'FRC12', libelle: 'FRC12' },
		{ code: 'FRC13', libelle: 'FRC13' },
		{ code: 'FRC14', libelle: 'FRC14' },
		{ code: 'FRC2', libelle: 'FRC2' },
		{ code: 'FRC21', libelle: 'FRC21' },
		{ code: 'FRC22', libelle: 'FRC22' },
		{ code: 'FRC23', libelle: 'FRC23' },
		{ code: 'FRC24', libelle: 'FRC24' },
		{ code: 'FRD', libelle: 'FRD' },
		{ code: 'FRD1', libelle: 'FRD1' },
		{ code: 'FRD11', libelle: 'FRD11' },
		{ code: 'FRD12', libelle: 'FRD12' },
		{ code: 'FRD13', libelle: 'FRD13' },
		{ code: 'FRD2', libelle: 'FRD2' },
		{ code: 'FRD21', libelle: 'FRD21' },
		{ code: 'FRD22', libelle: 'FRD22' },
		{ code: 'FRE', libelle: 'FRE' },
		{ code: 'FRE1', libelle: 'FRE1' },
		{ code: 'FRE11', libelle: 'FRE11' },
		{ code: 'FRE12', libelle: 'FRE12' },
		{ code: 'FRE2', libelle: 'FRE2' },
		{ code: 'FRE21', libelle: 'FRE21' },
		{ code: 'FRE22', libelle: 'FRE22' },
		{ code: 'FRE23', libelle: 'FRE23' },
		{ code: 'FRF', libelle: 'FRF' },
		{ code: 'FRF1', libelle: 'FRF1' },
		{ code: 'FRF11', libelle: 'FRF11' },
		{ code: 'FRF12', libelle: 'FRF12' },
		{ code: 'FRF2', libelle: 'FRF2' },
		{ code: 'FRF21', libelle: 'FRF21' },
		{ code: 'FRF22', libelle: 'FRF22' },
		{ code: 'FRF23', libelle: 'FRF23' },
		{ code: 'FRF24', libelle: 'FRF24' },
		{ code: 'FRF3', libelle: 'FRF3' },
		{ code: 'FRF31', libelle: 'FRF31' },
		{ code: 'FRF32', libelle: 'FRF32' },
		{ code: 'FRF33', libelle: 'FRF33' },
		{ code: 'FRF34', libelle: 'FRF34' },
		{ code: 'FRG', libelle: 'FRG' },
		{ code: 'FRG0', libelle: 'FRG0' },
		{ code: 'FRG01', libelle: 'FRG01' },
		{ code: 'FRG02', libelle: 'FRG02' },
		{ code: 'FRG03', libelle: 'FRG03' },
		{ code: 'FRG04', libelle: 'FRG04' },
		{ code: 'FRG05', libelle: 'FRG05' },
		{ code: 'FRH', libelle: 'FRH' },
		{ code: 'FRH0', libelle: 'FRH0' },
		{ code: 'FRH01', libelle: 'FRH01' },
		{ code: 'FRH02', libelle: 'FRH02' },
		{ code: 'FRH03', libelle: 'FRH03' },
		{ code: 'FRH04', libelle: 'FRH04' },
		{ code: 'FRI', libelle: 'FRI' },
		{ code: 'FRI1', libelle: 'FRI1' },
		{ code: 'FRI11', libelle: 'FRI11' },
		{ code: 'FRI12', libelle: 'FRI12' },
		{ code: 'FRI13', libelle: 'FRI13' },
		{ code: 'FRI14', libelle: 'FRI14' },
		{ code: 'FRI15', libelle: 'FRI15' },
		{ code: 'FRI2', libelle: 'FRI2' },
		{ code: 'FRI21', libelle: 'FRI21' },
		{ code: 'FRI22', libelle: 'FRI22' },
		{ code: 'FRI23', libelle: 'FRI23' },
		{ code: 'FRI3', libelle: 'FRI3' },
		{ code: 'FRI31', libelle: 'FRI31' },
		{ code: 'FRI32', libelle: 'FRI32' },
		{ code: 'FRI33', libelle: 'FRI33' },
		{ code: 'FRI34', libelle: 'FRI34' },
		{ code: 'FRJ', libelle: 'FRJ' },
		{ code: 'FRJ1', libelle: 'FRJ1' },
		{ code: 'FRJ11', libelle: 'FRJ11' },
		{ code: 'FRJ12', libelle: 'FRJ12' },
		{ code: 'FRJ13', libelle: 'FRJ13' },
		{ code: 'FRJ14', libelle: 'FRJ14' },
		{ code: 'FRJ15', libelle: 'FRJ15' },
		{ code: 'FRJ2', libelle: 'FRJ2' },
		{ code: 'FRJ21', libelle: 'FRJ21' },
		{ code: 'FRJ22', libelle: 'FRJ22' },
		{ code: 'FRJ23', libelle: 'FRJ23' },
		{ code: 'FRJ24', libelle: 'FRJ24' },
		{ code: 'FRJ25', libelle: 'FRJ25' },
		{ code: 'FRJ26', libelle: 'FRJ26' },
		{ code: 'FRJ27', libelle: 'FRJ27' },
		{ code: 'FRJ28', libelle: 'FRJ28' },
		{ code: 'FRK', libelle: 'FRK' },
		{ code: 'FRK1', libelle: 'FRK1' },
		{ code: 'FRK11', libelle: 'FRK11' },
		{ code: 'FRK12', libelle: 'FRK12' },
		{ code: 'FRK13', libelle: 'FRK13' },
		{ code: 'FRK14', libelle: 'FRK14' },
		{ code: 'FRK2', libelle: 'FRK2' },
		{ code: 'FRK21', libelle: 'FRK21' },
		{ code: 'FRK22', libelle: 'FRK22' },
		{ code: 'FRK23', libelle: 'FRK23' },
		{ code: 'FRK24', libelle: 'FRK24' },
		{ code: 'FRK25', libelle: 'FRK25' },
		{ code: 'FRK26', libelle: 'FRK26' },
		{ code: 'FRK27', libelle: 'FRK27' },
		{ code: 'FRK28', libelle: 'FRK28' },
		{ code: 'FRL', libelle: 'FRL' },
		{ code: 'FRL0', libelle: 'FRL0' },
		{ code: 'FRL01', libelle: 'FRL01' },
		{ code: 'FRL02', libelle: 'FRL02' },
		{ code: 'FRL03', libelle: 'FRL03' },
		{ code: 'FRL04', libelle: 'FRL04' },
		{ code: 'FRL05', libelle: 'FRL05' },
		{ code: 'FRL06', libelle: 'FRL06' },
		{ code: 'FRM', libelle: 'FRM' },
		{ code: 'FRM0', libelle: 'FRM0' },
		{ code: 'FRM01', libelle: 'FRM01' },
		{ code: 'FRM02', libelle: 'FRM02' },
		{ code: 'FRY', libelle: 'FRY' },
		{ code: 'FRY1', libelle: 'FRY1' },
		{ code: 'FRY10', libelle: 'FRY10' },
		{ code: 'FRY2', libelle: 'FRY2' },
		{ code: 'FRY20', libelle: 'FRY20' },
		{ code: 'FRY3', libelle: 'FRY3' },
		{ code: 'FRY30', libelle: 'FRY30' },
		{ code: 'FRY4', libelle: 'FRY4' },
		{ code: 'FRY40', libelle: 'FRY40' },
		{ code: 'FRY5', libelle: 'FRY5' },
		{ code: 'FRY50', libelle: 'FRY50' },
		{ code: 'FRZ', libelle: 'FRZ' },
		{ code: 'FRZZ', libelle: 'FRZZ' },
		{ code: 'FRZZZ', libelle: 'FRZZZ' },
		{ code: 'HR', libelle: 'HR' },
		{ code: 'HR0', libelle: 'HR0' },
		{ code: 'HR02', libelle: 'HR02' },
		{ code: 'HR021', libelle: 'HR021' },
		{ code: 'HR022', libelle: 'HR022' },
		{ code: 'HR023', libelle: 'HR023' },
		{ code: 'HR024', libelle: 'HR024' },
		{ code: 'HR025', libelle: 'HR025' },
		{ code: 'HR026', libelle: 'HR026' },
		{ code: 'HR027', libelle: 'HR027' },
		{ code: 'HR028', libelle: 'HR028' },
		{ code: 'HR03', libelle: 'HR03' },
		{ code: 'HR031', libelle: 'HR031' },
		{ code: 'HR032', libelle: 'HR032' },
		{ code: 'HR033', libelle: 'HR033' },
		{ code: 'HR034', libelle: 'HR034' },
		{ code: 'HR035', libelle: 'HR035' },
		{ code: 'HR036', libelle: 'HR036' },
		{ code: 'HR037', libelle: 'HR037' },
		{ code: 'HR05', libelle: 'HR05' },
		{ code: 'HR050', libelle: 'HR050' },
		{ code: 'HR06', libelle: 'HR06' },
		{ code: 'HR061', libelle: 'HR061' },
		{ code: 'HR062', libelle: 'HR062' },
		{ code: 'HR063', libelle: 'HR063' },
		{ code: 'HR064', libelle: 'HR064' },
		{ code: 'HR065', libelle: 'HR065' },
		{ code: 'HRZ', libelle: 'HRZ' },
		{ code: 'HRZZ', libelle: 'HRZZ' },
		{ code: 'HRZZZ', libelle: 'HRZZZ' },
		{ code: 'IT', libelle: 'IT' },
		{ code: 'ITC', libelle: 'ITC' },
		{ code: 'ITC1', libelle: 'ITC1' },
		{ code: 'ITC11', libelle: 'ITC11' },
		{ code: 'ITC12', libelle: 'ITC12' },
		{ code: 'ITC13', libelle: 'ITC13' },
		{ code: 'ITC14', libelle: 'ITC14' },
		{ code: 'ITC15', libelle: 'ITC15' },
		{ code: 'ITC16', libelle: 'ITC16' },
		{ code: 'ITC17', libelle: 'ITC17' },
		{ code: 'ITC18', libelle: 'ITC18' },
		{ code: 'ITC2', libelle: 'ITC2' },
		{ code: 'ITC20', libelle: 'ITC20' },
		{ code: 'ITC3', libelle: 'ITC3' },
		{ code: 'ITC31', libelle: 'ITC31' },
		{ code: 'ITC32', libelle: 'ITC32' },
		{ code: 'ITC33', libelle: 'ITC33' },
		{ code: 'ITC34', libelle: 'ITC34' },
		{ code: 'ITC4', libelle: 'ITC4' },
		{ code: 'ITC41', libelle: 'ITC41' },
		{ code: 'ITC42', libelle: 'ITC42' },
		{ code: 'ITC43', libelle: 'ITC43' },
		{ code: 'ITC44', libelle: 'ITC44' },
		{ code: 'ITC46', libelle: 'ITC46' },
		{ code: 'ITC47', libelle: 'ITC47' },
		{ code: 'ITC48', libelle: 'ITC48' },
		{ code: 'ITC49', libelle: 'ITC49' },
		{ code: 'ITC4A', libelle: 'ITC4A' },
		{ code: 'ITC4B', libelle: 'ITC4B' },
		{ code: 'ITC4C', libelle: 'ITC4C' },
		{ code: 'ITC4D', libelle: 'ITC4D' },
		{ code: 'ITF', libelle: 'ITF' },
		{ code: 'ITF1', libelle: 'ITF1' },
		{ code: 'ITF11', libelle: 'ITF11' },
		{ code: 'ITF12', libelle: 'ITF12' },
		{ code: 'ITF13', libelle: 'ITF13' },
		{ code: 'ITF14', libelle: 'ITF14' },
		{ code: 'ITF2', libelle: 'ITF2' },
		{ code: 'ITF21', libelle: 'ITF21' },
		{ code: 'ITF22', libelle: 'ITF22' },
		{ code: 'ITF3', libelle: 'ITF3' },
		{ code: 'ITF31', libelle: 'ITF31' },
		{ code: 'ITF32', libelle: 'ITF32' },
		{ code: 'ITF33', libelle: 'ITF33' },
		{ code: 'ITF34', libelle: 'ITF34' },
		{ code: 'ITF35', libelle: 'ITF35' },
		{ code: 'ITF4', libelle: 'ITF4' },
		{ code: 'ITF43', libelle: 'ITF43' },
		{ code: 'ITF44', libelle: 'ITF44' },
		{ code: 'ITF45', libelle: 'ITF45' },
		{ code: 'ITF46', libelle: 'ITF46' },
		{ code: 'ITF47', libelle: 'ITF47' },
		{ code: 'ITF48', libelle: 'ITF48' },
		{ code: 'ITF5', libelle: 'ITF5' },
		{ code: 'ITF51', libelle: 'ITF51' },
		{ code: 'ITF52', libelle: 'ITF52' },
		{ code: 'ITF6', libelle: 'ITF6' },
		{ code: 'ITF61', libelle: 'ITF61' },
		{ code: 'ITF62', libelle: 'ITF62' },
		{ code: 'ITF63', libelle: 'ITF63' },
		{ code: 'ITF64', libelle: 'ITF64' },
		{ code: 'ITF65', libelle: 'ITF65' },
		{ code: 'ITG', libelle: 'ITG' },
		{ code: 'ITG1', libelle: 'ITG1' },
		{ code: 'ITG11', libelle: 'ITG11' },
		{ code: 'ITG12', libelle: 'ITG12' },
		{ code: 'ITG13', libelle: 'ITG13' },
		{ code: 'ITG14', libelle: 'ITG14' },
		{ code: 'ITG15', libelle: 'ITG15' },
		{ code: 'ITG16', libelle: 'ITG16' },
		{ code: 'ITG17', libelle: 'ITG17' },
		{ code: 'ITG18', libelle: 'ITG18' },
		{ code: 'ITG19', libelle: 'ITG19' },
		{ code: 'ITG2', libelle: 'ITG2' },
		{ code: 'ITG2D', libelle: 'ITG2D' },
		{ code: 'ITG2E', libelle: 'ITG2E' },
		{ code: 'ITG2F', libelle: 'ITG2F' },
		{ code: 'ITG2G', libelle: 'ITG2G' },
		{ code: 'ITG2H', libelle: 'ITG2H' },
		{ code: 'ITH', libelle: 'ITH' },
		{ code: 'ITH1', libelle: 'ITH1' },
		{ code: 'ITH10', libelle: 'ITH10' },
		{ code: 'ITH2', libelle: 'ITH2' },
		{ code: 'ITH20', libelle: 'ITH20' },
		{ code: 'ITH3', libelle: 'ITH3' },
		{ code: 'ITH31', libelle: 'ITH31' },
		{ code: 'ITH32', libelle: 'ITH32' },
		{ code: 'ITH33', libelle: 'ITH33' },
		{ code: 'ITH34', libelle: 'ITH34' },
		{ code: 'ITH35', libelle: 'ITH35' },
		{ code: 'ITH36', libelle: 'ITH36' },
		{ code: 'ITH37', libelle: 'ITH37' },
		{ code: 'ITH4', libelle: 'ITH4' },
		{ code: 'ITH41', libelle: 'ITH41' },
		{ code: 'ITH42', libelle: 'ITH42' },
		{ code: 'ITH43', libelle: 'ITH43' },
		{ code: 'ITH44', libelle: 'ITH44' },
		{ code: 'ITH5', libelle: 'ITH5' },
		{ code: 'ITH51', libelle: 'ITH51' },
		{ code: 'ITH52', libelle: 'ITH52' },
		{ code: 'ITH53', libelle: 'ITH53' },
		{ code: 'ITH54', libelle: 'ITH54' },
		{ code: 'ITH55', libelle: 'ITH55' },
		{ code: 'ITH56', libelle: 'ITH56' },
		{ code: 'ITH57', libelle: 'ITH57' },
		{ code: 'ITH58', libelle: 'ITH58' },
		{ code: 'ITH59', libelle: 'ITH59' },
		{ code: 'ITI', libelle: 'ITI' },
		{ code: 'ITI1', libelle: 'ITI1' },
		{ code: 'ITI11', libelle: 'ITI11' },
		{ code: 'ITI12', libelle: 'ITI12' },
		{ code: 'ITI13', libelle: 'ITI13' },
		{ code: 'ITI14', libelle: 'ITI14' },
		{ code: 'ITI15', libelle: 'ITI15' },
		{ code: 'ITI16', libelle: 'ITI16' },
		{ code: 'ITI17', libelle: 'ITI17' },
		{ code: 'ITI18', libelle: 'ITI18' },
		{ code: 'ITI19', libelle: 'ITI19' },
		{ code: 'ITI1A', libelle: 'ITI1A' },
		{ code: 'ITI2', libelle: 'ITI2' },
		{ code: 'ITI21', libelle: 'ITI21' },
		{ code: 'ITI22', libelle: 'ITI22' },
		{ code: 'ITI3', libelle: 'ITI3' },
		{ code: 'ITI31', libelle: 'ITI31' },
		{ code: 'ITI32', libelle: 'ITI32' },
		{ code: 'ITI33', libelle: 'ITI33' },
		{ code: 'ITI34', libelle: 'ITI34' },
		{ code: 'ITI35', libelle: 'ITI35' },
		{ code: 'ITI4', libelle: 'ITI4' },
		{ code: 'ITI41', libelle: 'ITI41' },
		{ code: 'ITI42', libelle: 'ITI42' },
		{ code: 'ITI43', libelle: 'ITI43' },
		{ code: 'ITI44', libelle: 'ITI44' },
		{ code: 'ITI45', libelle: 'ITI45' },
		{ code: 'ITZ', libelle: 'ITZ' },
		{ code: 'ITZZ', libelle: 'ITZZ' },
		{ code: 'ITZZZ', libelle: 'ITZZZ' },
		{ code: 'CY', libelle: 'CY' },
		{ code: 'CY0', libelle: 'CY0' },
		{ code: 'CY00', libelle: 'CY00' },
		{ code: 'CY000', libelle: 'CY000' },
		{ code: 'CYZ', libelle: 'CYZ' },
		{ code: 'CYZZ', libelle: 'CYZZ' },
		{ code: 'CYZZZ', libelle: 'CYZZZ' },
		{ code: 'LV', libelle: 'LV' },
		{ code: 'LV0', libelle: 'LV0' },
		{ code: 'LV00', libelle: 'LV00' },
		{ code: 'LV003', libelle: 'LV003' },
		{ code: 'LV005', libelle: 'LV005' },
		{ code: 'LV006', libelle: 'LV006' },
		{ code: 'LV007', libelle: 'LV007' },
		{ code: 'LV008', libelle: 'LV008' },
		{ code: 'LV009', libelle: 'LV009' },
		{ code: 'LVZ', libelle: 'LVZ' },
		{ code: 'LVZZ', libelle: 'LVZZ' },
		{ code: 'LVZZZ', libelle: 'LVZZZ' },
		{ code: 'LT', libelle: 'LT' },
		{ code: 'LT0', libelle: 'LT0' },
		{ code: 'LT01', libelle: 'LT01' },
		{ code: 'LT011', libelle: 'LT011' },
		{ code: 'LT02', libelle: 'LT02' },
		{ code: 'LT021', libelle: 'LT021' },
		{ code: 'LT022', libelle: 'LT022' },
		{ code: 'LT023', libelle: 'LT023' },
		{ code: 'LT024', libelle: 'LT024' },
		{ code: 'LT025', libelle: 'LT025' },
		{ code: 'LT026', libelle: 'LT026' },
		{ code: 'LT027', libelle: 'LT027' },
		{ code: 'LT028', libelle: 'LT028' },
		{ code: 'LT029', libelle: 'LT029' },
		{ code: 'LTZ', libelle: 'LTZ' },
		{ code: 'LTZZ', libelle: 'LTZZ' },
		{ code: 'LTZZZ', libelle: 'LTZZZ' },
		{ code: 'LU', libelle: 'LU' },
		{ code: 'LU0', libelle: 'LU0' },
		{ code: 'LU00', libelle: 'LU00' },
		{ code: 'LU000', libelle: 'LU000' },
		{ code: 'LUZ', libelle: 'LUZ' },
		{ code: 'LUZZ', libelle: 'LUZZ' },
		{ code: 'LUZZZ', libelle: 'LUZZZ' },
		{ code: 'HU', libelle: 'HU' },
		{ code: 'HU1', libelle: 'HU1' },
		{ code: 'HU11', libelle: 'HU11' },
		{ code: 'HU110', libelle: 'HU110' },
		{ code: 'HU12', libelle: 'HU12' },
		{ code: 'HU120', libelle: 'HU120' },
		{ code: 'HU2', libelle: 'HU2' },
		{ code: 'HU21', libelle: 'HU21' },
		{ code: 'HU211', libelle: 'HU211' },
		{ code: 'HU212', libelle: 'HU212' },
		{ code: 'HU213', libelle: 'HU213' },
		{ code: 'HU22', libelle: 'HU22' },
		{ code: 'HU221', libelle: 'HU221' },
		{ code: 'HU222', libelle: 'HU222' },
		{ code: 'HU223', libelle: 'HU223' },
		{ code: 'HU23', libelle: 'HU23' },
		{ code: 'HU231', libelle: 'HU231' },
		{ code: 'HU232', libelle: 'HU232' },
		{ code: 'HU233', libelle: 'HU233' },
		{ code: 'HU3', libelle: 'HU3' },
		{ code: 'HU31', libelle: 'HU31' },
		{ code: 'HU311', libelle: 'HU311' },
		{ code: 'HU312', libelle: 'HU312' },
		{ code: 'HU313', libelle: 'HU313' },
		{ code: 'HU32', libelle: 'HU32' },
		{ code: 'HU321', libelle: 'HU321' },
		{ code: 'HU322', libelle: 'HU322' },
		{ code: 'HU323', libelle: 'HU323' },
		{ code: 'HU33', libelle: 'HU33' },
		{ code: 'HU331', libelle: 'HU331' },
		{ code: 'HU332', libelle: 'HU332' },
		{ code: 'HU333', libelle: 'HU333' },
		{ code: 'HUZ', libelle: 'HUZ' },
		{ code: 'HUZZ', libelle: 'HUZZ' },
		{ code: 'HUZZZ', libelle: 'HUZZZ' },
		{ code: 'MT', libelle: 'MT' },
		{ code: 'MT0', libelle: 'MT0' },
		{ code: 'MT00', libelle: 'MT00' },
		{ code: 'MT001', libelle: 'MT001' },
		{ code: 'MT002', libelle: 'MT002' },
		{ code: 'MTZ', libelle: 'MTZ' },
		{ code: 'MTZZ', libelle: 'MTZZ' },
		{ code: 'MTZZZ', libelle: 'MTZZZ' },
		{ code: 'NL', libelle: 'NL' },
		{ code: 'NL1', libelle: 'NL1' },
		{ code: 'NL11', libelle: 'NL11' },
		{ code: 'NL111', libelle: 'NL111' },
		{ code: 'NL112', libelle: 'NL112' },
		{ code: 'NL113', libelle: 'NL113' },
		{ code: 'NL12', libelle: 'NL12' },
		{ code: 'NL124', libelle: 'NL124' },
		{ code: 'NL125', libelle: 'NL125' },
		{ code: 'NL126', libelle: 'NL126' },
		{ code: 'NL13', libelle: 'NL13' },
		{ code: 'NL131', libelle: 'NL131' },
		{ code: 'NL132', libelle: 'NL132' },
		{ code: 'NL133', libelle: 'NL133' },
		{ code: 'NL2', libelle: 'NL2' },
		{ code: 'NL21', libelle: 'NL21' },
		{ code: 'NL211', libelle: 'NL211' },
		{ code: 'NL212', libelle: 'NL212' },
		{ code: 'NL213', libelle: 'NL213' },
		{ code: 'NL22', libelle: 'NL22' },
		{ code: 'NL221', libelle: 'NL221' },
		{ code: 'NL224', libelle: 'NL224' },
		{ code: 'NL225', libelle: 'NL225' },
		{ code: 'NL226', libelle: 'NL226' },
		{ code: 'NL23', libelle: 'NL23' },
		{ code: 'NL230', libelle: 'NL230' },
		{ code: 'NL3', libelle: 'NL3' },
		{ code: 'NL31', libelle: 'NL31' },
		{ code: 'NL310', libelle: 'NL310' },
		{ code: 'NL32', libelle: 'NL32' },
		{ code: 'NL321', libelle: 'NL321' },
		{ code: 'NL323', libelle: 'NL323' },
		{ code: 'NL324', libelle: 'NL324' },
		{ code: 'NL325', libelle: 'NL325' },
		{ code: 'NL327', libelle: 'NL327' },
		{ code: 'NL328', libelle: 'NL328' },
		{ code: 'NL329', libelle: 'NL329' },
		{ code: 'NL33', libelle: 'NL33' },
		{ code: 'NL332', libelle: 'NL332' },
		{ code: 'NL333', libelle: 'NL333' },
		{ code: 'NL337', libelle: 'NL337' },
		{ code: 'NL33A', libelle: 'NL33A' },
		{ code: 'NL33B', libelle: 'NL33B' },
		{ code: 'NL33C', libelle: 'NL33C' },
		{ code: 'NL34', libelle: 'NL34' },
		{ code: 'NL341', libelle: 'NL341' },
		{ code: 'NL342', libelle: 'NL342' },
		{ code: 'NL4', libelle: 'NL4' },
		{ code: 'NL41', libelle: 'NL41' },
		{ code: 'NL411', libelle: 'NL411' },
		{ code: 'NL412', libelle: 'NL412' },
		{ code: 'NL413', libelle: 'NL413' },
		{ code: 'NL414', libelle: 'NL414' },
		{ code: 'NL42', libelle: 'NL42' },
		{ code: 'NL421', libelle: 'NL421' },
		{ code: 'NL422', libelle: 'NL422' },
		{ code: 'NL423', libelle: 'NL423' },
		{ code: 'NLZ', libelle: 'NLZ' },
		{ code: 'NLZZ', libelle: 'NLZZ' },
		{ code: 'NLZZZ', libelle: 'NLZZZ' },
		{ code: 'AT', libelle: 'AT' },
		{ code: 'AT1', libelle: 'AT1' },
		{ code: 'AT11', libelle: 'AT11' },
		{ code: 'AT111', libelle: 'AT111' },
		{ code: 'AT112', libelle: 'AT112' },
		{ code: 'AT113', libelle: 'AT113' },
		{ code: 'AT12', libelle: 'AT12' },
		{ code: 'AT121', libelle: 'AT121' },
		{ code: 'AT122', libelle: 'AT122' },
		{ code: 'AT123', libelle: 'AT123' },
		{ code: 'AT124', libelle: 'AT124' },
		{ code: 'AT125', libelle: 'AT125' },
		{ code: 'AT126', libelle: 'AT126' },
		{ code: 'AT127', libelle: 'AT127' },
		{ code: 'AT13', libelle: 'AT13' },
		{ code: 'AT130', libelle: 'AT130' },
		{ code: 'AT2', libelle: 'AT2' },
		{ code: 'AT21', libelle: 'AT21' },
		{ code: 'AT211', libelle: 'AT211' },
		{ code: 'AT212', libelle: 'AT212' },
		{ code: 'AT213', libelle: 'AT213' },
		{ code: 'AT22', libelle: 'AT22' },
		{ code: 'AT221', libelle: 'AT221' },
		{ code: 'AT222', libelle: 'AT222' },
		{ code: 'AT223', libelle: 'AT223' },
		{ code: 'AT224', libelle: 'AT224' },
		{ code: 'AT225', libelle: 'AT225' },
		{ code: 'AT226', libelle: 'AT226' },
		{ code: 'AT3', libelle: 'AT3' },
		{ code: 'AT31', libelle: 'AT31' },
		{ code: 'AT311', libelle: 'AT311' },
		{ code: 'AT312', libelle: 'AT312' },
		{ code: 'AT313', libelle: 'AT313' },
		{ code: 'AT314', libelle: 'AT314' },
		{ code: 'AT315', libelle: 'AT315' },
		{ code: 'AT32', libelle: 'AT32' },
		{ code: 'AT321', libelle: 'AT321' },
		{ code: 'AT322', libelle: 'AT322' },
		{ code: 'AT323', libelle: 'AT323' },
		{ code: 'AT33', libelle: 'AT33' },
		{ code: 'AT331', libelle: 'AT331' },
		{ code: 'AT332', libelle: 'AT332' },
		{ code: 'AT333', libelle: 'AT333' },
		{ code: 'AT334', libelle: 'AT334' },
		{ code: 'AT335', libelle: 'AT335' },
		{ code: 'AT34', libelle: 'AT34' },
		{ code: 'AT341', libelle: 'AT341' },
		{ code: 'AT342', libelle: 'AT342' },
		{ code: 'ATZ', libelle: 'ATZ' },
		{ code: 'ATZZ', libelle: 'ATZZ' },
		{ code: 'ATZZZ', libelle: 'ATZZZ' },
		{ code: 'PL', libelle: 'PL' },
		{ code: 'PL2', libelle: 'PL2' },
		{ code: 'PL21', libelle: 'PL21' },
		{ code: 'PL213', libelle: 'PL213' },
		{ code: 'PL214', libelle: 'PL214' },
		{ code: 'PL217', libelle: 'PL217' },
		{ code: 'PL218', libelle: 'PL218' },
		{ code: 'PL219', libelle: 'PL219' },
		{ code: 'PL21A', libelle: 'PL21A' },
		{ code: 'PL22', libelle: 'PL22' },
		{ code: 'PL224', libelle: 'PL224' },
		{ code: 'PL225', libelle: 'PL225' },
		{ code: 'PL227', libelle: 'PL227' },
		{ code: 'PL228', libelle: 'PL228' },
		{ code: 'PL229', libelle: 'PL229' },
		{ code: 'PL22A', libelle: 'PL22A' },
		{ code: 'PL22B', libelle: 'PL22B' },
		{ code: 'PL22C', libelle: 'PL22C' },
		{ code: 'PL4', libelle: 'PL4' },
		{ code: 'PL41', libelle: 'PL41' },
		{ code: 'PL411', libelle: 'PL411' },
		{ code: 'PL414', libelle: 'PL414' },
		{ code: 'PL415', libelle: 'PL415' },
		{ code: 'PL416', libelle: 'PL416' },
		{ code: 'PL417', libelle: 'PL417' },
		{ code: 'PL418', libelle: 'PL418' },
		{ code: 'PL42', libelle: 'PL42' },
		{ code: 'PL424', libelle: 'PL424' },
		{ code: 'PL426', libelle: 'PL426' },
		{ code: 'PL427', libelle: 'PL427' },
		{ code: 'PL428', libelle: 'PL428' },
		{ code: 'PL43', libelle: 'PL43' },
		{ code: 'PL431', libelle: 'PL431' },
		{ code: 'PL432', libelle: 'PL432' },
		{ code: 'PL5', libelle: 'PL5' },
		{ code: 'PL51', libelle: 'PL51' },
		{ code: 'PL514', libelle: 'PL514' },
		{ code: 'PL515', libelle: 'PL515' },
		{ code: 'PL516', libelle: 'PL516' },
		{ code: 'PL517', libelle: 'PL517' },
		{ code: 'PL518', libelle: 'PL518' },
		{ code: 'PL52', libelle: 'PL52' },
		{ code: 'PL523', libelle: 'PL523' },
		{ code: 'PL524', libelle: 'PL524' },
		{ code: 'PL6', libelle: 'PL6' },
		{ code: 'PL61', libelle: 'PL61' },
		{ code: 'PL613', libelle: 'PL613' },
		{ code: 'PL616', libelle: 'PL616' },
		{ code: 'PL617', libelle: 'PL617' },
		{ code: 'PL618', libelle: 'PL618' },
		{ code: 'PL619', libelle: 'PL619' },
		{ code: 'PL62', libelle: 'PL62' },
		{ code: 'PL621', libelle: 'PL621' },
		{ code: 'PL622', libelle: 'PL622' },
		{ code: 'PL623', libelle: 'PL623' },
		{ code: 'PL63', libelle: 'PL63' },
		{ code: 'PL633', libelle: 'PL633' },
		{ code: 'PL634', libelle: 'PL634' },
		{ code: 'PL636', libelle: 'PL636' },
		{ code: 'PL637', libelle: 'PL637' },
		{ code: 'PL638', libelle: 'PL638' },
		{ code: 'PL7', libelle: 'PL7' },
		{ code: 'PL71', libelle: 'PL71' },
		{ code: 'PL711', libelle: 'PL711' },
		{ code: 'PL712', libelle: 'PL712' },
		{ code: 'PL713', libelle: 'PL713' },
		{ code: 'PL714', libelle: 'PL714' },
		{ code: 'PL715', libelle: 'PL715' },
		{ code: 'PL72', libelle: 'PL72' },
		{ code: 'PL721', libelle: 'PL721' },
		{ code: 'PL722', libelle: 'PL722' },
		{ code: 'PL8', libelle: 'PL8' },
		{ code: 'PL81', libelle: 'PL81' },
		{ code: 'PL811', libelle: 'PL811' },
		{ code: 'PL812', libelle: 'PL812' },
		{ code: 'PL814', libelle: 'PL814' },
		{ code: 'PL815', libelle: 'PL815' },
		{ code: 'PL82', libelle: 'PL82' },
		{ code: 'PL821', libelle: 'PL821' },
		{ code: 'PL822', libelle: 'PL822' },
		{ code: 'PL823', libelle: 'PL823' },
		{ code: 'PL824', libelle: 'PL824' },
		{ code: 'PL84', libelle: 'PL84' },
		{ code: 'PL841', libelle: 'PL841' },
		{ code: 'PL842', libelle: 'PL842' },
		{ code: 'PL843', libelle: 'PL843' },
		{ code: 'PL9', libelle: 'PL9' },
		{ code: 'PL91', libelle: 'PL91' },
		{ code: 'PL911', libelle: 'PL911' },
		{ code: 'PL912', libelle: 'PL912' },
		{ code: 'PL913', libelle: 'PL913' },
		{ code: 'PL92', libelle: 'PL92' },
		{ code: 'PL921', libelle: 'PL921' },
		{ code: 'PL922', libelle: 'PL922' },
		{ code: 'PL923', libelle: 'PL923' },
		{ code: 'PL924', libelle: 'PL924' },
		{ code: 'PL925', libelle: 'PL925' },
		{ code: 'PL926', libelle: 'PL926' },
		{ code: 'PLZ', libelle: 'PLZ' },
		{ code: 'PLZZ', libelle: 'PLZZ' },
		{ code: 'PLZZZ', libelle: 'PLZZZ' },
		{ code: 'PT', libelle: 'PT' },
		{ code: 'PT1', libelle: 'PT1' },
		{ code: 'PT11', libelle: 'PT11' },
		{ code: 'PT111', libelle: 'PT111' },
		{ code: 'PT112', libelle: 'PT112' },
		{ code: 'PT119', libelle: 'PT119' },
		{ code: 'PT11A', libelle: 'PT11A' },
		{ code: 'PT11B', libelle: 'PT11B' },
		{ code: 'PT11C', libelle: 'PT11C' },
		{ code: 'PT11D', libelle: 'PT11D' },
		{ code: 'PT11E', libelle: 'PT11E' },
		{ code: 'PT15', libelle: 'PT15' },
		{ code: 'PT150', libelle: 'PT150' },
		{ code: 'PT16', libelle: 'PT16' },
		{ code: 'PT16B', libelle: 'PT16B' },
		{ code: 'PT16D', libelle: 'PT16D' },
		{ code: 'PT16E', libelle: 'PT16E' },
		{ code: 'PT16F', libelle: 'PT16F' },
		{ code: 'PT16G', libelle: 'PT16G' },
		{ code: 'PT16H', libelle: 'PT16H' },
		{ code: 'PT16I', libelle: 'PT16I' },
		{ code: 'PT16J', libelle: 'PT16J' },
		{ code: 'PT17', libelle: 'PT17' },
		{ code: 'PT170', libelle: 'PT170' },
		{ code: 'PT18', libelle: 'PT18' },
		{ code: 'PT181', libelle: 'PT181' },
		{ code: 'PT184', libelle: 'PT184' },
		{ code: 'PT185', libelle: 'PT185' },
		{ code: 'PT186', libelle: 'PT186' },
		{ code: 'PT187', libelle: 'PT187' },
		{ code: 'PT2', libelle: 'PT2' },
		{ code: 'PT20', libelle: 'PT20' },
		{ code: 'PT200', libelle: 'PT200' },
		{ code: 'PT3', libelle: 'PT3' },
		{ code: 'PT30', libelle: 'PT30' },
		{ code: 'PT300', libelle: 'PT300' },
		{ code: 'PTZ', libelle: 'PTZ' },
		{ code: 'PTZZ', libelle: 'PTZZ' },
		{ code: 'PTZZZ', libelle: 'PTZZZ' },
		{ code: 'RO', libelle: 'RO' },
		{ code: 'RO1', libelle: 'RO1' },
		{ code: 'RO11', libelle: 'RO11' },
		{ code: 'RO111', libelle: 'RO111' },
		{ code: 'RO112', libelle: 'RO112' },
		{ code: 'RO113', libelle: 'RO113' },
		{ code: 'RO114', libelle: 'RO114' },
		{ code: 'RO115', libelle: 'RO115' },
		{ code: 'RO116', libelle: 'RO116' },
		{ code: 'RO12', libelle: 'RO12' },
		{ code: 'RO121', libelle: 'RO121' },
		{ code: 'RO122', libelle: 'RO122' },
		{ code: 'RO123', libelle: 'RO123' },
		{ code: 'RO124', libelle: 'RO124' },
		{ code: 'RO125', libelle: 'RO125' },
		{ code: 'RO126', libelle: 'RO126' },
		{ code: 'RO2', libelle: 'RO2' },
		{ code: 'RO21', libelle: 'RO21' },
		{ code: 'RO211', libelle: 'RO211' },
		{ code: 'RO212', libelle: 'RO212' },
		{ code: 'RO213', libelle: 'RO213' },
		{ code: 'RO214', libelle: 'RO214' },
		{ code: 'RO215', libelle: 'RO215' },
		{ code: 'RO216', libelle: 'RO216' },
		{ code: 'RO22', libelle: 'RO22' },
		{ code: 'RO221', libelle: 'RO221' },
		{ code: 'RO222', libelle: 'RO222' },
		{ code: 'RO223', libelle: 'RO223' },
		{ code: 'RO224', libelle: 'RO224' },
		{ code: 'RO225', libelle: 'RO225' },
		{ code: 'RO226', libelle: 'RO226' },
		{ code: 'RO3', libelle: 'RO3' },
		{ code: 'RO31', libelle: 'RO31' },
		{ code: 'RO311', libelle: 'RO311' },
		{ code: 'RO312', libelle: 'RO312' },
		{ code: 'RO313', libelle: 'RO313' },
		{ code: 'RO314', libelle: 'RO314' },
		{ code: 'RO315', libelle: 'RO315' },
		{ code: 'RO316', libelle: 'RO316' },
		{ code: 'RO317', libelle: 'RO317' },
		{ code: 'RO32', libelle: 'RO32' },
		{ code: 'RO321', libelle: 'RO321' },
		{ code: 'RO322', libelle: 'RO322' },
		{ code: 'RO4', libelle: 'RO4' },
		{ code: 'RO41', libelle: 'RO41' },
		{ code: 'RO411', libelle: 'RO411' },
		{ code: 'RO412', libelle: 'RO412' },
		{ code: 'RO413', libelle: 'RO413' },
		{ code: 'RO414', libelle: 'RO414' },
		{ code: 'RO415', libelle: 'RO415' },
		{ code: 'RO42', libelle: 'RO42' },
		{ code: 'RO421', libelle: 'RO421' },
		{ code: 'RO422', libelle: 'RO422' },
		{ code: 'RO423', libelle: 'RO423' },
		{ code: 'RO424', libelle: 'RO424' },
		{ code: 'ROZ', libelle: 'ROZ' },
		{ code: 'ROZZ', libelle: 'ROZZ' },
		{ code: 'ROZZZ', libelle: 'ROZZZ' },
		{ code: 'SI', libelle: 'SI' },
		{ code: 'SI0', libelle: 'SI0' },
		{ code: 'SI03', libelle: 'SI03' },
		{ code: 'SI031', libelle: 'SI031' },
		{ code: 'SI032', libelle: 'SI032' },
		{ code: 'SI033', libelle: 'SI033' },
		{ code: 'SI034', libelle: 'SI034' },
		{ code: 'SI035', libelle: 'SI035' },
		{ code: 'SI036', libelle: 'SI036' },
		{ code: 'SI037', libelle: 'SI037' },
		{ code: 'SI038', libelle: 'SI038' },
		{ code: 'SI04', libelle: 'SI04' },
		{ code: 'SI041', libelle: 'SI041' },
		{ code: 'SI042', libelle: 'SI042' },
		{ code: 'SI043', libelle: 'SI043' },
		{ code: 'SI044', libelle: 'SI044' },
		{ code: 'SIZ', libelle: 'SIZ' },
		{ code: 'SIZZ', libelle: 'SIZZ' },
		{ code: 'SIZZZ', libelle: 'SIZZZ' },
		{ code: 'SK', libelle: 'SK' },
		{ code: 'SK0', libelle: 'SK0' },
		{ code: 'SK01', libelle: 'SK01' },
		{ code: 'SK010', libelle: 'SK010' },
		{ code: 'SK02', libelle: 'SK02' },
		{ code: 'SK021', libelle: 'SK021' },
		{ code: 'SK022', libelle: 'SK022' },
		{ code: 'SK023', libelle: 'SK023' },
		{ code: 'SK03', libelle: 'SK03' },
		{ code: 'SK031', libelle: 'SK031' },
		{ code: 'SK032', libelle: 'SK032' },
		{ code: 'SK04', libelle: 'SK04' },
		{ code: 'SK041', libelle: 'SK041' },
		{ code: 'SK042', libelle: 'SK042' },
		{ code: 'SKZ', libelle: 'SKZ' },
		{ code: 'SKZZ', libelle: 'SKZZ' },
		{ code: 'SKZZZ', libelle: 'SKZZZ' },
		{ code: 'FI', libelle: 'FI' },
		{ code: 'FI1', libelle: 'FI1' },
		{ code: 'FI19', libelle: 'FI19' },
		{ code: 'FI193', libelle: 'FI193' },
		{ code: 'FI194', libelle: 'FI194' },
		{ code: 'FI195', libelle: 'FI195' },
		{ code: 'FI196', libelle: 'FI196' },
		{ code: 'FI197', libelle: 'FI197' },
		{ code: 'FI1B', libelle: 'FI1B' },
		{ code: 'FI1B1', libelle: 'FI1B1' },
		{ code: 'FI1C', libelle: 'FI1C' },
		{ code: 'FI1C1', libelle: 'FI1C1' },
		{ code: 'FI1C2', libelle: 'FI1C2' },
		{ code: 'FI1C3', libelle: 'FI1C3' },
		{ code: 'FI1C4', libelle: 'FI1C4' },
		{ code: 'FI1C5', libelle: 'FI1C5' },
		{ code: 'FI1D', libelle: 'FI1D' },
		{ code: 'FI1D1', libelle: 'FI1D1' },
		{ code: 'FI1D2', libelle: 'FI1D2' },
		{ code: 'FI1D3', libelle: 'FI1D3' },
		{ code: 'FI1D5', libelle: 'FI1D5' },
		{ code: 'FI1D7', libelle: 'FI1D7' },
		{ code: 'FI1D8', libelle: 'FI1D8' },
		{ code: 'FI1D9', libelle: 'FI1D9' },
		{ code: 'FI2', libelle: 'FI2' },
		{ code: 'FI20', libelle: 'FI20' },
		{ code: 'FI200', libelle: 'FI200' },
		{ code: 'FIZ', libelle: 'FIZ' },
		{ code: 'FIZZ', libelle: 'FIZZ' },
		{ code: 'FIZZZ', libelle: 'FIZZZ' },
		{ code: 'SE', libelle: 'SE' },
		{ code: 'SE1', libelle: 'SE1' },
		{ code: 'SE11', libelle: 'SE11' },
		{ code: 'SE110', libelle: 'SE110' },
		{ code: 'SE12', libelle: 'SE12' },
		{ code: 'SE121', libelle: 'SE121' },
		{ code: 'SE122', libelle: 'SE122' },
		{ code: 'SE123', libelle: 'SE123' },
		{ code: 'SE124', libelle: 'SE124' },
		{ code: 'SE125', libelle: 'SE125' },
		{ code: 'SE2', libelle: 'SE2' },
		{ code: 'SE21', libelle: 'SE21' },
		{ code: 'SE211', libelle: 'SE211' },
		{ code: 'SE212', libelle: 'SE212' },
		{ code: 'SE213', libelle: 'SE213' },
		{ code: 'SE214', libelle: 'SE214' },
		{ code: 'SE22', libelle: 'SE22' },
		{ code: 'SE221', libelle: 'SE221' },
		{ code: 'SE224', libelle: 'SE224' },
		{ code: 'SE23', libelle: 'SE23' },
		{ code: 'SE231', libelle: 'SE231' },
		{ code: 'SE232', libelle: 'SE232' },
		{ code: 'SE3', libelle: 'SE3' },
		{ code: 'SE31', libelle: 'SE31' },
		{ code: 'SE311', libelle: 'SE311' },
		{ code: 'SE312', libelle: 'SE312' },
		{ code: 'SE313', libelle: 'SE313' },
		{ code: 'SE32', libelle: 'SE32' },
		{ code: 'SE321', libelle: 'SE321' },
		{ code: 'SE322', libelle: 'SE322' },
		{ code: 'SE33', libelle: 'SE33' },
		{ code: 'SE331', libelle: 'SE331' },
		{ code: 'SE332', libelle: 'SE332' },
		{ code: 'SEZ', libelle: 'SEZ' },
		{ code: 'SEZZ', libelle: 'SEZZ' },
		{ code: 'SEZZZ', libelle: 'SEZZZ' },
		{ code: 'UK', libelle: 'UK' },
		{ code: 'UKC', libelle: 'UKC' },
		{ code: 'UKC1', libelle: 'UKC1' },
		{ code: 'UKC11', libelle: 'UKC11' },
		{ code: 'UKC12', libelle: 'UKC12' },
		{ code: 'UKC13', libelle: 'UKC13' },
		{ code: 'UKC14', libelle: 'UKC14' },
		{ code: 'UKC2', libelle: 'UKC2' },
		{ code: 'UKC21', libelle: 'UKC21' },
		{ code: 'UKC22', libelle: 'UKC22' },
		{ code: 'UKC23', libelle: 'UKC23' },
		{ code: 'UKD', libelle: 'UKD' },
		{ code: 'UKD1', libelle: 'UKD1' },
		{ code: 'UKD11', libelle: 'UKD11' },
		{ code: 'UKD12', libelle: 'UKD12' },
		{ code: 'UKD3', libelle: 'UKD3' },
		{ code: 'UKD33', libelle: 'UKD33' },
		{ code: 'UKD34', libelle: 'UKD34' },
		{ code: 'UKD35', libelle: 'UKD35' },
		{ code: 'UKD36', libelle: 'UKD36' },
		{ code: 'UKD37', libelle: 'UKD37' },
		{ code: 'UKD4', libelle: 'UKD4' },
		{ code: 'UKD41', libelle: 'UKD41' },
		{ code: 'UKD42', libelle: 'UKD42' },
		{ code: 'UKD44', libelle: 'UKD44' },
		{ code: 'UKD45', libelle: 'UKD45' },
		{ code: 'UKD46', libelle: 'UKD46' },
		{ code: 'UKD47', libelle: 'UKD47' },
		{ code: 'UKD6', libelle: 'UKD6' },
		{ code: 'UKD61', libelle: 'UKD61' },
		{ code: 'UKD62', libelle: 'UKD62' },
		{ code: 'UKD63', libelle: 'UKD63' },
		{ code: 'UKD7', libelle: 'UKD7' },
		{ code: 'UKD71', libelle: 'UKD71' },
		{ code: 'UKD72', libelle: 'UKD72' },
		{ code: 'UKD73', libelle: 'UKD73' },
		{ code: 'UKD74', libelle: 'UKD74' },
		{ code: 'UKE', libelle: 'UKE' },
		{ code: 'UKE1', libelle: 'UKE1' },
		{ code: 'UKE11', libelle: 'UKE11' },
		{ code: 'UKE12', libelle: 'UKE12' },
		{ code: 'UKE13', libelle: 'UKE13' },
		{ code: 'UKE2', libelle: 'UKE2' },
		{ code: 'UKE21', libelle: 'UKE21' },
		{ code: 'UKE22', libelle: 'UKE22' },
		{ code: 'UKE3', libelle: 'UKE3' },
		{ code: 'UKE31', libelle: 'UKE31' },
		{ code: 'UKE32', libelle: 'UKE32' },
		{ code: 'UKE4', libelle: 'UKE4' },
		{ code: 'UKE41', libelle: 'UKE41' },
		{ code: 'UKE42', libelle: 'UKE42' },
		{ code: 'UKE44', libelle: 'UKE44' },
		{ code: 'UKE45', libelle: 'UKE45' },
		{ code: 'UKF', libelle: 'UKF' },
		{ code: 'UKF1', libelle: 'UKF1' },
		{ code: 'UKF11', libelle: 'UKF11' },
		{ code: 'UKF12', libelle: 'UKF12' },
		{ code: 'UKF13', libelle: 'UKF13' },
		{ code: 'UKF14', libelle: 'UKF14' },
		{ code: 'UKF15', libelle: 'UKF15' },
		{ code: 'UKF16', libelle: 'UKF16' },
		{ code: 'UKF2', libelle: 'UKF2' },
		{ code: 'UKF21', libelle: 'UKF21' },
		{ code: 'UKF22', libelle: 'UKF22' },
		{ code: 'UKF24', libelle: 'UKF24' },
		{ code: 'UKF25', libelle: 'UKF25' },
		{ code: 'UKF3', libelle: 'UKF3' },
		{ code: 'UKF30', libelle: 'UKF30' },
		{ code: 'UKG', libelle: 'UKG' },
		{ code: 'UKG1', libelle: 'UKG1' },
		{ code: 'UKG11', libelle: 'UKG11' },
		{ code: 'UKG12', libelle: 'UKG12' },
		{ code: 'UKG13', libelle: 'UKG13' },
		{ code: 'UKG2', libelle: 'UKG2' },
		{ code: 'UKG21', libelle: 'UKG21' },
		{ code: 'UKG22', libelle: 'UKG22' },
		{ code: 'UKG23', libelle: 'UKG23' },
		{ code: 'UKG24', libelle: 'UKG24' },
		{ code: 'UKG3', libelle: 'UKG3' },
		{ code: 'UKG31', libelle: 'UKG31' },
		{ code: 'UKG32', libelle: 'UKG32' },
		{ code: 'UKG33', libelle: 'UKG33' },
		{ code: 'UKG36', libelle: 'UKG36' },
		{ code: 'UKG37', libelle: 'UKG37' },
		{ code: 'UKG38', libelle: 'UKG38' },
		{ code: 'UKG39', libelle: 'UKG39' },
		{ code: 'UKH', libelle: 'UKH' },
		{ code: 'UKH1', libelle: 'UKH1' },
		{ code: 'UKH11', libelle: 'UKH11' },
		{ code: 'UKH12', libelle: 'UKH12' },
		{ code: 'UKH14', libelle: 'UKH14' },
		{ code: 'UKH15', libelle: 'UKH15' },
		{ code: 'UKH16', libelle: 'UKH16' },
		{ code: 'UKH17', libelle: 'UKH17' },
		{ code: 'UKH2', libelle: 'UKH2' },
		{ code: 'UKH21', libelle: 'UKH21' },
		{ code: 'UKH23', libelle: 'UKH23' },
		{ code: 'UKH24', libelle: 'UKH24' },
		{ code: 'UKH25', libelle: 'UKH25' },
		{ code: 'UKH3', libelle: 'UKH3' },
		{ code: 'UKH31', libelle: 'UKH31' },
		{ code: 'UKH32', libelle: 'UKH32' },
		{ code: 'UKH34', libelle: 'UKH34' },
		{ code: 'UKH35', libelle: 'UKH35' },
		{ code: 'UKH36', libelle: 'UKH36' },
		{ code: 'UKH37', libelle: 'UKH37' },
		{ code: 'UKI', libelle: 'UKI' },
		{ code: 'UKI3', libelle: 'UKI3' },
		{ code: 'UKI31', libelle: 'UKI31' },
		{ code: 'UKI32', libelle: 'UKI32' },
		{ code: 'UKI33', libelle: 'UKI33' },
		{ code: 'UKI34', libelle: 'UKI34' },
		{ code: 'UKI4', libelle: 'UKI4' },
		{ code: 'UKI41', libelle: 'UKI41' },
		{ code: 'UKI42', libelle: 'UKI42' },
		{ code: 'UKI43', libelle: 'UKI43' },
		{ code: 'UKI44', libelle: 'UKI44' },
		{ code: 'UKI45', libelle: 'UKI45' },
		{ code: 'UKI5', libelle: 'UKI5' },
		{ code: 'UKI51', libelle: 'UKI51' },
		{ code: 'UKI52', libelle: 'UKI52' },
		{ code: 'UKI53', libelle: 'UKI53' },
		{ code: 'UKI54', libelle: 'UKI54' },
		{ code: 'UKI6', libelle: 'UKI6' },
		{ code: 'UKI61', libelle: 'UKI61' },
		{ code: 'UKI62', libelle: 'UKI62' },
		{ code: 'UKI63', libelle: 'UKI63' },
		{ code: 'UKI7', libelle: 'UKI7' },
		{ code: 'UKI71', libelle: 'UKI71' },
		{ code: 'UKI72', libelle: 'UKI72' },
		{ code: 'UKI73', libelle: 'UKI73' },
		{ code: 'UKI74', libelle: 'UKI74' },
		{ code: 'UKI75', libelle: 'UKI75' },
		{ code: 'UKJ', libelle: 'UKJ' },
		{ code: 'UKJ1', libelle: 'UKJ1' },
		{ code: 'UKJ11', libelle: 'UKJ11' },
		{ code: 'UKJ12', libelle: 'UKJ12' },
		{ code: 'UKJ13', libelle: 'UKJ13' },
		{ code: 'UKJ14', libelle: 'UKJ14' },
		{ code: 'UKJ2', libelle: 'UKJ2' },
		{ code: 'UKJ21', libelle: 'UKJ21' },
		{ code: 'UKJ22', libelle: 'UKJ22' },
		{ code: 'UKJ25', libelle: 'UKJ25' },
		{ code: 'UKJ26', libelle: 'UKJ26' },
		{ code: 'UKJ27', libelle: 'UKJ27' },
		{ code: 'UKJ28', libelle: 'UKJ28' },
		{ code: 'UKJ3', libelle: 'UKJ3' },
		{ code: 'UKJ31', libelle: 'UKJ31' },
		{ code: 'UKJ32', libelle: 'UKJ32' },
		{ code: 'UKJ34', libelle: 'UKJ34' },
		{ code: 'UKJ35', libelle: 'UKJ35' },
		{ code: 'UKJ36', libelle: 'UKJ36' },
		{ code: 'UKJ37', libelle: 'UKJ37' },
		{ code: 'UKJ4', libelle: 'UKJ4' },
		{ code: 'UKJ41', libelle: 'UKJ41' },
		{ code: 'UKJ43', libelle: 'UKJ43' },
		{ code: 'UKJ44', libelle: 'UKJ44' },
		{ code: 'UKJ45', libelle: 'UKJ45' },
		{ code: 'UKJ46', libelle: 'UKJ46' },
		{ code: 'UKK', libelle: 'UKK' },
		{ code: 'UKK1', libelle: 'UKK1' },
		{ code: 'UKK11', libelle: 'UKK11' },
		{ code: 'UKK12', libelle: 'UKK12' },
		{ code: 'UKK13', libelle: 'UKK13' },
		{ code: 'UKK14', libelle: 'UKK14' },
		{ code: 'UKK15', libelle: 'UKK15' },
		{ code: 'UKK2', libelle: 'UKK2' },
		{ code: 'UKK23', libelle: 'UKK23' },
		{ code: 'UKK24', libelle: 'UKK24' },
		{ code: 'UKK25', libelle: 'UKK25' },
		{ code: 'UKK3', libelle: 'UKK3' },
		{ code: 'UKK30', libelle: 'UKK30' },
		{ code: 'UKK4', libelle: 'UKK4' },
		{ code: 'UKK41', libelle: 'UKK41' },
		{ code: 'UKK42', libelle: 'UKK42' },
		{ code: 'UKK43', libelle: 'UKK43' },
		{ code: 'UKL', libelle: 'UKL' },
		{ code: 'UKL1', libelle: 'UKL1' },
		{ code: 'UKL11', libelle: 'UKL11' },
		{ code: 'UKL12', libelle: 'UKL12' },
		{ code: 'UKL13', libelle: 'UKL13' },
		{ code: 'UKL14', libelle: 'UKL14' },
		{ code: 'UKL15', libelle: 'UKL15' },
		{ code: 'UKL16', libelle: 'UKL16' },
		{ code: 'UKL17', libelle: 'UKL17' },
		{ code: 'UKL18', libelle: 'UKL18' },
		{ code: 'UKL2', libelle: 'UKL2' },
		{ code: 'UKL21', libelle: 'UKL21' },
		{ code: 'UKL22', libelle: 'UKL22' },
		{ code: 'UKL23', libelle: 'UKL23' },
		{ code: 'UKL24', libelle: 'UKL24' },
		{ code: 'UKM', libelle: 'UKM' },
		{ code: 'UKM5', libelle: 'UKM5' },
		{ code: 'UKM50', libelle: 'UKM50' },
		{ code: 'UKM6', libelle: 'UKM6' },
		{ code: 'UKM61', libelle: 'UKM61' },
		{ code: 'UKM62', libelle: 'UKM62' },
		{ code: 'UKM63', libelle: 'UKM63' },
		{ code: 'UKM64', libelle: 'UKM64' },
		{ code: 'UKM65', libelle: 'UKM65' },
		{ code: 'UKM66', libelle: 'UKM66' },
		{ code: 'UKM7', libelle: 'UKM7' },
		{ code: 'UKM71', libelle: 'UKM71' },
		{ code: 'UKM72', libelle: 'UKM72' },
		{ code: 'UKM73', libelle: 'UKM73' },
		{ code: 'UKM75', libelle: 'UKM75' },
		{ code: 'UKM76', libelle: 'UKM76' },
		{ code: 'UKM77', libelle: 'UKM77' },
		{ code: 'UKM78', libelle: 'UKM78' },
		{ code: 'UKM8', libelle: 'UKM8' },
		{ code: 'UKM81', libelle: 'UKM81' },
		{ code: 'UKM82', libelle: 'UKM82' },
		{ code: 'UKM83', libelle: 'UKM83' },
		{ code: 'UKM84', libelle: 'UKM84' },
		{ code: 'UKM9', libelle: 'UKM9' },
		{ code: 'UKM91', libelle: 'UKM91' },
		{ code: 'UKM92', libelle: 'UKM92' },
		{ code: 'UKM93', libelle: 'UKM93' },
		{ code: 'UKM94', libelle: 'UKM94' },
		{ code: 'UKM95', libelle: 'UKM95' },
		{ code: 'UKN', libelle: 'UKN' },
		{ code: 'UKN0', libelle: 'UKN0' },
		{ code: 'UKN06', libelle: 'UKN06' },
		{ code: 'UKN07', libelle: 'UKN07' },
		{ code: 'UKN08', libelle: 'UKN08' },
		{ code: 'UKN09', libelle: 'UKN09' },
		{ code: 'UKN0A', libelle: 'UKN0A' },
		{ code: 'UKN0B', libelle: 'UKN0B' },
		{ code: 'UKN0C', libelle: 'UKN0C' },
		{ code: 'UKN0D', libelle: 'UKN0D' },
		{ code: 'UKN0E', libelle: 'UKN0E' },
		{ code: 'UKN0F', libelle: 'UKN0F' },
		{ code: 'UKN0G', libelle: 'UKN0G' },
		{ code: 'UKZ', libelle: 'UKZ' },
		{ code: 'UKZZ', libelle: 'UKZZ' },
		{ code: 'UKZZZ', libelle: 'UKZZZ' },
		{ code: 'IS', libelle: 'IS' },
		{ code: 'IS0', libelle: 'IS0' },
		{ code: 'IS00', libelle: 'IS00' },
		{ code: 'IS001', libelle: 'IS001' },
		{ code: 'IS002', libelle: 'IS002' },
		{ code: 'ISZ', libelle: 'ISZ' },
		{ code: 'ISZZ', libelle: 'ISZZ' },
		{ code: 'ISZZZ', libelle: 'ISZZZ' },
		{ code: 'LI', libelle: 'LI' },
		{ code: 'LI0', libelle: 'LI0' },
		{ code: 'LI00', libelle: 'LI00' },
		{ code: 'LI000', libelle: 'LI000' },
		{ code: 'LIZ', libelle: 'LIZ' },
		{ code: 'LIZZ', libelle: 'LIZZ' },
		{ code: 'LIZZZ', libelle: 'LIZZZ' },
		{ code: 'NO', libelle: 'NO' },
		{ code: 'NO0', libelle: 'NO0' },
		{ code: 'NO02', libelle: 'NO02' },
		{ code: 'NO020', libelle: 'NO020' },
		{ code: 'NO06', libelle: 'NO06' },
		{ code: 'NO060', libelle: 'NO060' },
		{ code: 'NO07', libelle: 'NO07' },
		{ code: 'NO071', libelle: 'NO071' },
		{ code: 'NO074', libelle: 'NO074' },
		{ code: 'NO08', libelle: 'NO08' },
		{ code: 'NO081', libelle: 'NO081' },
		{ code: 'NO082', libelle: 'NO082' },
		{ code: 'NO09', libelle: 'NO09' },
		{ code: 'NO091', libelle: 'NO091' },
		{ code: 'NO092', libelle: 'NO092' },
		{ code: 'NO0A', libelle: 'NO0A' },
		{ code: 'NO0A1', libelle: 'NO0A1' },
		{ code: 'NO0A2', libelle: 'NO0A2' },
		{ code: 'NO0A3', libelle: 'NO0A3' },
		{ code: 'NO0B', libelle: 'NO0B' },
		{ code: 'NO0B1', libelle: 'NO0B1' },
		{ code: 'NO0B2', libelle: 'NO0B2' },
		{ code: 'NOZ', libelle: 'NOZ' },
		{ code: 'NOZZ', libelle: 'NOZZ' },
		{ code: 'NOZZZ', libelle: 'NOZZZ' },
		{ code: 'CH', libelle: 'CH' },
		{ code: 'CH0', libelle: 'CH0' },
		{ code: 'CH01', libelle: 'CH01' },
		{ code: 'CH011', libelle: 'CH011' },
		{ code: 'CH012', libelle: 'CH012' },
		{ code: 'CH013', libelle: 'CH013' },
		{ code: 'CH02', libelle: 'CH02' },
		{ code: 'CH021', libelle: 'CH021' },
		{ code: 'CH022', libelle: 'CH022' },
		{ code: 'CH023', libelle: 'CH023' },
		{ code: 'CH024', libelle: 'CH024' },
		{ code: 'CH025', libelle: 'CH025' },
		{ code: 'CH03', libelle: 'CH03' },
		{ code: 'CH031', libelle: 'CH031' },
		{ code: 'CH032', libelle: 'CH032' },
		{ code: 'CH033', libelle: 'CH033' },
		{ code: 'CH04', libelle: 'CH04' },
		{ code: 'CH040', libelle: 'CH040' },
		{ code: 'CH05', libelle: 'CH05' },
		{ code: 'CH051', libelle: 'CH051' },
		{ code: 'CH052', libelle: 'CH052' },
		{ code: 'CH053', libelle: 'CH053' },
		{ code: 'CH054', libelle: 'CH054' },
		{ code: 'CH055', libelle: 'CH055' },
		{ code: 'CH056', libelle: 'CH056' },
		{ code: 'CH057', libelle: 'CH057' },
		{ code: 'CH06', libelle: 'CH06' },
		{ code: 'CH061', libelle: 'CH061' },
		{ code: 'CH062', libelle: 'CH062' },
		{ code: 'CH063', libelle: 'CH063' },
		{ code: 'CH064', libelle: 'CH064' },
		{ code: 'CH065', libelle: 'CH065' },
		{ code: 'CH066', libelle: 'CH066' },
		{ code: 'CH07', libelle: 'CH07' },
		{ code: 'CH070', libelle: 'CH070' },
		{ code: 'CHZ', libelle: 'CHZ' },
		{ code: 'CHZZ', libelle: 'CHZZ' },
		{ code: 'CHZZZ', libelle: 'CHZZZ' },
		{ code: 'ME', libelle: 'ME' },
		{ code: 'ME0', libelle: 'ME0' },
		{ code: 'ME00', libelle: 'ME00' },
		{ code: 'ME000', libelle: 'ME000' },
		{ code: 'MEZ', libelle: 'MEZ' },
		{ code: 'MEZZ', libelle: 'MEZZ' },
		{ code: 'MEZZZ', libelle: 'MEZZZ' },
		{ code: 'MK', libelle: 'MK' },
		{ code: 'MK0', libelle: 'MK0' },
		{ code: 'MK00', libelle: 'MK00' },
		{ code: 'MK001', libelle: 'MK001' },
		{ code: 'MK002', libelle: 'MK002' },
		{ code: 'MK003', libelle: 'MK003' },
		{ code: 'MK004', libelle: 'MK004' },
		{ code: 'MK005', libelle: 'MK005' },
		{ code: 'MK006', libelle: 'MK006' },
		{ code: 'MK007', libelle: 'MK007' },
		{ code: 'MK008', libelle: 'MK008' },
		{ code: 'MKZ', libelle: 'MKZ' },
		{ code: 'MKZZ', libelle: 'MKZZ' },
		{ code: 'MKZZZ', libelle: 'MKZZZ' },
		{ code: 'AL', libelle: 'AL' },
		{ code: 'AL0', libelle: 'AL0' },
		{ code: 'AL01', libelle: 'AL01' },
		{ code: 'AL011', libelle: 'AL011' },
		{ code: 'AL012', libelle: 'AL012' },
		{ code: 'AL013', libelle: 'AL013' },
		{ code: 'AL014', libelle: 'AL014' },
		{ code: 'AL015', libelle: 'AL015' },
		{ code: 'AL02', libelle: 'AL02' },
		{ code: 'AL021', libelle: 'AL021' },
		{ code: 'AL022', libelle: 'AL022' },
		{ code: 'AL03', libelle: 'AL03' },
		{ code: 'AL031', libelle: 'AL031' },
		{ code: 'AL032', libelle: 'AL032' },
		{ code: 'AL033', libelle: 'AL033' },
		{ code: 'AL034', libelle: 'AL034' },
		{ code: 'AL035', libelle: 'AL035' },
		{ code: 'ALZ', libelle: 'ALZ' },
		{ code: 'ALZZ', libelle: 'ALZZ' },
		{ code: 'ALZZZ', libelle: 'ALZZZ' },
		{ code: 'RS', libelle: 'RS' },
		{ code: 'RS1', libelle: 'RS1' },
		{ code: 'RS11', libelle: 'RS11' },
		{ code: 'RS110', libelle: 'RS110' },
		{ code: 'RS12', libelle: 'RS12' },
		{ code: 'RS121', libelle: 'RS121' },
		{ code: 'RS122', libelle: 'RS122' },
		{ code: 'RS123', libelle: 'RS123' },
		{ code: 'RS124', libelle: 'RS124' },
		{ code: 'RS125', libelle: 'RS125' },
		{ code: 'RS126', libelle: 'RS126' },
		{ code: 'RS127', libelle: 'RS127' },
		{ code: 'RS2', libelle: 'RS2' },
		{ code: 'RS21', libelle: 'RS21' },
		{ code: 'RS211', libelle: 'RS211' },
		{ code: 'RS212', libelle: 'RS212' },
		{ code: 'RS213', libelle: 'RS213' },
		{ code: 'RS214', libelle: 'RS214' },
		{ code: 'RS215', libelle: 'RS215' },
		{ code: 'RS216', libelle: 'RS216' },
		{ code: 'RS217', libelle: 'RS217' },
		{ code: 'RS218', libelle: 'RS218' },
		{ code: 'RS22', libelle: 'RS22' },
		{ code: 'RS221', libelle: 'RS221' },
		{ code: 'RS222', libelle: 'RS222' },
		{ code: 'RS223', libelle: 'RS223' },
		{ code: 'RS224', libelle: 'RS224' },
		{ code: 'RS225', libelle: 'RS225' },
		{ code: 'RS226', libelle: 'RS226' },
		{ code: 'RS227', libelle: 'RS227' },
		{ code: 'RS228', libelle: 'RS228' },
		{ code: 'RS229', libelle: 'RS229' },
		{ code: 'RSZ', libelle: 'RSZ' },
		{ code: 'RSZZ', libelle: 'RSZZ' },
		{ code: 'RSZZZ', libelle: 'RSZZZ' },
		{ code: 'TR', libelle: 'TR' },
		{ code: 'TR1', libelle: 'TR1' },
		{ code: 'TR10', libelle: 'TR10' },
		{ code: 'TR100', libelle: 'TR100' },
		{ code: 'TR2', libelle: 'TR2' },
		{ code: 'TR21', libelle: 'TR21' },
		{ code: 'TR211', libelle: 'TR211' },
		{ code: 'TR212', libelle: 'TR212' },
		{ code: 'TR213', libelle: 'TR213' },
		{ code: 'TR22', libelle: 'TR22' },
		{ code: 'TR221', libelle: 'TR221' },
		{ code: 'TR222', libelle: 'TR222' },
		{ code: 'TR3', libelle: 'TR3' },
		{ code: 'TR31', libelle: 'TR31' },
		{ code: 'TR310', libelle: 'TR310' },
		{ code: 'TR32', libelle: 'TR32' },
		{ code: 'TR321', libelle: 'TR321' },
		{ code: 'TR322', libelle: 'TR322' },
		{ code: 'TR323', libelle: 'TR323' },
		{ code: 'TR33', libelle: 'TR33' },
		{ code: 'TR331', libelle: 'TR331' },
		{ code: 'TR332', libelle: 'TR332' },
		{ code: 'TR333', libelle: 'TR333' },
		{ code: 'TR334', libelle: 'TR334' },
		{ code: 'TR4', libelle: 'TR4' },
		{ code: 'TR41', libelle: 'TR41' },
		{ code: 'TR411', libelle: 'TR411' },
		{ code: 'TR412', libelle: 'TR412' },
		{ code: 'TR413', libelle: 'TR413' },
		{ code: 'TR42', libelle: 'TR42' },
		{ code: 'TR421', libelle: 'TR421' },
		{ code: 'TR422', libelle: 'TR422' },
		{ code: 'TR423', libelle: 'TR423' },
		{ code: 'TR424', libelle: 'TR424' },
		{ code: 'TR425', libelle: 'TR425' },
		{ code: 'TR5', libelle: 'TR5' },
		{ code: 'TR51', libelle: 'TR51' },
		{ code: 'TR510', libelle: 'TR510' },
		{ code: 'TR52', libelle: 'TR52' },
		{ code: 'TR521', libelle: 'TR521' },
		{ code: 'TR522', libelle: 'TR522' },
		{ code: 'TR6', libelle: 'TR6' },
		{ code: 'TR61', libelle: 'TR61' },
		{ code: 'TR611', libelle: 'TR611' },
		{ code: 'TR612', libelle: 'TR612' },
		{ code: 'TR613', libelle: 'TR613' },
		{ code: 'TR62', libelle: 'TR62' },
		{ code: 'TR621', libelle: 'TR621' },
		{ code: 'TR622', libelle: 'TR622' },
		{ code: 'TR63', libelle: 'TR63' },
		{ code: 'TR631', libelle: 'TR631' },
		{ code: 'TR632', libelle: 'TR632' },
		{ code: 'TR633', libelle: 'TR633' },
		{ code: 'TR7', libelle: 'TR7' },
		{ code: 'TR71', libelle: 'TR71' },
		{ code: 'TR711', libelle: 'TR711' },
		{ code: 'TR712', libelle: 'TR712' },
		{ code: 'TR713', libelle: 'TR713' },
		{ code: 'TR714', libelle: 'TR714' },
		{ code: 'TR715', libelle: 'TR715' },
		{ code: 'TR72', libelle: 'TR72' },
		{ code: 'TR721', libelle: 'TR721' },
		{ code: 'TR722', libelle: 'TR722' },
		{ code: 'TR723', libelle: 'TR723' },
		{ code: 'TR8', libelle: 'TR8' },
		{ code: 'TR81', libelle: 'TR81' },
		{ code: 'TR811', libelle: 'TR811' },
		{ code: 'TR812', libelle: 'TR812' },
		{ code: 'TR813', libelle: 'TR813' },
		{ code: 'TR82', libelle: 'TR82' },
		{ code: 'TR821', libelle: 'TR821' },
		{ code: 'TR822', libelle: 'TR822' },
		{ code: 'TR823', libelle: 'TR823' },
		{ code: 'TR83', libelle: 'TR83' },
		{ code: 'TR831', libelle: 'TR831' },
		{ code: 'TR832', libelle: 'TR832' },
		{ code: 'TR833', libelle: 'TR833' },
		{ code: 'TR834', libelle: 'TR834' },
		{ code: 'TR9', libelle: 'TR9' },
		{ code: 'TR90', libelle: 'TR90' },
		{ code: 'TR901', libelle: 'TR901' },
		{ code: 'TR902', libelle: 'TR902' },
		{ code: 'TR903', libelle: 'TR903' },
		{ code: 'TR904', libelle: 'TR904' },
		{ code: 'TR905', libelle: 'TR905' },
		{ code: 'TR906', libelle: 'TR906' },
		{ code: 'TRA', libelle: 'TRA' },
		{ code: 'TRA1', libelle: 'TRA1' },
		{ code: 'TRA11', libelle: 'TRA11' },
		{ code: 'TRA12', libelle: 'TRA12' },
		{ code: 'TRA13', libelle: 'TRA13' },
		{ code: 'TRA2', libelle: 'TRA2' },
		{ code: 'TRA21', libelle: 'TRA21' },
		{ code: 'TRA22', libelle: 'TRA22' },
		{ code: 'TRA23', libelle: 'TRA23' },
		{ code: 'TRA24', libelle: 'TRA24' },
		{ code: 'TRB', libelle: 'TRB' },
		{ code: 'TRB1', libelle: 'TRB1' },
		{ code: 'TRB11', libelle: 'TRB11' },
		{ code: 'TRB12', libelle: 'TRB12' },
		{ code: 'TRB13', libelle: 'TRB13' },
		{ code: 'TRB14', libelle: 'TRB14' },
		{ code: 'TRB2', libelle: 'TRB2' },
		{ code: 'TRB21', libelle: 'TRB21' },
		{ code: 'TRB22', libelle: 'TRB22' },
		{ code: 'TRB23', libelle: 'TRB23' },
		{ code: 'TRB24', libelle: 'TRB24' },
		{ code: 'TRC', libelle: 'TRC' },
		{ code: 'TRC1', libelle: 'TRC1' },
		{ code: 'TRC11', libelle: 'TRC11' },
		{ code: 'TRC12', libelle: 'TRC12' },
		{ code: 'TRC13', libelle: 'TRC13' },
		{ code: 'TRC2', libelle: 'TRC2' },
		{ code: 'TRC21', libelle: 'TRC21' },
		{ code: 'TRC22', libelle: 'TRC22' },
		{ code: 'TRC3', libelle: 'TRC3' },
		{ code: 'TRC31', libelle: 'TRC31' },
		{ code: 'TRC32', libelle: 'TRC32' },
		{ code: 'TRC33', libelle: 'TRC33' },
		{ code: 'TRC34', libelle: 'TRC34' },
		{ code: 'TRZ', libelle: 'TRZ' },
		{ code: 'TRZZ', libelle: 'TRZZ' },
		{ code: 'TRZZZ', libelle: 'TRZZZ' },
		{ code: '1A', libelle: '1A' },
		{ code: 'AD', libelle: 'AD' },
		{ code: 'AE', libelle: 'AE' },
		{ code: 'AF', libelle: 'AF' },
		{ code: 'AG', libelle: 'AG' },
		{ code: 'AI', libelle: 'AI' },
		{ code: 'AM', libelle: 'AM' },
		{ code: 'AO', libelle: 'AO' },
		{ code: 'AQ', libelle: 'AQ' },
		{ code: 'AR', libelle: 'AR' },
		{ code: 'AS', libelle: 'AS' },
		{ code: 'AU', libelle: 'AU' },
		{ code: 'AW', libelle: 'AW' },
		{ code: 'AZ', libelle: 'AZ' },
		{ code: 'BA', libelle: 'BA' },
		{ code: 'BB', libelle: 'BB' },
		{ code: 'BD', libelle: 'BD' },
		{ code: 'BF', libelle: 'BF' },
		{ code: 'BH', libelle: 'BH' },
		{ code: 'BI', libelle: 'BI' },
		{ code: 'BJ', libelle: 'BJ' },
		{ code: 'BL', libelle: 'BL' },
		{ code: 'BM', libelle: 'BM' },
		{ code: 'BN', libelle: 'BN' },
		{ code: 'BO', libelle: 'BO' },
		{ code: 'BQ', libelle: 'BQ' },
		{ code: 'BR', libelle: 'BR' },
		{ code: 'BS', libelle: 'BS' },
		{ code: 'BT', libelle: 'BT' },
		{ code: 'BV', libelle: 'BV' },
		{ code: 'BW', libelle: 'BW' },
		{ code: 'BY', libelle: 'BY' },
		{ code: 'BZ', libelle: 'BZ' },
		{ code: 'CA', libelle: 'CA' },
		{ code: 'CC', libelle: 'CC' },
		{ code: 'CD', libelle: 'CD' },
		{ code: 'CF', libelle: 'CF' },
		{ code: 'CG', libelle: 'CG' },
		{ code: 'CI', libelle: 'CI' },
		{ code: 'CK', libelle: 'CK' },
		{ code: 'CL', libelle: 'CL' },
		{ code: 'CM', libelle: 'CM' },
		{ code: 'CN', libelle: 'CN' },
		{ code: 'CO', libelle: 'CO' },
		{ code: 'CP', libelle: 'CP' },
		{ code: 'CR', libelle: 'CR' },
		{ code: 'CU', libelle: 'CU' },
		{ code: 'CV', libelle: 'CV' },
		{ code: 'CW', libelle: 'CW' },
		{ code: 'CX', libelle: 'CX' },
		{ code: 'DJ', libelle: 'DJ' },
		{ code: 'DM', libelle: 'DM' },
		{ code: 'DO', libelle: 'DO' },
		{ code: 'DZ', libelle: 'DZ' },
		{ code: 'EC', libelle: 'EC' },
		{ code: 'EG', libelle: 'EG' },
		{ code: 'EH', libelle: 'EH' },
		{ code: 'ER', libelle: 'ER' },
		{ code: 'ET', libelle: 'ET' },
		{ code: 'FJ', libelle: 'FJ' },
		{ code: 'FK', libelle: 'FK' },
		{ code: 'FM', libelle: 'FM' },
		{ code: 'FO', libelle: 'FO' },
		{ code: 'GA', libelle: 'GA' },
		{ code: 'GD', libelle: 'GD' },
		{ code: 'GE', libelle: 'GE' },
		{ code: 'GG', libelle: 'GG' },
		{ code: 'GH', libelle: 'GH' },
		{ code: 'GL', libelle: 'GL' },
		{ code: 'GM', libelle: 'GM' },
		{ code: 'GN', libelle: 'GN' },
		{ code: 'GQ', libelle: 'GQ' },
		{ code: 'GS', libelle: 'GS' },
		{ code: 'GT', libelle: 'GT' },
		{ code: 'GU', libelle: 'GU' },
		{ code: 'GW', libelle: 'GW' },
		{ code: 'GY', libelle: 'GY' },
		{ code: 'HK', libelle: 'HK' },
		{ code: 'HM', libelle: 'HM' },
		{ code: 'HN', libelle: 'HN' },
		{ code: 'HT', libelle: 'HT' },
		{ code: 'ID', libelle: 'ID' },
		{ code: 'IL', libelle: 'IL' },
		{ code: 'IM', libelle: 'IM' },
		{ code: 'IN', libelle: 'IN' },
		{ code: 'IO', libelle: 'IO' },
		{ code: 'IQ', libelle: 'IQ' },
		{ code: 'IR', libelle: 'IR' },
		{ code: 'JE', libelle: 'JE' },
		{ code: 'JM', libelle: 'JM' },
		{ code: 'JO', libelle: 'JO' },
		{ code: 'JP', libelle: 'JP' },
		{ code: 'KE', libelle: 'KE' },
		{ code: 'KG', libelle: 'KG' },
		{ code: 'KH', libelle: 'KH' },
		{ code: 'KI', libelle: 'KI' },
		{ code: 'KM', libelle: 'KM' },
		{ code: 'KN', libelle: 'KN' },
		{ code: 'KP', libelle: 'KP' },
		{ code: 'KR', libelle: 'KR' },
		{ code: 'KW', libelle: 'KW' },
		{ code: 'KY', libelle: 'KY' },
		{ code: 'KZ', libelle: 'KZ' },
		{ code: 'LA', libelle: 'LA' },
		{ code: 'LB', libelle: 'LB' },
		{ code: 'LC', libelle: 'LC' },
		{ code: 'LK', libelle: 'LK' },
		{ code: 'LR', libelle: 'LR' },
		{ code: 'LS', libelle: 'LS' },
		{ code: 'LY', libelle: 'LY' },
		{ code: 'MA', libelle: 'MA' },
		{ code: 'MC', libelle: 'MC' },
		{ code: 'MD', libelle: 'MD' },
		{ code: 'MG', libelle: 'MG' },
		{ code: 'MH', libelle: 'MH' },
		{ code: 'ML', libelle: 'ML' },
		{ code: 'MM', libelle: 'MM' },
		{ code: 'MN', libelle: 'MN' },
		{ code: 'MO', libelle: 'MO' },
		{ code: 'MP', libelle: 'MP' },
		{ code: 'MR', libelle: 'MR' },
		{ code: 'MS', libelle: 'MS' },
		{ code: 'MU', libelle: 'MU' },
		{ code: 'MV', libelle: 'MV' },
		{ code: 'MW', libelle: 'MW' },
		{ code: 'MX', libelle: 'MX' },
		{ code: 'MY', libelle: 'MY' },
		{ code: 'MZ', libelle: 'MZ' },
		{ code: 'NA', libelle: 'NA' },
		{ code: 'NC', libelle: 'NC' },
		{ code: 'NE', libelle: 'NE' },
		{ code: 'NF', libelle: 'NF' },
		{ code: 'NG', libelle: 'NG' },
		{ code: 'NI', libelle: 'NI' },
		{ code: 'NP', libelle: 'NP' },
		{ code: 'NR', libelle: 'NR' },
		{ code: 'NU', libelle: 'NU' },
		{ code: 'NZ', libelle: 'NZ' },
		{ code: 'OM', libelle: 'OM' },
		{ code: 'PA', libelle: 'PA' },
		{ code: 'PE', libelle: 'PE' },
		{ code: 'PF', libelle: 'PF' },
		{ code: 'PG', libelle: 'PG' },
		{ code: 'PH', libelle: 'PH' },
		{ code: 'PK', libelle: 'PK' },
		{ code: 'PM', libelle: 'PM' },
		{ code: 'PN', libelle: 'PN' },
		{ code: 'PR', libelle: 'PR' },
		{ code: 'PS', libelle: 'PS' },
		{ code: 'PW', libelle: 'PW' },
		{ code: 'PY', libelle: 'PY' },
		{ code: 'QA', libelle: 'QA' },
		{ code: 'RU', libelle: 'RU' },
		{ code: 'RW', libelle: 'RW' },
		{ code: 'SA', libelle: 'SA' },
		{ code: 'SB', libelle: 'SB' },
		{ code: 'SC', libelle: 'SC' },
		{ code: 'SD', libelle: 'SD' },
		{ code: 'SG', libelle: 'SG' },
		{ code: 'SH', libelle: 'SH' },
		{ code: 'SJ', libelle: 'SJ' },
		{ code: 'SL', libelle: 'SL' },
		{ code: 'SM', libelle: 'SM' },
		{ code: 'SN', libelle: 'SN' },
		{ code: 'SO', libelle: 'SO' },
		{ code: 'SR', libelle: 'SR' },
		{ code: 'SS', libelle: 'SS' },
		{ code: 'ST', libelle: 'ST' },
		{ code: 'SV', libelle: 'SV' },
		{ code: 'SX', libelle: 'SX' },
		{ code: 'SY', libelle: 'SY' },
		{ code: 'SZ', libelle: 'SZ' },
		{ code: 'TC', libelle: 'TC' },
		{ code: 'TD', libelle: 'TD' },
		{ code: 'TF', libelle: 'TF' },
		{ code: 'TG', libelle: 'TG' },
		{ code: 'TH', libelle: 'TH' },
		{ code: 'TJ', libelle: 'TJ' },
		{ code: 'TK', libelle: 'TK' },
		{ code: 'TL', libelle: 'TL' },
		{ code: 'TM', libelle: 'TM' },
		{ code: 'TN', libelle: 'TN' },
		{ code: 'TO', libelle: 'TO' },
		{ code: 'TT', libelle: 'TT' },
		{ code: 'TV', libelle: 'TV' },
		{ code: 'TW', libelle: 'TW' },
		{ code: 'TZ', libelle: 'TZ' },
		{ code: 'UA', libelle: 'UA' },
		{ code: 'UG', libelle: 'UG' },
		{ code: 'UM', libelle: 'UM' },
		{ code: 'US', libelle: 'US' },
		{ code: 'UY', libelle: 'UY' },
		{ code: 'UZ', libelle: 'UZ' },
		{ code: 'VA', libelle: 'VA' },
		{ code: 'VC', libelle: 'VC' },
		{ code: 'VE', libelle: 'VE' },
		{ code: 'VG', libelle: 'VG' },
		{ code: 'VI', libelle: 'VI' },
		{ code: 'VN', libelle: 'VN' },
		{ code: 'VU', libelle: 'VU' },
		{ code: 'WF', libelle: 'WF' },
		{ code: 'WS', libelle: 'WS' },
		{ code: 'YE', libelle: 'YE' },
		{ code: 'ZA', libelle: 'ZA' },
		{ code: 'ZM', libelle: 'ZM' },
		{ code: 'ZW', libelle: 'ZW' }];

	private services = [
		{ code: '1', libelle: 'Services d\'entretien et de réparation' },
		{ code: '2', libelle: 'Services liés à l\'aide militaire fournie aux pays étrangers' },
		{ code: '3', libelle: 'Services de défense, services de défense militaire et services de défense civile' },
		{ code: '4', libelle: 'Services d\'enquête et de sécurité' },
		{ code: '5', libelle: 'Services de transports terrestres' },
		{ code: '6', libelle: 'Services de transports aériens: transports de voyageurs et de marchandises, à l\'exclusion des transports de courrier' },
		{ code: '7', libelle: 'Transports de courrier par transport terrestre et par air' },
		{ code: '8', libelle: 'Services de transports ferroviaires' },
		{ code: '9', libelle: 'Services de transport par eau' },
		{ code: '10', libelle: 'Services annexes et auxiliaires des transports' },
		{ code: '11', libelle: 'Services de télécommunications' },
		{ code: '12', libelle: 'Services financiers: Services d\'assurances' },
		{ code: '13', libelle: 'Services informatiques et services connexes' },
		{ code: '14', libelle: 'Services de recherche et de développement [2] et tests d\'évaluation' },
		{ code: '15', libelle: 'Services comptables, d\'audit et de tenue de livres' },
		{ code: '16', libelle: 'Services de conseil en gestion [3] et services connexes' },
		{ code: '17', libelle: 'Services d\'architecture; services d\'ingénierie et services intégrés d\'ingénierie; services d\'aménagement urbain et d\'architecture paysagère; services connexes de consultations scientifiques et techniques; services d\'essais et d\'analyses techniques' },
		{ code: '18', libelle: 'Services de nettoyage de bâtiments et services de gestion de propriétés' },
		{ code: '19', libelle: 'Services de voirie et d\'enlèvement des ordures: services d\'assainissement et services analogues' },
		{ code: '20', libelle: 'Services de simulation et de formation dans les domaines de la défense et de la sécurité' },
		{ code: '21', libelle: 'Services d\'hôtellerie et de restauration' },
		{ code: '22', libelle: 'Services annexes et auxiliaires des transports' },
		{ code: '23', libelle: 'Services juridiques' },
		{ code: '24', libelle: 'Services de placement et de fourniture de personnel [5]' },
		{ code: '25', libelle: 'Services sociaux et sanitaires' },
		{ code: '26', libelle: 'Autres services' }
	];

	private civilite = [
		{code:'',libelle:'- Sélectionner -'},
		{code:'M',libelle:'M'},
		{code:'MME',libelle:'MME'}
	]

	constructor(private http: HttpService, private translateService: TranslateService) {
	}

  public loadReferences(){
    this.getAllCpv();
    this.getAllNuts();
    this.getAllCountry();
    this.getAllLanguage();
    this.getAllCurrency();
    this.getAllUnitCode();
    this.getBandeauErreurMapping();
    // Initialiser les mots-clés depuis le tableau local
    this.mot_clef.sort((a, b) => +a.code - +b.code);
    this.motClefSubject.next(this.mot_clef);
  }

	public getOptions(type: string): any[] {
		if (type === AutoCompleteType[AutoCompleteType.PAYS]) {
			return this.pays.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.MOT_CLEF]) {
			return this.mot_clef.sort((a, b) => +a.code - +b.code);
		}

		if (type === AutoCompleteType[AutoCompleteType.CLASSSUPPLEMENTAIRE]) {
			return this.classsupplementaire.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.CODENUTS]) {
			return this.codenuts.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.LANGEC]) {
			return this.langEC.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.DEVISE]) {
			return this.devise.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.EDITION]) {
			return this.edition.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.GENRE]) {
			return this.genre.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.CLASSIFICATIONVALUE]) {
			return this.classificationValue.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.CLASSIFICATIONORGANISME]) {
			return this.classificationOrganisme.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.RAPPEL]) {
			return this.rappel.sort((a, b) => this.getSort(a.code, b.code));
		}

		if (type === AutoCompleteType[AutoCompleteType.RUBRIQUE]) {
			return this.rubrique.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.LIEUCODENUTS]) {
			return this.lieucodenuts.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.SERVICES]) {
			return this.services.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.TYPERENS]) {
			return this.typeRens.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}
		if (type === AutoCompleteType[AutoCompleteType.CPV]) {
			return this.cpvSubject.getValue().sort((a, b) => this.getSort(a.libelle, b.libelle));
		}
		if (type === AutoCompleteType[AutoCompleteType.CURRENCY]) {
			return this.currencySubject.getValue().sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.DURATIONUNIT]) {
			return this.durationUnitSubject.getValue().sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.MEASUREMENTUNIT]) {
			return this.measurementUnitSubject.getValue().sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

		if (type === AutoCompleteType[AutoCompleteType.CIVILITE]) {
			return this.civilite.sort((a, b) => this.getSort(a.libelle, b.libelle));
		}

	}
	getSort(a: string, b: string): number {
		for (let i = 0; i < (a.length < b.length ? a.length : b.length); i++)
			if (a.charAt(i) != b.charAt(i)) return a.charCodeAt(i) - b.charCodeAt(i);
		return a.length - b.length;
	}

	public getAllCpv() {
		this.http.get(Endpoints.ALL_CPV).pipe(
			map(data =>
				Object.keys(data).map(index => data[index])
					.sort((a, b) => this.translateService.instant(a.libelle).localeCompare(this.translateService.instant(b.libelle)))
			)
		).subscribe(
			(cpv) => {
				this.cpvSubject.next(cpv);
			},
			error => {
				console.error(error);
			}
		);
	}

	public getAllNuts() {
		this.http.get(Endpoints.ALL_NUTS).pipe(
		  map(data => {
			return Object.keys(data).map(index => data[index]);
		  })
		).subscribe(
		  (nuts) => {
			// Mise à jour du BehaviorSubject
			this.nutsSubject.next(nuts);
		  },
		  error => {
			console.error(error);
		  }
		);
	}

  public getAllLanguage() {
		this.http.get(Endpoints.ALL_LANGUAGE).pipe(
			map(data => {
			  return Object.keys(data).map(index => data[index]);
			})
		  ).subscribe(
			(language) => {
			  // Mise à jour du BehaviorSubject
			  this.languageSubject.next(this.translateAndSort(language));
			},
			error => {
			  console.error(error);
			}
		  );
	}

	public getAllCountry() {
		this.http.get(Endpoints.ALL_COUNTRY).pipe(
		  map(data => {
			return Object.keys(data).map(index => data[index]);
		  })
		).subscribe(
		  (countries) => {
			// Mise à jour du BehaviorSubject
			this.countrySubject.next(this.translateAndSort(countries));
		  },
		  error => {
			console.error(error);
		  }
		);
	}

	public getAllCurrency() {
		this.http.get(Endpoints.ALL_CURRENCY).pipe(
		  map(data => {
			return Object.keys(data).map(index => data[index]);
		  })
		).subscribe(
		  (currency) => {
			// Mise à jour du BehaviorSubject
			this.currencySubject.next(this.translateAndSort(currency));
		  },
		  error => {
			console.error(error);
		  }
		);
	}

	public getAllUnitCode() {
		this.http.get(Endpoints.ALL_UNITCODE).pipe(
			map(data => {
			  return Object.keys(data).map(index => data[index]);
			})
		  ).subscribe(
			(durationUnit) => {
			  // Mise à jour du BehaviorSubject
			  this.durationUnitSubject.next(this.translateAndSort(durationUnit));
			},
			error => {
			  console.error(error);
			}
		  );
	}

	public getBandeauErreurMapping() {
		this.http.get(Endpoints.ALL_BANDEAU_ERREUR_MAPPING).pipe(
			map(data => {
			  return Object.keys(data).map(index => data[index]);
			})
		  ).subscribe(
			(data) => {
			  // Mise à jour du BehaviorSubject
			  this.eformBandeauErreurMappingSubject.next(data);
			},
			error => {
			  console.error(error);
			}
		  );
	}

  public translateAndSort(listToTranslateAndSort) {
    let translatedAndOrderedOptionsWithCode = new Array<any>();
    //On traduit et ordonne les libelles des listes déroulantes avec code
    if (listToTranslateAndSort) {
      listToTranslateAndSort.forEach(opt => {
        opt.libelle = this.translateService.instant(opt.libelle);
        translatedAndOrderedOptionsWithCode.push(opt);
      });
	  translatedAndOrderedOptionsWithCode.sort((a, b) => a.libelle.localeCompare(b.libelle));
    }
    return translatedAndOrderedOptionsWithCode;
  }
}
